/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { toastr } from "react-redux-toastr";
import { Modal } from "react-bootstrap";
import commonLabels from "../../../common/labels/common_en.json";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import applicationStagesLabels from "../labels/applicationstages_en.json";
import TimetableLabels from "../../../timetablemanagement/labels/timetable_en.json";
import { fromUTCDate, toUTCDate, getFormattedDate } from "../../../helpers/Datetime";
import dayjs from "dayjs";
import DataImport from "./DataImport";
import DatePicker from "react-datepicker";
import TablePagination from "../../../common/components/TablePagination";
import TimeTableCsvData from "../../../timetablemanagement/components/TimeTableCsvData";
import ImportDataModal from "./ImportDataModal";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import CDNCKEditor from "../../../common/components/CDNCKEditor";
import Select from "react-select";
import {
  marksheetTemlateDownload,
  manageStageConfig,
  saveStageConfig,
  updateStageConfig,
  getSubjectsListByPostCriteriaId,
  addObjectionDetails,
  manageObjectionStage,
  getExamSubjectForObjection,
  uploadObjectionFile,
  manageObjectionAnswerKeyData,
  downloadObjectionAnswerKeyData,
  getObjectionQuestions,
  getExamSubjectsForObjectionFile,
  addObjectionFile,
  manageObjectionFileStage,
  getObjectionFileImage,
  updateObjectionFile,
  getExamSubjectForObjectionReport,
  getObjectionExamSubjectQuestions,
  getObjectionReportData,
  getObjectionCountReportData,
  getObjectionAttachmentReportApplications,
  getObjectionAttachmentReportsReferenceDocument,
  downloadGetObjectionAttachmentReportsReferenceDocument,
  deleteCenterWiseAdmitCard,
  getSearchAdmitCardListData,
  getProfileInfoDisplay,
  getProfileSummaryDetails,
  admitCard,
  getVenueDetails,
  manageAdmitCardSearchListData,
  getapplicationListing,
  saveSMSdata,
  getApprovedVenueDetailsAPI,
  uploadExamStaffDataAPI,
  examStaffSampleFileDownload,
  getVenueStaffInfo,
  interviewLetterCsvFileDownload,
  getScheduleTypeListAPI, getapplicationListingForInterviewPtLetter, getInterviewPtLetterDropdownValuesAPI,
  uploadInterviewPTLetterCsvAPI, getInterviewReportDetailsAPI, downloadEligibleCandidatesListFileAPI, saveInterviewInstructionsAPI, getInterviewInstructionsListAPI, deleteInterviewInstructionsDetailsById
} from "../actions/applicationStagesAction";
import {
  getTimeTableDetailsByAdvtId,
  deleteTimeTableDetailById,
  deleteExamInstructionsDetailsById,
  getTimeTableDetailsByTemplateId,
  getExamTemplateListForImportAdmitCardCsvAPI,
} from "../../../timetablemanagement/actions/timetableManagementAction";
import "../../styles/time_table_management.css";
import _ from "lodash/fp";
import docLabels from "../../documentsverification/labels/documentlabel.json";
import CommonLoader from "../../../common/components/CommonLoader";
import "jspdf-autotable";
import html2pdf from "html2pdf.js";
import ObjectionReport from "./ObjectionReport";
import ObjectionAnswerKeyDataModal from "./ObjectionAnswerKeyDataModal";
import UpdateTimeTableDetails from "../../../timetablemanagement/components/UpdateTimeTableDetails";
import ConfirmationDialog from "../../../common/components/ConfirmationDialog";
import candidateManagementLabels from "../../../candidatedatamanagement/labels/candidatedatamanagement_en.json";
import AdmitCard from "./AdmitCard";
// import ViewAdmitCard from "./ViewAdmitCard";
import venueLabels from '../../../venuemanagement/labels/venue_en.json';
import SendNotificationModal from '../components/SendNotificationModal';
import DownloadInterviewLetterModal from './DownloadInterviewLetterModal';
import { interviewPtLetterHeaderField, interviewReportDropdownData } from '../../../common/constants/dropdownOptions';
import { getPostNames } from '../../../documentsverification/actions/documentVerificationAction';
import jsPDF from 'jspdf';
import AttendanceMusterReportModal from './AttendanceMusterReportModal';
import Devnagari from "../../masterManagement/components/devnagari";

const StageContent = (props) => {
  const pdfRef = useRef();
  const admitCardpdfRef = useRef();
  const viewAdmitCardpdfRef = useRef();
  const targetRef = useRef(null);
  let rowPerPage = 10;
  let admitCardStageSearchRowPerPage = 10;
  const [allStageConfigList, setAllStageConfigList] = useState([]);
  const MAX_FILE_SIZE = 200 * 1024;

  const matchingCode = "ANSWER_KEY_QUESTION_OBJECTION";
  let foundIndex = -1;
  let mergedObjectionsList = [];

  useEffect(() => {
    if (props && props.allStageConfigData && props.allStageConfigData.length > 0) {
      let parsedData = JSON.parse(props.allStageConfigData);
      if (parsedData && parsedData.advertisementStageDtoList && parsedData.advertisementStageDtoList.length > 0) {
        for (let i = 0; i < parsedData.advertisementStageDtoList.length; i++) {
          if (parsedData.advertisementStageDtoList[i].stage.code === matchingCode) {
            foundIndex = i;
            mergedObjectionsList = parsedData.advertisementStageDtoList[i].masterAdvertisementStageObjectionDto
              ? parsedData.advertisementStageDtoList[i].masterAdvertisementStageObjectionDto
                .advertisementStageObjectionsDtoList
              : [];
            break;
          }
        }

        if (foundIndex !== -1) {
          for (let i = foundIndex + 1; i < parsedData.advertisementStageDtoList.length; i++) {
            if (
              parsedData.advertisementStageDtoList[i].stage.code === matchingCode &&
              parsedData.advertisementStageDtoList[i].masterAdvertisementStageObjectionDto
            ) {
              const objectionsList =
                parsedData.advertisementStageDtoList[i].masterAdvertisementStageObjectionDto
                  .advertisementStageObjectionsDtoList;
              if (objectionsList && objectionsList.length > 0) {
                mergedObjectionsList = [...mergedObjectionsList, ...objectionsList];
                parsedData.advertisementStageDtoList[i].masterAdvertisementStageObjectionDto.advertisementStageObjectionsDtoList = [];
              }
            }
          }

          parsedData.advertisementStageDtoList[foundIndex].masterAdvertisementStageObjectionDto.advertisementStageObjectionsDtoList = mergedObjectionsList;
        }

        if (mergedObjectionsList && mergedObjectionsList.length > 0) {
          setShowObjectionAnswerKeyDataTab(true);
        }
        if (mergedObjectionsList.length === 0) {
          setShowObjectionAnswerKeyDataTab(false);
        }
        setAllStageConfigList(parsedData);
      }
    }
  }, [props && props.allStageConfigData]);

  let advertisementDetails = {};
  if (props.advertisementDetails) {
    advertisementDetails = JSON.parse(props.advertisementDetails);
  }

  let headerField = [
    {
      id: "1",
      steps: "Step 1",
      name: "Configuration",
      code: "configurationTab",
    },
    {
      id: "2",
      steps: "Step 2",
      name: "Content",
      code: "contentTab",
    },
  ];

  let admitCardheaderField = [
    {
      id: "1",
      steps: "Step 1",
      name: "Configuration",
      code: "configurationTab",
    },
    {
      id: "2",
      steps: "Step 2",
      name: "Content",
      code: "contentTab",
    },
    {
      id: "3",
      steps: "Step 3",
      name: "Search List",
      code: "searchListTab",
    },
    {
      id: "4",
      steps: "Step 4",
      name: "Delete List",
      code: "deleteListTab",
    },
    {
      id: "5",
      steps: "Step 5",
      name: "Notification",
      code: "notificationTab",
    }
    ,
    {
      id: "6",
      steps: "Step 6",
      name: "Report",
      code: "ReportTab",
    },
  ];
  let feerecheaderField = [
    {
      id: "1",
      steps: "Step 1",
      name: "Content",
      code: "contentTab",
    },
  ];

  let types = [
    {
      val: "1",
      title: "Type 1",
    },
    {
      val: "2",
      title: "Type 2",
    },
  ];

  let timeTableCsvListHeader = [
    "No.",
    "Advt. Name",
    "Template Name",
    "Exam Display Name",
    "Action",
  ];

  let objectionListHeader = [
    "No.",
    "Post Name",
    "Exam Name",
    "Subject Name",
    "Paper Set",
    "Start Date",
    "End Date",
    "Payment End Date",
    "Question Include",
    "Question Exclude",
    "Action",
  ];

  let objectionCountReportList = [
    {
      val: 0,
      title: "Objection Count With Payment",
    },
    {
      val: 1,
      title: "Objection Count Without Payment",
    },
  ];

  let applicationOption = [
    {
      id: "1",
      name: "Configuration",
    },
    {
      id: "2",
      name: "Content",
    },
    {
      id: "3",
      name: "Search List",
    },
  ];

  const dispatch = useDispatch();
  const {
    register,
    control,
    formState,
    errors,
    handleSubmit,
    setError,
    watch,
    reset,
  } = useForm({
    mode: "onChange",
  });

  let [selectedPostStartDate, setSelectedPostStartDate] = useState("");
  let [selectedPostEndDate, setSelectedPostEndDate] = useState("");
  let [selectedPaymentEndDate, setSelectedPaymentEndDate] = useState("");
  let [selectedType, setSelectedType] = useState("");
  let [isActive, setIsActive] = useState(true);

  const [stepSubName, setSubName] = useState("upload_tab");
  const [stepName, setName] = useState("1");
  let [postCriteriaId, setPostCriteriaId] = useState(null);
  let [subjectId, setSubjectId] = useState(null);
  const [reloadAll, setReloadAll] = useState(0);
  let [isEditStageConfigId, setIsEditStageConfigId] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [quePaperSet, setQuePaperSet] = useState("");
  const [noOfQuestions, setNoOfQuestions] = useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  let [isEditObjectionStageConfigId, setIsEditObjectionStageConfigId] =
    useState("");
  const [objectionExamSubjectId, setObjectionExamSubjectId] = useState("");
  const [objectionStep, setObjectionStep] = useState("objection_configuration");
  const [objectionFile, setObjectionFile] = useState("");
  const [objectionExamId, setObjectionExamId] = useState("");
  const [objectionFilesSubjectId, setObjectionFilesSubjectId] = useState("");
  const [selectObjectionFilesQuestions, setSelectObjectionFilesQuestions] =
    useState("");
  const [objectionFileUploader, setObjectionFileUploader] = useState("");
  let [isEditObjectionFileStage, setIsEditObjectionFileStage] = useState(false);
  let [showObjectionFileImgModal, setShowObjectionFileImgModal] =
    useState(false);
  let [objectionFileId, setObjectionFileId] = useState("");
  let [tempState, setTempState] = useState(false);
  let [isSaveButtonRendered, setIsSaveButtonRendered] = useState(false);
  let [objectionConfigurationId, setObjectionConfigurationId] = useState("");
  let [objectionReportExamId, setObjectionReportExamId] = useState("");
  let [objectionReportExamSubId, setObjectionReportExamSubId] = useState("");
  let [objectionReportExamSubQueNo, setObjectionReportExamSubQueNo] =
    useState("");
  let [showObjectionAnswerKeyDataTab, setShowObjectionAnswerKeyDataTab] =
    useState(false);
  let [objectionContentTab, setObjectionContentTab] =
    useState("objection_report");
  let [showObjectionAnswerKeyModal, setShowObjectionAnswerKeyModal] =
    useState(false);
  let [objectionAnswerKeyModalData, setObjectionAnswerKeyModalData] =
    useState("");
  let [objectionCountReportExamId, setObjectionCountReportExamId] =
    useState("");
  let [objectionCountReportExamSubId, setObjectionCountReportExamSubId] =
    useState("");
  let [objectionReportCountFlg, setObjectionReportCountFlg] = useState("");
  let [objectionAttachmentReportExamId, setObjectionAttachmentReportExamId] =
    useState("");
  let [
    objectionAttachmentReportExamSubId,
    setObjectionAttachmentReportExamSubId,
  ] = useState("");
  let [
    objectionAttachmentReportExamSubQueNo,
    setObjectionAttachmentReportExamSubQueNo,
  ] = useState("");
  let [objectionAttachmentReportAppNo, setObjectionAttachmentReportAppNo] =
    useState("");
  let [
    showAdmitCardStageContentUpdateModal,
    setShowAdmitCardStageContentUpdateModal,
  ] = useState(false);
  let [
    showAdmitCardStageContentDeleteModal,
    setShowAdmitCardStageContentDeleteModal,
  ] = useState(false);
  let [deleteTimeTableDetail, setDeleteTimeTableDetail] = useState(0);
  let [details, setDetails] = useState("");
  let [examTemplate, setExamTemplate] = useState("");
  let [viewAdmitCardModal, setViewAdmitCardModal] = useState(false);
  let [examCenter, setExamCenter] = useState("");
  let [
    showCenterWiseDeleteAdmitCardModal,
    setShowCenterWiseDeleteAdmitCardModal,
  ] = useState(false);
  let [admitCardSearchData, setAdmitCardSearchData] = useState("");
  let [admitCardViewData, setAdmitCardViewData] = useState("");
  const [selectExamTemplate, setSelectExamTemplate] = useState("");
  const [selectedVenue, setSelectedVenue] = useState("");
  const [selectedAdvertisement, setSelectedAdvertisement] = useState();
  const [postCriteriaOptions, setPostCriteriaOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectall, setSelectAll] = useState("");
  const [templateIdForNotification, setTemplateIdForNotification] = useState("");
  const [examDateForNotification, setExamDateForNotification] = useState("");
  const [examCenterIdForNotification, setExamCenterIdForNotification] = useState("");
  const [venueIdForNotification, setVenueIdForNotification] = useState("");
  const [candidateNameForNotification, setCandidateNameForNotification] = useState("");
  const [applicationNoForNotification, setApplicationNoForNotification] = useState("");
  const [mobileNoForNotification, setMobileNoForNotification] = useState("");
  const [sendNotificationToAllModal, setSendNotificationToAllModal] = useState(false);
  const [sendNotificationToAllByTemplateId, setSendNotificationToAllByTemplateId] = useState(false);
  const [templateIdForReport, setTemplateIdForReport] = useState("");
  const [examDateForReport, setExamDateForReport] = useState("");
  const [examCenterIdForReport, setExamCenterIdForReport] = useState("");
  const [venueIdForReport, setVenueIdForReport] = useState("");
  const [file, setFile] = useState("");
  const fileInputRef = useRef(null);
  const [interviewCsvfile, setInterviewCsvfileFile] = useState("");
  const [interviewPtLettertype, setInterviewPtLettertype] = useState("");
  const interviewCsvfileInputRef = useRef(null);
  const [openDonwloadInterviewLetterCsvModal, setOpenDonwloadInterviewLetterCsvModal] = useState(false);
  const [interviewPtLetterPostId, setInterviewPtLetterPostId] = useState("");
  const [reportType, setReportType] = useState("");
  const [interviewPtLetterReportName, setInterviewPtLetterReportName] = useState("");
  const [interviewPtLetterReportPostId, setInterviewPtLetterReportPostId] = useState("");
  const [openAttendanceMusterReportModal, setOpenAttendanceMusterReportModal] = useState(false);
  const [interviewPtLetterInstructionsPostId, setInterviewPtLetterInstructionsPostId] = useState("");
  const [letterType, setLetterType] = useState("");
  const [authority, setAuthority] = useState(commonLabels.INTERVIEW_AUTHORITY);
  const [signature, setSignature] = useState(commonLabels.INTERVIEW_SIGNATURE);
  const [signatureLengthErr, setSignatureLengthErr] = useState(false);
  const [authorityLengthErr, setAuthorityLengthErr] = useState(false);
  const [impInstruction, setImpInstruction] = useState("");
  const [candidateInstruction, setCandidateInstruction] = useState("");
  const [templateIdForAdmitCard, setTemplateIdForAdmitCard] = useState('');
  const [interviewInstructionsId, setInterviewInstructionsId] = useState('');
  const [sendNotificationToAllByinterviewPtLetterType, setSendNotificationToAllByinterviewPtLetterType] = useState(false);
  const [interviewPtLetterTypeForNotification, setInterviewPtLetterTypeForNotification] = useState('')
  const [examCenterIdForInterviewPtLetter, setExamCenterIdForInterviewPtLetter] = useState('');
  const [venueIdForInterviewPtLetter, setVenueIdForInterviewPtLetter] = useState('');
  const [interviewPtLetterNotificationPostId, setInterviewPtLetterNotificationPostId] = useState("");
  const [interviewDateForNotification, setInterviewDateForNotification] = useState("");
  const [candidateNameForInterviewPtLetter, setCandidateNameForInterviewPtLetter] = useState("");
  const [applicationNoForInterviewPtLetter, setApplicationNoForInterviewPtLetter] = useState("");
  const [mobileNoForInterviewPtLetter, setMobileNoForInterviewPtLetter] = useState("");
  const [sendNotificationToAllModalForInterviewPtLetter, setSendNotificationToAllModalForInterviewPtLetter] = useState(false);
  const [sendNotificationToAllViaMobile, setSendNotificationToAllViaMobile] = useState(false);
  const [sendNotificationToAllViaEmail, setSendNotificationToAllViaEmail] = useState(false);
  const [isAllCheckedForSendNotificationToAllViaMobile, setIsAllCheckedForSendNotificationToAllViaMobile] = useState(false);
  const [isAllCheckedForSendNotificationToAllViaEmail, setIsAllCheckedForSendNotificationToAllViaEmail] = useState(false);
  const [applicationListingArrForInterviewPtLetter, setApplicationListingArrForInterviewPtLetter] = useState([])
  const [disableFlg, setDisableFlg] = useState(false)
  const [serialNo, setSerialNo] = useState('');
  const [publicationDate, setpublicationDate] = useState('');
  const objectionAnswerKeyfileInputRef = useRef(null);

  const {
    allSubjectsList,
    allReDownloadApplicationDocList,
    getExamPaperSet,
    getExamPaperQuestionsLimit,
    getExamSubjectsForObjection,
    getObjectionAnsweKeyDataList,
    getExamSubjectsListForObjectionFile,
    getObjectionQuestionsList,
    getAllObjectionFilesList,
    getAllObjectionFilesPageNoCounter,
    objectionFilesUploadedPhoto,
    getSearchAdmitCardListDetails,
    getAdmitCardSearchListPageNoCounter,
    getAllObjectionReportExamsList,
    getAllObjectionReportExamSubjectsList,
    getAllObjectionReportExamSubjectQuestionsList,
    getObjectionReportDetails,
    getObjectionReportCountDetails,
    getObjectionAttachmentReportApplicationsData,
    admitCardData,
    getVenueDetailsList,
    getapplicationList, getInterviewPtLetterDropdownValues,
    getApprovedVenueDetailsList, getApplicationListingArrForInterviewPtLetter,
    getScheduleTypeList, getInterviewReportList, getInterviewInstructionsList
  } = useSelector((state) => state.applicationManagementReducer, shallowEqual);

  const {
    timeTableCsvListPageNoCounter,
    getActiveExamListData,
    getTimeTableDetails,
    getUpdateTimeTableDataByTempId,
    getExamTemplateListForImportAdmitCardCsv,
    getExamCenterList,
  } = useSelector((state) => state.timeTableManagementReducer, shallowEqual);

  const { postNamesData } = useSelector(
    (state) => state.documentVerificationReducer,
    shallowEqual
  );
  let TimeTableCsvListTableCounter = timeTableCsvListPageNoCounter + 1;
  let ObjectionFilesTableCounter = getAllObjectionFilesPageNoCounter + 1;
  let admitCardTableCounter = getAdmitCardSearchListPageNoCounter + 1;

  useEffect(() => {
    props.adverId &&
      props.stageCode === "ANSWER_KEY_QUESTION_OBJECTION" &&
      dispatch(getExamSubjectsForObjectionFile(props.adverId, props.stageId));
    // eslint-disable-next-line
  }, []);

  useEffect(() => { }, [reloadAll]);
  useEffect(() => { }, [selectedPostStartDate]);
  useEffect(() => { }, [selectedPostEndDate]);
  useEffect(() => { }, [selectedPaymentEndDate]);
  useEffect(() => { }, [selectedType]);
  useEffect(() => { }, [isActive]);

  useEffect(() => { }, [postCriteriaId]);
  useEffect(() => { }, [subjectId]);
  useEffect(() => { }, [isEditStageConfigId]);
  useEffect(() => { }, [stepName]);
  useEffect(() => { }, [allStageConfigList]);
  useEffect(() => { }, [isEditObjectionStageConfigId]);

  useEffect(() => {
    if (
      objectionFilesUploadedPhoto &&
      (objectionFilesUploadedPhoto.objectionQuestionFile === null ||
        objectionFilesUploadedPhoto.objectionQuestionFile === "" ||
        objectionFilesUploadedPhoto.objectionQuestionFile === undefined) &&
      isEditObjectionFileStage
    ) {
      setTempState(true);
    } else {
      setTempState(false);
    }
  }, [objectionFilesUploadedPhoto, isEditObjectionFileStage]);

  useEffect(() => {
    if (
      getApplicationListingArrForInterviewPtLetter && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList.length > 0
    ) {
      let arr = getApplicationListingArrForInterviewPtLetter && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList;
      const updatedArr = arr.map(item => ({
        ...item,
        isMobileNoCheckedFlg: false,
        isEmailCheckedFlg: false
      }));
      setApplicationListingArrForInterviewPtLetter(updatedArr);
    }
  }, [getApplicationListingArrForInterviewPtLetter]);

  useEffect(() => {
    const hasChecked = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length > 0 && applicationListingArrForInterviewPtLetter.some(item => item.isMobileNoCheckedFlg === true || item.isEmailCheckedFlg === true);
    setDisableFlg(hasChecked);
  }, [applicationListingArrForInterviewPtLetter]);


  const reloadAllData = () => {
    setReloadAll((prevState) => prevState + 1);
  };

  const onchangePostStartDate = (e) => {
    setSelectedPostStartDate(e);
  };

  const onchangePostEndDate = (e) => {
    setSelectedPostEndDate(e);
  };

  const onEditStageConfig = (ele) => {
    dispatch(
      getSubjectsListByPostCriteriaId(ele.postCriteriaId, props.adverId)
    );
    setIsEditStageConfigId(ele.id);
    setPostCriteriaId(ele.postCriteriaId);
    setSubjectId(ele.examSubjectId);
    setSelectedPostStartDate(
      ele.startDate ? dayjs(ele.startDate).toDate() : ""
    );
    setSelectedPostEndDate(ele.endDate ? dayjs(ele.endDate).toDate() : "");
    setSelectedPaymentEndDate(
      ele.onlinePaymentEndDate ? dayjs(ele.onlinePaymentEndDate).toDate() : ""
    );
    setSelectedType(ele.type);
    setIsActive(ele.isActive);
    setExamTemplate(ele.templateId);
    reloadAllData();
  };

  const activeStageConfig = (ele, currentStatus) => {
    let requestBody = {
      advertisementStageDto: {
        id: ele.id,
        isActive: !currentStatus,
      },
    };
    dispatch(manageStageConfig(props.adverId, requestBody));
  };

  const manageStageConfigData = (ele) => {
    let requestBody = {
      advertisementStageDto: {
        id: ele.id,
        isDeleted: true,
      },
    };
    dispatch(manageStageConfig(props.adverId, requestBody));
  };

  const onchangePaymentEndDate = (e) => {
    setSelectedPaymentEndDate(e);
  };

  const onchangeType = (e) => {
    setSelectedType(e.target.value);
  };

  const onChangePostCriteria = (event) => {
    setPostCriteriaId(event.target.value);
    dispatch(getSubjectsListByPostCriteriaId(event.target.value));
  };

  const [showImportDocList, setImportDocumentList] = useState(false);

  const [csvHeader, setCsvHeader] = useState([]);
  const downloadTemplate = () => {
    dispatch(marksheetTemlateDownload());
  };

  const downloadDocumentTemplate = () => {
    if (
      allReDownloadApplicationDocList &&
      allReDownloadApplicationDocList.reuploadDocumentStatusDtoList &&
      allReDownloadApplicationDocList.reuploadDocumentStatusDtoList.length > 0
    ) {
      const alldata =
        allReDownloadApplicationDocList.reuploadDocumentStatusDtoList.map(
          (row) => ({
            data: row,
          })
        );

      const csvData = jsonToCsv(alldata);

      csvHeader.length == 0 && downloadFile(csvData);
    }
  };
  const jsonToCsv = (alldata) => {
    const csvRows = [];
    const headers = Object.keys(alldata[0].data);
    let newHeader = [];
    headers.length > 0 &&
      headers.map((item) => {
        if (
          item == "applicationId" ||
          item == "uploadedDocumentList" ||
          item == "remainingDocumentList"
        ) {
          newHeader.push(item);
        }
      });

    setCsvHeader(newHeader);
    csvRows.push(newHeader.join(","));
    for (let i = 0; i < alldata.length; i++) {
      for (const row of Object.values(alldata[i])) {
        const values = newHeader.map((header) => {
          let escaped = "";
          if (Array.isArray(row[header])) {
            let names = "";
            let allNames = false;
            let itemNames = "";
            if (row[header].length > 0) {
              row[header].length > 0 &&
                row[header].map((item, ind) => {
                  if (ind == 0) {
                    itemNames = item.name;
                  } else {
                    itemNames = itemNames + " & " + item.name;
                  }

                  if (ind == row[header].length - 1) {
                    allNames = true;
                    return itemNames;
                  }
                });
            } else {
              escaped = ("" + itemNames).replace(/"/g, '\\"');
            }

            if (allNames) {
              escaped = ("" + itemNames).replace(/"/g, '\\"');
            }
          } else {
            escaped = ("" + row[header]).replace(/"/g, '\\"');
          }

          return `"${escaped}"`;
        });
        csvRows.push(values.join(","));
      }
    }
    return csvRows.join("\n");
  };

  const downloadFile = (error) => {
    const a = document.createElement("a");
    a.setAttribute(
      "href",
      "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(error)
    );

    a.setAttribute("hidden", "");

    a.setAttribute("download", "applicationListdownload.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  const handledUploadList = () => {
    setImportDocumentList(true);
  };
  const handledUploadDocumentList = () => {
    setImportDocumentList(true);
  };

  const saveStageConfigData = (stgId, stageData) => {
    if (
      props.adverId != null &&
      props.adverId != "" &&
      props.adverId != undefined &&
      stgId != null &&
      stgId != "" &&
      stgId != undefined &&
      selectedPostStartDate != null &&
      selectedPostStartDate != "" &&
      selectedPostStartDate != undefined &&
      selectedPostEndDate != null &&
      selectedPostEndDate != "" &&
      selectedPostEndDate != undefined
    ) {
      let combinationVar = "";

      let isAlreadyNotExist = false;
      let isAlreadyExist = true;
      let existingEntry = [];

      if (stgId == 9) {
        combinationVar =
          props.adverId +
          "_" +
          stgId +
          "_" +
          postCriteriaId +
          "_" +
          subjectId +
          "_" +
          selectedType;

        allStageConfigList &&
          allStageConfigList.advertisementStageDtoList &&
          allStageConfigList.advertisementStageDtoList.length > 0 &&
          allStageConfigList.advertisementStageDtoList.map((item, index) => {
            existingEntry.push(
              item.advertisementId +
              "_" +
              item.stage.id +
              "_" +
              item.postCriteriaId +
              "_" +
              item.examSubjectId +
              "_" +
              item.type
            );
            if (item.stage.id == stgId) {
              if (
                (item.postCriteriaId == null ||
                  item.postCriteriaId == "" ||
                  item.postCriteriaId == undefined) &&
                (item.examSubjectId == null ||
                  item.examSubjectId == "" ||
                  item.examSubjectId == undefined) &&
                (item.type == null || item.type == "" || item.type == undefined)
              ) {
                isAlreadyExist = false;
              }
            }
          });
      } else {
        combinationVar =
          props.adverId + "_" + stgId + "_" + postCriteriaId + "_" + subjectId;
        allStageConfigList &&
          allStageConfigList.advertisementStageDtoList &&
          allStageConfigList.advertisementStageDtoList.length > 0 &&
          allStageConfigList.advertisementStageDtoList.map((item, index) => {
            existingEntry.push(
              item.advertisementId +
              "_" +
              item.stage.id +
              "_" +
              item.postCriteriaId +
              "_" +
              item.examSubjectId
            );
            if (item.stage.id == stgId) {
              if (
                (item.postCriteriaId == null ||
                  item.postCriteriaId == "" ||
                  item.postCriteriaId == undefined) &&
                (item.examSubjectId == null ||
                  item.examSubjectId == "" ||
                  item.examSubjectId == undefined)
              ) {
                isAlreadyExist = false;
              }
            }
          });
      }

      if (isAlreadyExist) {
        if (existingEntry.indexOf(combinationVar) == -1) {
          isAlreadyNotExist = true;
        }
      } else if (stgId === 5) {
        isAlreadyNotExist = true;
      }

      if (isAlreadyNotExist == true || isEditStageConfigId != "") {
        let requestBody = {
          advertisementStageDto: {
            templateId: parseInt(examTemplate),
            advertisementId: props.adverId,
            postCriteriaId: postCriteriaId,
            stage: JSON.parse(stageData),
            examSubjectId: subjectId,
            startDate: selectedPostStartDate,
            endDate: selectedPostEndDate,
            onlinePaymentEndDate: selectedPaymentEndDate,
            type: selectedType,
            isActive: isActive,
            isDeleted: false,
          },
        };
        if (isEditStageConfigId != "") {
          requestBody.advertisementStageDto.id = isEditStageConfigId;
          dispatch(
            updateStageConfig(props.adverId, requestBody, resetFormFields)
          );
        } else {
          dispatch(
            saveStageConfig(props.adverId, requestBody, resetFormFields)
          );
        }
        resetFormFields();
        setExamTemplate("");
        setIsActive(true);
      } else {
        toastr.error(applicationStagesLabels.ALREADY_EXIT_TOASTR_MES);
      }
    } else {
      toastr.error(applicationStagesLabels.MANDATORY_FIELD_TOASTR_MES);
    }
  };

  const resetFormFields = () => {
    setIsEditStageConfigId("");
    setPostCriteriaId("");
    setSubjectId("");
    setSelectedPostStartDate("");
    setSelectedPostEndDate("");
    setSelectedPaymentEndDate("");
    setSelectedType("");
    setIsActive(false);
    setSelectedCheckboxes([]);
    setNoOfQuestions("");
    setQuePaperSet("");
    setSelectedExam("");
    setIsEditObjectionStageConfigId("");
    reloadAllData();
  };

  const handleExamChange = (e) => {
    let examid = e.target.value;
    setSelectedExam(examid);
  };

  const handleCheckboxChange = (index) => {
    setSelectedCheckboxes((prevSelectedCheckboxes) => {
      if (prevSelectedCheckboxes.includes(index)) {
        return prevSelectedCheckboxes.filter(
          (checkboxIndex) => checkboxIndex !== index
        );
      } else {
        return [...prevSelectedCheckboxes, index];
      }
    });
  };

  const handleGetPostName = (postId) => {
    let PostName =
      advertisementDetails &&
      advertisementDetails.examPostList &&
      advertisementDetails.examPostList.length > 0 &&
      advertisementDetails.examPostList.find((e) => {
        if (e.postCriteria.id == postId) {
          return e.postCriteria.name;
        }
      });
    return PostName.postCriteria.name;
  };

  const handleExamName = (exmaId) => {
    let ExamName =
      getActiveExamListData &&
      getActiveExamListData.length > 0 &&
      getActiveExamListData.find((e) => {
        if (e.id == exmaId) {
          return e.name;
        }
      });
    return ExamName.name;
  };

  const handleSubjectName = (subId) => {
    let SubjectName =
      allSubjectsList &&
      allSubjectsList.examSubjects &&
      allSubjectsList.examSubjects.length > 0 &&
      allSubjectsList.examSubjects.find((e) => {
        if (e.id == subId) {
          return e.name;
        }
      });
    return SubjectName.name;
  };

  const handleExamPaperSetLabel = (paperSetId) => {
    let ExamPaperSetLabel =
      getExamPaperSet && getExamPaperSet.lookupOptionDtoList &&
      getExamPaperSet.lookupOptionDtoList.length > 0 &&
      getExamPaperSet.lookupOptionDtoList.find((e) => {
        if (e.id == paperSetId) {
          return e.label;
        }
      });
    return ExamPaperSetLabel.label;
  };

  const handleAddMoreDetails = (stgId, stageData) => {
    if (
      props.adverId != null &&
      props.adverId != "" &&
      props.adverId != undefined &&
      stgId != null &&
      stgId != "" &&
      stgId != undefined &&
      selectedPostStartDate != null &&
      selectedPostStartDate != "" &&
      selectedPostStartDate != undefined &&
      selectedPostEndDate != null &&
      selectedPostEndDate != "" &&
      selectedPostEndDate != undefined &&
      selectedPaymentEndDate != null &&
      selectedPaymentEndDate != "" &&
      selectedPaymentEndDate != undefined &&
      selectedExam != null &&
      selectedExam != "" &&
      selectedExam != undefined &&
      postCriteriaId != null &&
      postCriteriaId != "" &&
      postCriteriaId != undefined &&
      subjectId != null &&
      subjectId != "" &&
      subjectId != undefined &&
      quePaperSet != null &&
      quePaperSet != "" &&
      quePaperSet != undefined &&
      noOfQuestions != null &&
      noOfQuestions != "" &&
      noOfQuestions != undefined
    ) {
      if (isEditObjectionStageConfigId !== "") {
        if (
          allStageConfigList &&
          allStageConfigList.advertisementStageDtoList &&
          allStageConfigList.advertisementStageDtoList.length > 0 &&
          allStageConfigList.advertisementStageDtoList.filter(
            (item) => item.stage.id == props.stageId
          )
        ) {
          allStageConfigList &&
            allStageConfigList.advertisementStageDtoList &&
            allStageConfigList.advertisementStageDtoList.length > 0 &&
            allStageConfigList.advertisementStageDtoList
              .filter((item) => item.stage.id == props.stageId)
              .map((item) => {
                if (
                  item.masterAdvertisementStageObjectionDto &&
                  item.masterAdvertisementStageObjectionDto
                    .advertisementStageObjectionsDtoList &&
                  item.masterAdvertisementStageObjectionDto
                    .advertisementStageObjectionsDtoList.length > 0
                ) {
                  let originalArray =
                    item.masterAdvertisementStageObjectionDto
                      .advertisementStageObjectionsDtoList;
                  if (originalArray[isEditObjectionStageConfigId].id) {
                    const unSelectedCheckbox = [];
                    for (let i = 1; i <= noOfQuestions; i++) {
                      if (!selectedCheckboxes.includes(i)) {
                        unSelectedCheckbox.push(i);
                      }
                    }
                    let requestBody = {
                      advertisementStageObjectionsDtoList: [
                        {
                          advertisementStage: {
                            id: originalArray[isEditObjectionStageConfigId].id,
                            advertisementId: props.adverId,
                            postCriteriaId: postCriteriaId,
                            stage: JSON.parse(stageData),
                            examSubjectId: subjectId,
                            startDate: selectedPostStartDate,
                            endDate: selectedPostEndDate,
                            onlinePaymentEndDate: selectedPaymentEndDate,
                            type: selectedType,
                            isActive: isActive,
                            isDeleted: false,
                          },
                          id: objectionConfigurationId,
                          examId: selectedExam,
                          examPaperSet: quePaperSet,
                          objectionQuestions:
                            JSON.stringify(selectedCheckboxes),
                          objectionQuestionsCount: noOfQuestions,
                          objectionExcludeQuestions:
                            JSON.stringify(unSelectedCheckbox),
                        },
                      ],
                    };
                    dispatch(
                      addObjectionDetails(
                        props.adverId,
                        requestBody,
                        resetFormFields,
                        "Edit"
                      )
                    );
                  } else {
                    const unSelectedCheckbox = [];
                    for (let i = 1; i <= noOfQuestions; i++) {
                      if (!selectedCheckboxes.includes(i)) {
                        unSelectedCheckbox.push(i);
                      }
                    }
                    originalArray[isEditObjectionStageConfigId] = {
                      ...originalArray[isEditObjectionStageConfigId],
                      examId: parseInt(selectedExam),
                      examName: handleExamName(selectedExam),
                      examPaperSet: parseInt(quePaperSet),
                      examPaperSetName: handleExamPaperSetLabel(quePaperSet),
                      examPostName: handleGetPostName(postCriteriaId),
                      examSubjectName: handleSubjectName(subjectId),
                      isActive: isActive,
                      isDeleted: false,
                      objectionQuestions: JSON.stringify(selectedCheckboxes),
                      objectionQuestionsCount: noOfQuestions,
                      objectionExcludeQuestions:
                        JSON.stringify(unSelectedCheckbox),
                      advertisementStage: {
                        ...originalArray[isEditObjectionStageConfigId]
                          .advertisementStage,
                        examSubjectId: parseInt(subjectId),
                        onlinePaymentEndDate: selectedPaymentEndDate,
                        postCriteriaId: parseInt(postCriteriaId),
                        startDate: selectedPostStartDate,
                        endDate: selectedPostEndDate,
                      },
                    };
                  }
                  setPostCriteriaId("");
                  setSubjectId("");
                  setSelectedPostStartDate("");
                  setSelectedPostEndDate("");
                  setSelectedPaymentEndDate("");
                  setSelectedType("");
                  setIsActive(true);
                  setSelectedCheckboxes([]);
                  setNoOfQuestions("");
                  setQuePaperSet("");
                  setSelectedExam("");
                  setIsEditObjectionStageConfigId("");
                }
              });
        }
      } else {
        if (
          allStageConfigList &&
          allStageConfigList.advertisementStageDtoList &&
          allStageConfigList.advertisementStageDtoList.length > 0
        ) {
          const filteredList =
            allStageConfigList.advertisementStageDtoList.filter(
              (item) => item.stage.id === props.stageId
            );
          if (filteredList.length > 0) {
            const item = filteredList[0];

            if (
              item.masterAdvertisementStageObjectionDto &&
              item.masterAdvertisementStageObjectionDto
                .advertisementStageObjectionsDtoList
            ) {
              const newObjection = {};
              newObjection.advertisementStage = {};
              newObjection.advertisementStage.stage = JSON.parse(stageData);

              newObjection.examPostName = handleGetPostName(postCriteriaId);
              newObjection.advertisementStage.postCriteriaId =
                parseInt(postCriteriaId);

              newObjection.examId = parseInt(selectedExam);
              newObjection.examName = handleExamName(selectedExam);

              newObjection.examSubjectName = handleSubjectName(subjectId);
              newObjection.advertisementStage.examSubjectId =
                parseInt(subjectId);

              newObjection.advertisementStage.startDate = selectedPostStartDate;
              newObjection.advertisementStage.endDate = selectedPostEndDate;
              newObjection.advertisementStage.onlinePaymentEndDate =
                selectedPaymentEndDate;
              newObjection.objectionQuestions =
                JSON.stringify(selectedCheckboxes);
              newObjection.objectionQuestionsCount = noOfQuestions;

              const unSelectedCheckbox = [];
              for (let i = 1; i <= noOfQuestions; i++) {
                if (!selectedCheckboxes.includes(i)) {
                  unSelectedCheckbox.push(i);
                }
              }
              newObjection.objectionExcludeQuestions =
                JSON.stringify(unSelectedCheckbox);
              newObjection.isActive = isActive;
              newObjection.examPaperSetName =
                handleExamPaperSetLabel(quePaperSet);
              newObjection.examPaperSet = parseInt(quePaperSet);

              item.masterAdvertisementStageObjectionDto.advertisementStageObjectionsDtoList.push(
                newObjection
              );
            }
            setAllStageConfigList((prevStageConfigList) => {
              const updatedStageConfigList = { ...prevStageConfigList };
              return updatedStageConfigList;
            });
          } else {
            const unSelectedCheckbox = [];
            for (let i = 1; i <= noOfQuestions; i++) {
              if (!selectedCheckboxes.includes(i)) {
                unSelectedCheckbox.push(i);
              }
            }
            let advertisementStageDto = {
              advertisementId: parseInt(props.adverId),
              postCriteriaId: parseInt(postCriteriaId),
              stage: JSON.parse(stageData),
              examSubjectId: parseInt(subjectId),
              startDate: selectedPostStartDate,
              endDate: selectedPostEndDate,
              onlinePaymentEndDate: selectedPaymentEndDate,
              type: selectedType,
              isActive: isActive,
              isDeleted: false,
              examPostName: handleGetPostName(postCriteriaId),
              examSubjectName: handleSubjectName(subjectId),
              masterAdvertisementStageObjectionDto: {
                advertisementStageObjectionsDtoList: [
                  {
                    advertisementStage: {
                      advertisementId: parseInt(props.adverId),
                      stage: JSON.parse(stageData),
                      startDate: selectedPostStartDate,
                      endDate: selectedPostEndDate,
                      onlinePaymentEndDate: selectedPaymentEndDate,
                      postCriteriaId: parseInt(postCriteriaId),
                      examSubjectId: parseInt(subjectId),
                      isActive: isActive,
                      isDeleted: false,
                    },
                    examPostName: handleGetPostName(postCriteriaId),
                    examSubjectName: handleSubjectName(subjectId),
                    examId: parseInt(selectedExam),
                    examName: handleExamName(selectedExam),
                    examPaperSet: parseInt(quePaperSet),
                    examPaperSetName: handleExamPaperSetLabel(quePaperSet),
                    objectionQuestions: JSON.stringify(selectedCheckboxes),
                    objectionQuestionsCount: noOfQuestions,
                    objectionExcludeQuestions:
                      JSON.stringify(unSelectedCheckbox),
                    isActive: isActive,
                    isDeleted: false,
                  },
                ],
              },
            };
            const updatedArray = [
              ...allStageConfigList.advertisementStageDtoList,
              advertisementStageDto,
            ];
            setAllStageConfigList((prevState) => ({
              ...prevState,
              advertisementStageDtoList: updatedArray,
            }));
          }
          setPostCriteriaId("");
          setSubjectId("");
          setSelectedPostStartDate("");
          setSelectedPostEndDate("");
          setSelectedPaymentEndDate("");
          setSelectedType("");
          setIsActive(true);
          setSelectedCheckboxes([]);
          setNoOfQuestions("");
          setQuePaperSet("");
          setSelectedExam("");
          setIsEditObjectionStageConfigId("");
        }
      }
    } else {
      toastr.error(applicationStagesLabels.MANDATORY_FIELD_TOASTR_MES);
    }
    setIsSaveButtonRendered(false);
    setIsActive(true);
  };

  const handleSaveObjectionData = () => {
    if (
      allStageConfigList &&
      allStageConfigList.advertisementStageDtoList &&
      allStageConfigList.advertisementStageDtoList.length > 0
    ) {
      const item = allStageConfigList.advertisementStageDtoList.find(
        (item) => item.stage.id == props.stageId
      );

      if (
        item &&
        item.masterAdvertisementStageObjectionDto &&
        item.masterAdvertisementStageObjectionDto
          .advertisementStageObjectionsDtoList &&
        item.masterAdvertisementStageObjectionDto
          .advertisementStageObjectionsDtoList.length > 0
      ) {
        let originalArray =
          item.masterAdvertisementStageObjectionDto
            .advertisementStageObjectionsDtoList;

        const advertisementStageObjectionsDtoList = originalArray.map((obj) => {
          const advertisementStageObjectionsDto = {
            advertisementStage: {
              advertisementId: props.adverId,
              postCriteriaId: obj.advertisementStage?.postCriteriaId || null,
              stage: obj.advertisementStage?.stage || null,
              examSubjectId: obj.advertisementStage?.examSubjectId || null,
              startDate: obj.advertisementStage?.startDate || null,
              endDate: obj.advertisementStage?.endDate || null,
              onlinePaymentEndDate:
                obj.advertisementStage?.onlinePaymentEndDate || null,
              type: obj.advertisementStage?.type || null,
              isActive: obj.isActive || null,
              isDeleted: false,
            },
            examId: obj.examId || null,
            examPaperSet: obj.examPaperSet || null,
            objectionQuestions: obj.objectionQuestions || null,
            objectionQuestionsCount: obj.objectionQuestionsCount || null,
          };
          return advertisementStageObjectionsDto;
        });

        const requestBody = { advertisementStageObjectionsDtoList };
        dispatch(
          addObjectionDetails(
            props.adverId,
            requestBody,
            resetFormFields,
            "Add"
          )
        );
      }
    }
    setIsActive(true);
  };

  const onEditObjectionStageConfig = (ele, index) => {
    setObjectionConfigurationId(ele.id);
    dispatch(
      getSubjectsListByPostCriteriaId(
        ele.advertisementStage.postCriteriaId,
        props.adverId
      )
    );
    setIsEditObjectionStageConfigId(index);
    setPostCriteriaId(ele.advertisementStage.postCriteriaId);
    setSelectedExam(ele.examId);
    setSubjectId(ele.advertisementStage.examSubjectId);
    setSelectedPostStartDate(
      ele.advertisementStage.startDate
        ? dayjs(ele.advertisementStage.startDate).toDate()
        : ""
    );
    setSelectedPostEndDate(
      ele.advertisementStage.endDate
        ? dayjs(ele.advertisementStage.endDate).toDate()
        : ""
    );
    setSelectedPaymentEndDate(
      ele.advertisementStage.onlinePaymentEndDate
        ? dayjs(ele.advertisementStage.onlinePaymentEndDate).toDate()
        : ""
    );
    setQuePaperSet(ele.examPaperSet);
    setNoOfQuestions(ele.objectionQuestionsCount);
    setSelectedCheckboxes(JSON.parse(ele.objectionQuestions));
    setIsActive(ele.isActive);

    // reloadAllData();
  };

  const activeObjectionStageConfig = (ele, currentStatus, index) => {
    if (
      allStageConfigList &&
      allStageConfigList.advertisementStageDtoList &&
      allStageConfigList.advertisementStageDtoList.length > 0 &&
      allStageConfigList.advertisementStageDtoList.filter(
        (item) => item.stage.id == props.stageId
      )
    ) {
      allStageConfigList &&
        allStageConfigList.advertisementStageDtoList &&
        allStageConfigList.advertisementStageDtoList.length > 0 &&
        allStageConfigList.advertisementStageDtoList
          .filter((item) => item.stage.id == props.stageId)
          .map((item) => {
            if (
              item.masterAdvertisementStageObjectionDto &&
              item.masterAdvertisementStageObjectionDto
                .advertisementStageObjectionsDtoList &&
              item.masterAdvertisementStageObjectionDto
                .advertisementStageObjectionsDtoList.length > 0
            ) {
              let originalArray =
                item.masterAdvertisementStageObjectionDto
                  .advertisementStageObjectionsDtoList;
              if (originalArray[index].id) {
                let requestBody = {
                  advertisementStageObjectionsDto: {
                    id: originalArray[index].id,
                    isActive: !currentStatus,
                  },
                };
                dispatch(
                  manageObjectionStage(
                    props.adverId,
                    requestBody,
                    resetFormFields
                  )
                );
              } else {
                originalArray[index] = {
                  ...originalArray[index],
                  isActive: !currentStatus,
                  advertisementStage: {
                    ...originalArray[index].advertisementStage,
                  },
                };
              }
              setPostCriteriaId("");
              setSubjectId("");
              setSelectedPostStartDate("");
              setSelectedPostEndDate("");
              setSelectedPaymentEndDate("");
              setSelectedType("");
              setIsActive(true);
              setSelectedCheckboxes([]);
              setNoOfQuestions("");
              setQuePaperSet("");
              setSelectedExam("");
              setIsEditObjectionStageConfigId("");
            }
          });
    }
  };

  const manageObjectionStageConfigData = (ele, index) => {
    if (
      allStageConfigList &&
      allStageConfigList.advertisementStageDtoList &&
      allStageConfigList.advertisementStageDtoList.length > 0 &&
      allStageConfigList.advertisementStageDtoList.filter(
        (item) => item.stage.id == props.stageId
      )
    ) {
      allStageConfigList &&
        allStageConfigList.advertisementStageDtoList &&
        allStageConfigList.advertisementStageDtoList.length > 0 &&
        allStageConfigList.advertisementStageDtoList
          .filter((item) => item.stage.id == props.stageId)
          .map((item) => {
            if (
              item.masterAdvertisementStageObjectionDto &&
              item.masterAdvertisementStageObjectionDto
                .advertisementStageObjectionsDtoList &&
              item.masterAdvertisementStageObjectionDto
                .advertisementStageObjectionsDtoList.length > 0
            ) {
              let originalArray =
                item.masterAdvertisementStageObjectionDto
                  .advertisementStageObjectionsDtoList;
              if (originalArray[index].id) {
                let requestBody = {
                  advertisementStageObjectionsDto: {
                    id: originalArray[index].id,
                    isDeleted: true,
                  },
                };
                dispatch(
                  manageObjectionStage(
                    props.adverId,
                    requestBody,
                    resetFormFields
                  )
                );
              } else {
                originalArray.splice(index, 1);
                toastr.success(
                  applicationStagesLabels.DELETED_RECORD_TOASTR_MES
                );
              }
              setPostCriteriaId("");
              setSubjectId("");
              setSelectedPostStartDate("");
              setSelectedPostEndDate("");
              setSelectedPaymentEndDate("");
              setSelectedType("");
              setIsActive(true);
              setSelectedCheckboxes([]);
              setNoOfQuestions("");
              setQuePaperSet("");
              setSelectedExam("");
              setIsEditObjectionStageConfigId("");
            }
          });
    }
  };

  const onObjectionFileChange = (event) => {
    let data = event.target.files[0];

    if (event.target.files.length == 0) {
      return;
    }

    if (data.type === "application/vnd.ms-excel") {
      setObjectionFile(event.target.files[0]);
    } else {
      setError("file", { type: "required" });
    }
  };

  const handleInputClick = () => {
    setObjectionFile("");
  };

  const uploadFile = () => {
    if (
      formState.isValid &&
      objectionFile.type === "application/vnd.ms-excel"
    ) {
      let requestBody = {
        advtId: props.adverId,
        file: objectionFile,
        examId: objectionExamId,
        examSubjectId: objectionExamSubjectId,
      };
      dispatch(uploadObjectionFile(requestBody));
      setObjectionFile("");
      setObjectionExamId("");
      setObjectionExamSubjectId("");
      getExamSubjectsForObjection.length = 0;
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = "";
      }
      if (objectionAnswerKeyfileInputRef.current) {
        objectionAnswerKeyfileInputRef.current.value = "";
      }
    } else if (
      formState.isValid &&
      objectionFile.type !== "application/vnd.ms-excel"
    ) {
      setError("file", { type: "required" });
    }
  };

  const handleObjectionExamChange = (e) => {
    let examid = e.target.value;
    setObjectionExamId(examid);
    dispatch(getExamSubjectForObjection(examid));
  };

  const handleDeleteClick = (ele) => {
    dispatch(manageObjectionAnswerKeyData(props.adverId, ele.examSubjectId));
  };

  const handleDownloadClick = (ele) => {
    dispatch(
      downloadObjectionAnswerKeyData(
        props.adverId,
        ele.examSubjectId,
        ele.examId,
        ele.examName,
        ele.examSubjectName
      )
    );
  };

  const handleObjectionFileExamChange = (event, stageid) => {
    let exsubid = event.target.value;
    setObjectionFilesSubjectId(exsubid);
    if (exsubid !== "") {
      dispatch(getObjectionQuestions(props.adverId, stageid, exsubid));
    }
    setSelectObjectionFilesQuestions("");
    getObjectionQuestionsList.length = 0;
  };

  const handleSubjectCode = (subId) => {
    let SubjectCode =
      getExamSubjectsListForObjectionFile &&
      getExamSubjectsListForObjectionFile.length > 0 &&
      getExamSubjectsListForObjectionFile.find((e) => {
        if (e.id == subId) {
          return e.code;
        }
      });
    return SubjectCode.code;
  };

  const handleFileInputClick = () => {
    setObjectionFileUploader("");
  };

  const onFileChange = (event) => {
    let data = event.target.files[0];

    if (data) {
      if (data.size > MAX_FILE_SIZE) {
        toastr.error(applicationStagesLabels.FILE_SIZE_500_KB);
        event.target.value = null;
        return;
      }

      if (!data.type.startsWith("image/")) {
        toastr.error(applicationStagesLabels.FILE_TYPE_IMAGE);
        event.target.value = null;
        return;
      } else {
        setObjectionFileUploader(data);
      }
    }
  };

  const addObjectionFileData = () => {
    if (!isEditObjectionFileStage) {
      if (
        props.adverId != null &&
        props.adverId != "" &&
        props.adverId != undefined &&
        objectionFilesSubjectId != null &&
        objectionFilesSubjectId != "" &&
        objectionFilesSubjectId != undefined &&
        selectObjectionFilesQuestions != null &&
        selectObjectionFilesQuestions != "" &&
        selectObjectionFilesQuestions != undefined &&
        objectionFileUploader != null &&
        objectionFileUploader != "" &&
        objectionFileUploader != undefined
      ) {
        let examSubjectCode = handleSubjectCode(objectionFilesSubjectId);
        dispatch(
          addObjectionFile(
            props.adverId,
            examSubjectCode,
            selectObjectionFilesQuestions,
            objectionFileUploader,
            objectionFilesSubjectId
          )
        );
        setObjectionFileUploader("");
        setSelectObjectionFilesQuestions("");
        setObjectionFilesSubjectId("");
        getObjectionQuestionsList.length = 0;
        const fileInput = document.querySelector(
          'input[name="objectionFileUploader"]'
        );
        if (fileInput) {
          fileInput.value = "";
        }
      } else {
        toastr.error(applicationStagesLabels.MANDATORY_FIELD_TOASTR_MES);
      }
    } else {
      if (
        objectionFileUploader != null &&
        objectionFileUploader != "" &&
        objectionFileUploader != undefined
      ) {
        let examSubjectCode = handleSubjectCode(objectionFilesSubjectId);
        dispatch(
          updateObjectionFile(
            objectionFileId,
            props.adverId,
            examSubjectCode,
            selectObjectionFilesQuestions,
            objectionFileUploader,
            objectionFilesSubjectId
          )
        );
        setObjectionFileUploader("");
        setSelectObjectionFilesQuestions("");
        setObjectionFilesSubjectId("");
        setShowObjectionFileImgModal(false);
        setIsEditObjectionFileStage(false);
        delete objectionFilesUploadedPhoto.objectionQuestionFile;
        const fileInput = document.querySelector(
          'input[name="objectionFileUploader"]'
        );
        if (fileInput) {
          fileInput.value = "";
        }
      } else {
        toastr.error(applicationStagesLabels.MANDATORY_FIELD_TOASTR_MES);
      }
    }
  };

  const handleObjectionFileEditClick = (ele, stageid) => {
    setIsEditObjectionFileStage(true);
    if (ele.examSubjectId) {
      setObjectionFilesSubjectId(ele.examSubjectId);
      dispatch(
        getObjectionQuestions(props.adverId, stageid, ele.examSubjectId)
      );
    }

    if (ele.questionNo) {
      setSelectObjectionFilesQuestions(ele.questionNo);
    }

    if (ele.fileName) {
      dispatch(getObjectionFileImage(ele.fileName));
    }
    setObjectionFileId(ele.id);
  };

  const activeObjectionFileStageConfig = (ele, currentStatus) => {
    let requestBody = {
      id: ele.id,
      isActive: !currentStatus,
    };
    dispatch(manageObjectionFileStage(props.adverId, requestBody));
  };

  const deleteObjectionFileStageConfig = (ele) => {
    let requestBody = {
      id: ele.id,
      isDeleted: true,
    };
    dispatch(manageObjectionFileStage(props.adverId, requestBody));
  };

  const cancelObjectionFileImgModal = () => {
    setShowObjectionFileImgModal(false);
  };

  const handleViewUploadedImage = () => {
    setShowObjectionFileImgModal(true);
  };

  const selectAllCheckboxes = () => {
    const allCheckboxValues = Array.from(
      { length: noOfQuestions },
      (_, index) => index + 1
    );
    setSelectedCheckboxes(allCheckboxValues);
  };

  const itemToRenderSaveButton =
    allStageConfigList?.advertisementStageDtoList?.find(
      (item) =>
        item.stage.id === props.stageId &&
        item.masterAdvertisementStageObjectionDto
          ?.advertisementStageObjectionsDtoList?.length > 0
    );

  const renderSaveButton = itemToRenderSaveButton && !isSaveButtonRendered;

  const handleObjectionAnswerKeyDataStage = () => {
    if (showObjectionAnswerKeyDataTab) {
      setObjectionStep("objection_answer_key_data");
      setPostCriteriaId("");
      setSubjectId("");
      setSelectedPostStartDate("");
      setSelectedPostEndDate("");
      setSelectedPaymentEndDate("");
      setSelectedType("");
      setIsActive(true);
      setSelectedCheckboxes([]);
      setNoOfQuestions("");
      setQuePaperSet("");
      setSelectedExam("");
      setIsEditObjectionStageConfigId("");
    } else {
      toastr.error(applicationStagesLabels.TOASTR_MES);
    }
  };

  const handleObjectionFileStage = () => {
    if (showObjectionAnswerKeyDataTab) {
      setObjectionStep("objection_files");
      setPostCriteriaId("");
      setSubjectId("");
      setSelectedPostStartDate("");
      setSelectedPostEndDate("");
      setSelectedPaymentEndDate("");
      setSelectedType("");
      setIsActive(true);
      setSelectedCheckboxes([]);
      setNoOfQuestions("");
      setQuePaperSet("");
      setSelectedExam("");
      setIsEditObjectionStageConfigId("");
    } else {
      toastr.error(applicationStagesLabels.TOASTR_MES);
    }
  };

  const handleObjectionReportExamChange = (e) => {
    let exId = e.target.value;
    setObjectionReportExamId(exId);
    if (exId) {
      dispatch(getExamSubjectForObjectionReport(exId));
    }
    setObjectionReportExamSubId("");
    getAllObjectionReportExamSubjectQuestionsList.length = 0;
    getAllObjectionReportExamSubjectsList.length = 0;
    delete getObjectionReportDetails.objectionRequestReportDto;
  };

  const handleObjectionReportExamSubjectChange = (e, stageid) => {
    let exSubId = e.target.value;
    setObjectionReportExamSubId(exSubId);
    if (exSubId) {
      dispatch(
        getObjectionExamSubjectQuestions(props.adverId, stageid, exSubId)
      );
    }
    setObjectionReportExamSubQueNo("");
    getAllObjectionReportExamSubjectQuestionsList.length = 0;
    delete getObjectionReportDetails.objectionRequestReportDto;
  };

  const handleObjectionReportExamSubQueNoChange = (e) => {
    let queNo = e.target.value;
    setObjectionReportExamSubQueNo(queNo);
    delete getObjectionReportDetails.objectionRequestReportDto;
  };

  const handleViewReportButtonClick = () => {
    dispatch(
      getObjectionReportData(
        props.adverId,
        objectionReportExamId,
        objectionReportExamSubId,
        objectionReportExamSubQueNo
      )
    );
  };

  const handleResetButtonClick = () => {
    setObjectionReportExamId("");
    setObjectionReportExamSubId("");
    setObjectionReportExamSubQueNo("");
    delete getObjectionReportDetails.objectionRequestReportDto;
  };

  const genPdf = (pdfContent, advId, ExSubId, QueNo) => {
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = pdfContent.innerHTML;
    const options = {
      margin: [0.8, 0.4, 0.6, 0.4],
      filename: `ObjectionReport_${advId}_${ExSubId}_${QueNo}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 4, dpi: 600, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "landscape",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        var totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 0.5;
          const textY = pageHeight - 0.2;
          const lineY = textY - 0.1;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("-");
          const currentTime = currentDate.toLocaleTimeString([], {
            hour12: true,
          });
          const dateTime = `${formattedDate} ${currentTime}`;
          pdf.setFontSize(7);
          pdf.text(dateTime, 0.2, textY);
          pdf.text(`${i}`, textX, textY);
          pdf.setLineWidth(0.01);
          pdf.setDrawColor(0, 0, 0);
          pdf.line(0.2, lineY, pageWidth - 0.2, lineY);
        }
      })
      .save();
  };

  const handleDownloadReportButtonClick = () => {
    dispatch(
      getObjectionReportData(
        props.adverId,
        objectionReportExamId,
        objectionReportExamSubId,
        objectionReportExamSubQueNo
      )
    )
      .then((response) => {
        if (
          getObjectionReportDetails &&
          getObjectionReportDetails.objectionRequestReportDto &&
          getObjectionReportDetails.objectionRequestReportDto
            .objectionRequestsList &&
          getObjectionReportDetails.objectionRequestReportDto
            .objectionRequestsList.length > 0
        ) {
          genPdf(
            pdfRef.current,
            props.adverId,
            objectionReportExamSubId,
            objectionReportExamSubQueNo
          );
        }
      })
      .catch((error) => { });
  };

  const handleViewAnswerKeyBtnClick = (ele) => {
    setObjectionAnswerKeyModalData(ele);
    setShowObjectionAnswerKeyModal(true);
  };

  const handleObjectionCountReportExamChange = (e) => {
    let exId = e.target.value;
    setObjectionCountReportExamId(exId);
    if (exId) {
      dispatch(getExamSubjectForObjectionReport(exId));
    }
    setObjectionCountReportExamSubId("");
    getAllObjectionReportExamSubjectQuestionsList.length = 0;
    getAllObjectionReportExamSubjectsList.length = 0;
    delete getObjectionReportCountDetails.objectionQuestionCountList;
  };

  const handleViewObjectionCountReportButtonClick = () => {
    dispatch(
      getObjectionCountReportData(
        objectionReportCountFlg,
        objectionCountReportExamId,
        objectionCountReportExamSubId,
        props.adverId,
        "view"
      )
    );
  };

  const handleDownloadObjectionCountReportButtonClick = () => {
    dispatch(
      getObjectionCountReportData(
        objectionReportCountFlg,
        objectionCountReportExamId,
        objectionCountReportExamSubId,
        props.adverId,
        "download"
      )
    );
  };

  const handleResetObjectionCountButtonClick = () => {
    setObjectionReportCountFlg("");
    setObjectionCountReportExamId("");
    setObjectionCountReportExamSubId("");
    delete getObjectionReportCountDetails.objectionQuestionCountList;
    getAllObjectionReportExamSubjectQuestionsList.length = 0;
    getAllObjectionReportExamSubjectsList.length = 0;
  };

  const handleObjectionCountReportFlgChange = (flg) => {
    setObjectionReportCountFlg(flg);
    setObjectionCountReportExamId("");
    setObjectionCountReportExamSubId("");
    delete getObjectionReportCountDetails.objectionQuestionCountList;
    getAllObjectionReportExamSubjectQuestionsList.length = 0;
    getAllObjectionReportExamSubjectsList.length = 0;
  };

  const ObjectionCountData =
    getObjectionReportCountDetails &&
    getObjectionReportCountDetails.objectionQuestionCountList;
  const NoOfQues = ObjectionCountData && ObjectionCountData.length;

  const handleObjectionAttachmentReportExamChange = (e) => {
    let exId = e.target.value;
    setObjectionAttachmentReportExamId(exId);
    if (exId) {
      dispatch(getExamSubjectForObjectionReport(exId));
    }
    getAllObjectionReportExamSubjectQuestionsList.length = 0;
    getAllObjectionReportExamSubjectsList.length = 0;
    delete getObjectionReportCountDetails.objectionQuestionCountList;
    getObjectionAttachmentReportApplicationsData.length = 0;
  };

  const handleObjectionAttachmentReportExamSubjectChange = (e, stageid) => {
    let exSubId = e.target.value;
    setObjectionAttachmentReportExamSubId(exSubId);
    if (exSubId) {
      dispatch(
        getObjectionExamSubjectQuestions(props.adverId, stageid, exSubId)
      );
    }
    setObjectionAttachmentReportExamSubQueNo("");
    getAllObjectionReportExamSubjectQuestionsList.length = 0;
    delete getObjectionReportDetails.objectionRequestReportDto;
    getObjectionAttachmentReportApplicationsData.length = 0;
  };

  const handleObjectionAttachmentReportExamSubQueNoChange = (e, stageid) => {
    let queNo = e.target.value;
    setObjectionAttachmentReportExamSubQueNo(queNo);
    if (queNo) {
      dispatch(
        getObjectionAttachmentReportApplications(
          props.adverId,
          objectionAttachmentReportExamId,
          objectionAttachmentReportExamSubId,
          queNo,
          stageid
        )
      );
    }
    setObjectionAttachmentReportAppNo("");
    delete getObjectionReportDetails.objectionRequestReportDto;
    getObjectionAttachmentReportApplicationsData.length = 0;
  };

  const handleObjectionAttachmentReportApplicationNoChange = (e) => {
    let appno = e.target.value;
    setObjectionAttachmentReportAppNo(appno);
  };

  const handleDownloadObjectionAttachmentReport = () => {
    dispatch(
      downloadGetObjectionAttachmentReportsReferenceDocument(
        props.adverId,
        objectionAttachmentReportExamId,
        objectionAttachmentReportExamSubId,
        objectionAttachmentReportExamSubQueNo,
        objectionAttachmentReportAppNo
      )
    );
    setObjectionAttachmentReportExamId("");
    setObjectionAttachmentReportExamSubId("");
    setObjectionAttachmentReportExamSubQueNo("");
    setObjectionAttachmentReportAppNo("");
  };

  const handleDownloadAllApplicationsObjectionAttachmentReport = () => {
    dispatch(
      getObjectionAttachmentReportsReferenceDocument(
        props.adverId,
        objectionAttachmentReportExamId,
        objectionAttachmentReportExamSubId,
        objectionAttachmentReportExamSubQueNo,
        objectionAttachmentReportAppNo
      )
    );
    setObjectionAttachmentReportExamId("");
    setObjectionAttachmentReportExamSubId("");
    setObjectionAttachmentReportExamSubQueNo("");
    setObjectionAttachmentReportAppNo("");
  };

  const handleAdmitCardTabClick = (id) => {
    setName(id);
    if (id === "2") {
      props.adverId &&
        props.stageCode === "ADMIT_CARDS" &&
        dispatch(getTimeTableDetailsByAdvtId(props.adverId));
      delete getTimeTableDetails.examInstructionsDtoList;
    }
    // else if (id === "5") {
    //   props.adverId &&
    //     props.stageCode === "ADMIT_CARDS" &&
    //     dispatch(getapplicationListing(props.adverId));
    // }
    setExamCenter("");
    setSelectExamTemplate("");
    setSelectedVenue("");
    setAdmitCardSearchData("");
    setTemplateIdForNotification('');
    setExamDateForNotification('');
    setExamCenterIdForNotification('');
    setVenueIdForNotification('');
    setCandidateNameForNotification('');
    setApplicationNoForNotification('');
    setMobileNoForNotification('');
    setSendNotificationToAllByTemplateId(false);
    setTemplateIdForReport('');
    setExamDateForReport('');
    setExamCenterIdForReport('');
    setVenueIdForReport('');
    setFile('');
    if (getapplicationList && getapplicationList) {
      getapplicationList.length = 0;
    };

    if (getApprovedVenueDetailsList && getApprovedVenueDetailsList) {
      getApprovedVenueDetailsList.length = 0;
    };

    if (
      getSearchAdmitCardListDetails &&
      getSearchAdmitCardListDetails.candidateResponseDtos &&
      getSearchAdmitCardListDetails.candidateResponseDtos.length > 0
    ) {
      delete getSearchAdmitCardListDetails.candidateResponseDtos;
    }
    getVenueDetailsList.length = 0;
  };

  const handleAdmitCardStageContentEditClick = (id, examId, templateId) => {
    dispatch(getTimeTableDetailsByTemplateId(props.adverId, templateId, examId));
    setTemplateIdForAdmitCard(templateId);
    setShowAdmitCardStageContentUpdateModal(true);
  };

  const handleAdmitCardStageContentDeleteClick = (data) => {
    setDetails(data);
    setShowAdmitCardStageContentDeleteModal(true);
    setDeleteTimeTableDetail(data.id);
  };

  const deleteTimeTableData = (id) => {
    setShowAdmitCardStageContentDeleteModal(false);
    let requestBody = {
      timeTableExamsDto: {
        id: id,
        isDeleted: true,
        isActive: details.isActive,
      },
    };
    let examInstructionsRequestBody = {
      examInstructionsDto: {
        examId: details.examId,
        templateId: details.templateId,
        isDeleted: true,
        isActive: details.isActive,
      },
    };
    // dispatch(deleteTimeTableDetailById(requestBody, props.adverId));
    dispatch(
      deleteExamInstructionsDetailsById(
        examInstructionsRequestBody,
        props.adverId
      )
    );
    // window.location.reload()
  };

  const handleExamTemplateChange = (value) => {
    setExamTemplate(value);
  };

  const searchAction = () => {
    dispatch(
      getSearchAdmitCardListData(0, 10, props.adverId, admitCardSearchData)
    );
    if (
      getSearchAdmitCardListDetails &&
      getSearchAdmitCardListDetails.candidateResponseDtos &&
      getSearchAdmitCardListDetails.candidateResponseDtos.length > 0
    ) {
      delete getSearchAdmitCardListDetails.candidateResponseDtos;
    }
  };

  const resetAction = (e) => {
    setAdmitCardSearchData("");
    if (
      getSearchAdmitCardListDetails &&
      getSearchAdmitCardListDetails.candidateResponseDtos &&
      getSearchAdmitCardListDetails.candidateResponseDtos.length > 0
    ) {
      delete getSearchAdmitCardListDetails.candidateResponseDtos;
    }
  };

  const deleteCenterWiseTemplateList = () => {
    setShowCenterWiseDeleteAdmitCardModal(true);
  };

  const deleteCenterWiseAdmitCardData = () => {
    setShowCenterWiseDeleteAdmitCardModal(false);
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let examId =
      parseAdvertisementDetails &&
      parseAdvertisementDetails.advertisement &&
      parseAdvertisementDetails.advertisement.exam &&
      parseAdvertisementDetails.advertisement.exam.id;
    dispatch(
      deleteCenterWiseAdmitCard(
        examId,
        examCenter,
        selectExamTemplate,
        selectedVenue
      )
    );
    setExamCenter("");
    setSelectExamTemplate("");
    setSelectedVenue("");
    getVenueDetailsList.length = 0;
  };

  const resetCenterAction = (e) => {
    setExamCenter("");
    setSelectExamTemplate("");
    setSelectedVenue("");
    getVenueDetailsList.length = 0;
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      searchAction();
    }
  };

  const handleAdmitCardDownload = (ele) => {
    let applId = ele.applicationId;
    let profileId =
      ele && ele.personalInfoList && ele.personalInfoList.profileId;
    dispatch(getProfileSummaryDetails(profileId)).then((response) => {
      return dispatch(getProfileInfoDisplay(profileId)).then((response) => {
        dispatch(admitCard(applId))
          .then((response) => {
            if (
              response &&
              response.data &&
              response.data.admitCardList &&
              response.data.admitCardList.length > 1
            ) {
              setViewAdmitCardModal(true);
              setAdmitCardViewData(response.data);
            } else {
              admitCardGenPdf(admitCardpdfRef.current);
            }
          })
          .catch((error) => { });
      });
    });
  };

  const admitCardGenPdf = () => {
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = admitCardpdfRef.current.innerHTML;
    const options = {
      margin: [0.6, 0.4, 0.6, 0.4],
      filename: "admit-card.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };
    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        var totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 0.5;
          const textY = pageHeight - 0.2;
          const lineY = textY - 0.1;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("-");
          const currentTime = currentDate.toLocaleTimeString([], {
            hour12: true,
          });
          const dateTime = `${formattedDate} ${currentTime}`;
          pdf.setFontSize(7);
          pdf.text(dateTime, 0.2, textY);
          pdf.text(`${i}`, textX, textY);
          pdf.setLineWidth(0.01);
          pdf.setDrawColor(0, 0, 0);
          pdf.line(0.2, lineY, pageWidth - 0.2, lineY);
        }
      })
      .save();
  };

  const genViewAdmitCardpdfRef = () => {
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = viewAdmitCardpdfRef.current.innerHTML;
    const options = {
      margin: [0.8, 0.4, 0.6, 0.4],
      filename: "admit-card.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };
    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        var totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 0.5;
          const textY = pageHeight - 0.2;
          const lineY = textY - 0.1;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("-");
          const currentTime = currentDate.toLocaleTimeString([], {
            hour12: true,
          });
          const dateTime = `${formattedDate} ${currentTime}`;
          pdf.setFontSize(7);
          pdf.text(dateTime, 0.2, textY);
          pdf.text(`${i}`, textX, textY);
          pdf.setLineWidth(0.01);
          pdf.setDrawColor(0, 0, 0);
          pdf.line(0.2, lineY, pageWidth - 0.2, lineY);
        }
      })
      .save();
  };

  const handleDownloadAdmitCardClick = (ele) => {
    let applId = ele && ele.timeTable && ele.timeTable.applicationId;
    let tempId = ele && ele.timeTable && ele.timeTable.templateId;
    dispatch(admitCard(applId, tempId))
      .then((response) => {
        genViewAdmitCardpdfRef(viewAdmitCardpdfRef.current);
      })
      .catch((error) => { });
  };

  const handleExamCenterChange = (e) => {
    let value = e.target.value;
    setExamCenter(value);
    if (value && selectExamTemplate) {
      let advtData = props && props.advertisementDetails;
      let parseAdvertisementDetails = JSON.parse(advtData);
      let examId =
        parseAdvertisementDetails &&
        parseAdvertisementDetails.advertisement &&
        parseAdvertisementDetails.advertisement.exam &&
        parseAdvertisementDetails.advertisement.exam.id;
      setSelectedVenue("");
      dispatch(getVenueDetails(examId, value, selectExamTemplate));
    }
  };

  const handleSelectedExamTemplateChange = (e) => {
    let value = e.target.value;
    setSelectExamTemplate(value);
    if (value && examCenter) {
      let advtData = props && props.advertisementDetails;
      let parseAdvertisementDetails = JSON.parse(advtData);
      let examId =
        parseAdvertisementDetails &&
        parseAdvertisementDetails.advertisement &&
        parseAdvertisementDetails.advertisement.exam &&
        parseAdvertisementDetails.advertisement.exam.id;
      setSelectedVenue("");
      dispatch(getVenueDetails(examId, examCenter, value));
    }
  };

  const activeAdmitCardSearchListElement = (ele, currentStatus) => {
    let applicationId = ele.applicationId;
    let isactive = !currentStatus;
    dispatch(
      manageAdmitCardSearchListData(
        applicationId,
        isactive,
        admitCardSearchData,
        props.adverId
      )
    );
  };

  const onChangeAdvertisement = (event) => {
    let selected = event;
    setSelectedAdvertisement(selected);
    const selectedIds = selected.map((option) => option.value);
    setSelectedOptions(selectedIds);
  };

  const selectFunction = (e) => {
    setSelectAll(e);
  };

  const sendNotificationToAll = () => {
    let templatename = 'admissionCertificate';
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let advid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id ? parseAdvertisementDetails.advertisement.id : '';
    let tempid = templateIdForNotification ? templateIdForNotification : '';
    let examdate = examDateForNotification ? dayjs(examDateForNotification).format(commonLabels.DATE_FORMAT_LABEL) : '';
    let examcenterid = examCenterIdForNotification ? examCenterIdForNotification : '';
    let venueid = venueIdForNotification ? venueIdForNotification : '';
    let candidatename = candidateNameForNotification ? candidateNameForNotification : '';
    let applicationno = applicationNoForNotification ? applicationNoForNotification : '';
    let mobileno = mobileNoForNotification ? mobileNoForNotification : '';
    setSendNotificationToAllModal(false);
    setSendNotificationToAllByTemplateId(false);
    const data = {
      type: ["SMS"],
      adverId: advid,
      stageCode: props.stageCode,
      selectedValue: []
    }
    if (sendNotificationToAllByTemplateId) {
      dispatch(saveSMSdata(data, advid, templatename, tempid, '', '', '', '', '', ''));
    } else {
      dispatch(saveSMSdata(data, advid, templatename, tempid, examdate, examcenterid, venueid, candidatename, applicationno, mobileno));
    }
  };

  const onApplicationSelect = (ele, sendAll) => {
    let templatename = 'admissionCertificate';
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let advid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id ? parseAdvertisementDetails.advertisement.id : '';
    let tempid = templateIdForNotification ? templateIdForNotification : '';
    let examdate = examDateForNotification ? dayjs(examDateForNotification).format(commonLabels.DATE_FORMAT_LABEL) : '';
    let examcenterid = examCenterIdForNotification ? examCenterIdForNotification : '';
    let venueid = venueIdForNotification ? venueIdForNotification : '';
    let candidatename = candidateNameForNotification ? candidateNameForNotification : '';
    let applicationno = applicationNoForNotification ? applicationNoForNotification : '';
    let mobileno = mobileNoForNotification ? mobileNoForNotification : '';
    if (sendAll) {
      setSendNotificationToAllModal(true)
    } else {
      const data = {
        type: ["SMS"],
        adverId: advid,
        stageCode: props.stageCode,
        selectedValue: [ele.applicationNo]
      }
      dispatch(saveSMSdata(data, advid, templatename, tempid, examdate, examcenterid, venueid, candidatename, applicationno, mobileno));
    }
  };

  // Admit Card Send Notification Functionality

  const handleTemplateIdForNotification = (e) => {
    let value = e.target.value;
    setTemplateIdForNotification(value);
    setSendNotificationToAllByTemplateId(false);
  };

  const handleExamCenterIdForNotification = (e) => {
    let value = e.target.value;
    setExamCenterIdForNotification(value);
    setVenueIdForNotification("");
    if (value) {
      let advtData = props && props.advertisementDetails;
      let parseAdvertisementDetails = JSON.parse(advtData);
      let advtid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id;
      dispatch(getApprovedVenueDetailsAPI(advtid, value));
    }
    if (!value) {
      getApprovedVenueDetailsList.length = 0;
    }
  };

  const handleCandidateNameChangeForNotification = (e) => {
    let value = e.target.value;
    if (value) {
      const newValue = value.replace(/[^a-zA-Z\s]/g, "");
      setCandidateNameForNotification(newValue);
    } else {
      setCandidateNameForNotification(value)
    }
  };

  const handleApplicationNoChangeForNotification = (e) => {
    let value = e.target.value;
    if (value) {
      const newValue = value.replace(/\D/g, "");
      setApplicationNoForNotification(newValue);
    } else {
      setApplicationNoForNotification(value)
    }
  };

  const handleMobileNoChangeForNotification = (e) => {
    let value = e.target.value;
    if (value) {
      const newValue = value.replace(/\D/g, "");
      setMobileNoForNotification(newValue);
    } else {
      setMobileNoForNotification(value)
    }
  };

  const handleSearchApplicationListClick = () => {
    if (venueIdForNotification) {
      let advtData = props && props.advertisementDetails;
      let parseAdvertisementDetails = JSON.parse(advtData);
      let advid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id ? parseAdvertisementDetails.advertisement.id : '';
      let tempid = templateIdForNotification ? templateIdForNotification : '';
      let examdate = examDateForNotification ? dayjs(examDateForNotification).format(commonLabels.DATE_FORMAT_LABEL) : '';
      let examcenterid = examCenterIdForNotification ? examCenterIdForNotification : '';
      let venueid = venueIdForNotification ? venueIdForNotification : '';
      let candidatename = candidateNameForNotification ? candidateNameForNotification : '';
      let applicationno = applicationNoForNotification ? applicationNoForNotification : '';
      let mobileno = mobileNoForNotification ? mobileNoForNotification : '';
      dispatch(getapplicationListing(advid, tempid, examdate, examcenterid, venueid, candidatename, applicationno, mobileno));
    } else {
      const button = document.getElementById("venueIdForNotification");
      if (button) {
        button.focus();
      }
    }
  };

  const handleSendNotificationToAllByTemplateId = () => {
    setSendNotificationToAllModal(true);
    setSendNotificationToAllByTemplateId(true);
  };

  // Admit Card Report Functionality

  const handleTemplateIdForReport = (e) => {
    let value = e.target.value;
    setTemplateIdForReport(value);
  };

  const handleExamCenterIdForReport = (e) => {
    let value = e.target.value;
    setExamCenterIdForReport(value);
    setVenueIdForReport("");
    if (value) {
      let advtData = props && props.advertisementDetails;
      let parseAdvertisementDetails = JSON.parse(advtData);
      let advtid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id;
      dispatch(getApprovedVenueDetailsAPI(advtid, value));
    }
    if (!value) {
      getApprovedVenueDetailsList.length = 0;
    }
  };

  const onChangeImage = (event) => {
    if (event.target.files.length == 0) {
      return
    }
    setFile(event.target.files[0])
  }

  const handleStaffFileInputClick = () => {
    setFile("");
  };

  const handleUploadExamStaffClick = () => {
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let examId =
      parseAdvertisementDetails &&
      parseAdvertisementDetails.advertisement &&
      parseAdvertisementDetails.advertisement.exam &&
      parseAdvertisementDetails.advertisement.exam.id;

    let data = {};
    data.file = file;
    data.action = 'upload';
    data.advertisementId = props.adverId;
    data.examId = examId ? examId : '';
    data.templateId = templateIdForReport ? templateIdForReport : '';
    data.examCenterId = examCenterIdForReport ? examCenterIdForReport : '';
    data.venueId = venueIdForReport ? venueIdForReport : '';
    data.date = examDateForReport ? dayjs(examDateForReport).format(commonLabels.DATE_FORMAT_LABEL) : '';
    dispatch(uploadExamStaffDataAPI(data));
    setTemplateIdForReport("");
    setExamDateForReport("");
    setExamCenterIdForReport("");
    setVenueIdForReport("");
    setFile("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDonwloadExamStaffFile = () => {
    let date = examDateForReport ? dayjs(examDateForReport).format(commonLabels.DATE_FORMAT_LABEL) : '';
    dispatch(getVenueStaffInfo(props.adverId, examCenterIdForReport, venueIdForReport, date, ''));
    setTemplateIdForReport("");
    setExamDateForReport("");
    setExamCenterIdForReport("");
    setVenueIdForReport("");
    setFile("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSampleExamStaffFileDownload = () => {
    dispatch(examStaffSampleFileDownload())
  };


  // Interview Letter / PT Letter Functionality

  const handleInterviewAndPtLetterTabClick = (id) => {
    setName(id);
    if (id === "2") {
      props.adverId &&
        props.stageCode === "INTERVIEW_LETTER_PT_LETTER" &&
        dispatch(getScheduleTypeListAPI());
      dispatch(getPostNames(props.adverId));
    } else if (id === '3') {
      props.adverId &&
        props.stageCode === "INTERVIEW_LETTER_PT_LETTER" &&
        dispatch(getScheduleTypeListAPI());
      dispatch(getPostNames(props.adverId));
      dispatch(getInterviewInstructionsListAPI(props.adverId));
    }
    else if (id === "4") {
      props.adverId &&
        props.stageCode === "INTERVIEW_LETTER_PT_LETTER" &&
        dispatch(getScheduleTypeListAPI());
      dispatch(getInterviewReportDetailsAPI());
      dispatch(getPostNames(props.adverId));
    } else if (id === "5") {
      props.adverId &&
        props.stageCode === "INTERVIEW_LETTER_PT_LETTER" &&
        dispatch(getScheduleTypeListAPI());
      dispatch(getPostNames(props.adverId));
    }
    setInterviewPtLettertype('');
    setReportType('');
    setInterviewPtLetterReportPostId('');
    setInterviewPtLetterReportName('');
    setInterviewPtLetterInstructionsPostId('');
    setLetterType('');
    setInterviewPtLetterTypeForNotification('');
    setSendNotificationToAllByinterviewPtLetterType(false);
    setExamCenterIdForInterviewPtLetter('');
    setVenueIdForInterviewPtLetter('');
    setInterviewPtLetterNotificationPostId('');
    setInterviewDateForNotification('');
    setCandidateNameForInterviewPtLetter('');
    setApplicationNoForInterviewPtLetter('');
    setMobileNoForInterviewPtLetter('');
    setSendNotificationToAllViaMobile(false);
    setSendNotificationToAllViaEmail(false);
    setApplicationListingArrForInterviewPtLetter([]);
    setIsAllCheckedForSendNotificationToAllViaEmail(false);
    setIsAllCheckedForSendNotificationToAllViaMobile(false);
    setSerialNo('');
    setpublicationDate('');
    if (
      getApplicationListingArrForInterviewPtLetter && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList.length > 0
    ) {
      delete getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList;
    }
  };

  const onInterviewLetterCsvFileChange = (event) => {
    if (event.target.files.length == 0) {
      return
    }
    setInterviewCsvfileFile(event.target.files[0])
  }

  const handleInterviewLetterCsvFileInputClick = () => {
    setInterviewCsvfileFile("");
  };

  const handleInterviewLetterCsvFileDownload = () => {
    dispatch(interviewLetterCsvFileDownload())
  };

  const handleDonwloadInterviewLetterCsvFile = () => {
    setInterviewCsvfileFile("");
    setOpenDonwloadInterviewLetterCsvModal(true);
    if (interviewCsvfileInputRef.current) {
      interviewCsvfileInputRef.current.value = "";
    }
  };

  const handleInterviewLetterCsvUploadClick = () => {
    let data = {};
    data.file = interviewCsvfile;
    data.action = 'upload';
    data.advertisementId = props.adverId;
    data.scheduleType = interviewPtLettertype ? interviewPtLettertype : '';
    data.postid = interviewPtLetterPostId ? interviewPtLetterPostId : '';
    dispatch(uploadInterviewPTLetterCsvAPI(data));
    setInterviewCsvfileFile("");
    setInterviewPtLettertype("");
    setInterviewPtLetterPostId("");
    if (interviewCsvfileInputRef.current) {
      interviewCsvfileInputRef.current.value = "";
    }
  };

  const handleDownloadInterviewReportClick = () => {
    if (interviewPtLetterReportName == "ELIGIBLE CANDIDATE LIST") {
      dispatch(downloadEligibleCandidatesListFileAPI(props.adverId, interviewPtLetterReportPostId, reportType));
      setInterviewPtLetterReportPostId('');
      setInterviewPtLetterReportName('');
      setReportType('');
    } else
      if ((interviewPtLetterReportName === "ATTENDANCE MUSTER") || (interviewPtLetterReportName === "TOKEN MUSTER") || (interviewPtLetterReportName === "TOKEN MAPPING REPORT") || (interviewPtLetterReportName === "VERIFICATION MUSTER") || (interviewPtLetterReportName === "APPLICATION RECOMMENDATION") || (interviewPtLetterReportName === "PROFILE DETAILS") || (interviewPtLetterReportName === "SUMMARY SHEET")) {
        setOpenAttendanceMusterReportModal(true);
      }
      else {
        setInterviewPtLetterReportPostId('');
        setInterviewPtLetterReportName('');
        setReportType('');
      }
  };

  const handleInstructionsSubmit = () => {
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let examId = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.exam && parseAdvertisementDetails.advertisement.exam.id;
    let examDisplayName = postNamesData && postNamesData.length > 0 && postNamesData.find((e => e.id == interviewPtLetterInstructionsPostId))

    let otherDetails = {
      serialNo: serialNo,
      publicationDate: publicationDate
    };
    let requestBody = {};
    let examInstructionsDto = {};

    if (interviewInstructionsId) {
      examInstructionsDto.id = interviewInstructionsId;
    };

    examInstructionsDto.examId = examId;
    examInstructionsDto.examDisplayName = examDisplayName.name;
    examInstructionsDto.templateId = letterType;
    examInstructionsDto.postCriteriaId = interviewPtLetterInstructionsPostId;
    examInstructionsDto.examAuthority = authority;
    examInstructionsDto.examAuthoritySignature = signature;
    examInstructionsDto.studentInstructions = candidateInstruction;
    examInstructionsDto.importantInstructions = impInstruction;
    examInstructionsDto.isActive = true;
    examInstructionsDto.otherDetails = JSON.stringify(otherDetails);
    requestBody.examInstructionsDto = examInstructionsDto;

    if (interviewInstructionsId) {
      dispatch(saveInterviewInstructionsAPI(requestBody, interviewInstructionsId, props.adverId))
    } else {
      dispatch(saveInterviewInstructionsAPI(requestBody, '', props.adverId))
    }
    setInterviewPtLetterInstructionsPostId('');
    setLetterType('');
    setAuthority(commonLabels.INTERVIEW_AUTHORITY);
    setSignature(commonLabels.INTERVIEW_SIGNATURE);
    setSignatureLengthErr(false);
    setAuthorityLengthErr(false);
    setImpInstruction('');
    setCandidateInstruction('');
    setInterviewInstructionsId('');
    setSerialNo('');
    setpublicationDate('');
  };

  const handleAddInstructionsBtnClick = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  const handleEditInstructionsBtnClick = (ele) => {
    setInterviewInstructionsId(ele.id);
    setInterviewPtLetterInstructionsPostId(ele.postCriteriaId);
    setLetterType(ele.templateId);
    setAuthority(ele.examAuthority);
    setSignature(ele.examAuthoritySignature);
    setImpInstruction(ele.importantInstructions);
    setCandidateInstruction(ele.studentInstructions);
    let otherDetails = ele.otherDetails ? JSON.parse(ele.otherDetails) : '';
    if (otherDetails) {
      setSerialNo(otherDetails.serialNo);
      setpublicationDate(otherDetails.publicationDate);
    }
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  const handleDeleteInstructionsBtnClick = (ele) => {
    let requestBody = {};
    let examInstructionsDto = {};
    examInstructionsDto.id = ele.id;
    examInstructionsDto.isDeleted = true;
    requestBody.examInstructionsDto = examInstructionsDto;
    toastr.confirm(applicationStagesLabels.DELETE_RECORD_MES, {
      onOk: () => {
        dispatch(deleteInterviewInstructionsDetailsById(requestBody, props.adverId));
        setInterviewInstructionsId('');
        setInterviewPtLetterInstructionsPostId('');
        setLetterType('');
        setAuthority('');
        setSignature('');
        setImpInstruction('');
        setCandidateInstruction('');
        setSerialNo('');
        setpublicationDate('');
      }
    });
  };

  const handleInterviewPtLetterTypeNotification = (e) => {
    let value = e.target.value;
    setInterviewPtLetterTypeForNotification(value);
    setSendNotificationToAllByinterviewPtLetterType(false);
    if (value) {
      dispatch(getInterviewPtLetterDropdownValuesAPI(props.adverId, value));
    }
  };

  const handleExamCenterIdForInterviewPtLetterTypeNotification = (e) => {
    let value = e.target.value;
    setExamCenterIdForInterviewPtLetter(value);
  };

  const handleCandidateNameChangeForNotificationInterviewPtLetter = (e) => {
    let value = e.target.value;
    if (value) {
      const newValue = value.replace(/[^a-zA-Z\s]/g, "");
      setCandidateNameForInterviewPtLetter(newValue);
    } else {
      setCandidateNameForInterviewPtLetter(value)
    }
  };

  const handleApplicationNoChangeForNotificationInterviewPtLetter = (e) => {
    let value = e.target.value;
    if (value) {
      const newValue = value.replace(/\D/g, "");
      setApplicationNoForInterviewPtLetter(newValue);
    } else {
      setApplicationNoForInterviewPtLetter(value)
    }
  };

  const handleMobileNoChangeForNotificationInterviewPtLetter = (e) => {
    let value = e.target.value;
    if (value) {
      const newValue = value.replace(/\D/g, "");
      setMobileNoForInterviewPtLetter(newValue);
    } else {
      setMobileNoForInterviewPtLetter(value)
    }
  };

  const handleSearchApplicationListForInterviewPtLetterClick = () => {
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let advid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id ? parseAdvertisementDetails.advertisement.id : '';
    let type = interviewPtLetterTypeForNotification ? interviewPtLetterTypeForNotification : '';
    let postid = interviewPtLetterNotificationPostId ? interviewPtLetterNotificationPostId : '';
    let date = interviewDateForNotification ? dayjs(interviewDateForNotification).format(commonLabels.DATE_FORMAT_LABEL) : '';
    let examcenterid = examCenterIdForInterviewPtLetter ? examCenterIdForInterviewPtLetter : '';
    let venue = venueIdForInterviewPtLetter ? venueIdForInterviewPtLetter : '';
    let candidatename = candidateNameForInterviewPtLetter ? candidateNameForInterviewPtLetter : '';
    let applicationno = applicationNoForInterviewPtLetter ? applicationNoForInterviewPtLetter : '';
    let mobileno = mobileNoForInterviewPtLetter ? mobileNoForInterviewPtLetter : '';
    dispatch(getapplicationListingForInterviewPtLetter(advid, type, postid, date, examcenterid, venue, candidatename, applicationno, mobileno));
    if (
      getApplicationListingArrForInterviewPtLetter && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList.length > 0
    ) {
      delete getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList;
    }
    setIsAllCheckedForSendNotificationToAllViaEmail(false);
    setIsAllCheckedForSendNotificationToAllViaMobile(false);
    setApplicationListingArrForInterviewPtLetter([]);
    setSendNotificationToAllViaMobile(false);
    setSendNotificationToAllViaEmail(false);

  };

  const handleSendNotificationToAllForInterviewPtLetter = () => {
    setSendNotificationToAllModalForInterviewPtLetter(true);
    setSendNotificationToAllByinterviewPtLetterType(true);
  };

  const sendNotificationForInterviewPtLetter = (ele, sendAll) => {
    let templatename = 'ptAndInterview';
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let advid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id ? parseAdvertisementDetails.advertisement.id : '';
    let tempid = interviewPtLetterTypeForNotification ? interviewPtLetterTypeForNotification : '';
    let postid = interviewPtLetterNotificationPostId ? interviewPtLetterNotificationPostId : '';
    let examdate = interviewDateForNotification ? dayjs(interviewDateForNotification).format(commonLabels.DATE_FORMAT_LABEL) : '';
    let examcenterid = examCenterIdForInterviewPtLetter ? examCenterIdForInterviewPtLetter : '';
    let venueid = venueIdForInterviewPtLetter ? venueIdForInterviewPtLetter : '';
    let candidatename = candidateNameForInterviewPtLetter ? candidateNameForInterviewPtLetter : '';
    let applicationno = applicationNoForInterviewPtLetter ? applicationNoForInterviewPtLetter : '';
    let mobileno = mobileNoForInterviewPtLetter ? mobileNoForInterviewPtLetter : '';

    let typeFlg = ['SMS'];
    if ((ele.isMobileNoCheckedFlg) && (ele.isEmailCheckedFlg)) {
      typeFlg = ['SMS', 'EMAIL'];
    } else if ((ele.isMobileNoCheckedFlg) && (!ele.isEmailCheckedFlg)) {
      typeFlg = ['SMS'];
    } else if ((!ele.isMobileNoCheckedFlg) && (ele.isEmailCheckedFlg)) {
      typeFlg = ['EMAIL'];
    }

    if (sendAll) {
      setSendNotificationToAllModalForInterviewPtLetter(true)
    } else {
      const data = {
        type: typeFlg,
        adverId: advid,
        stageCode: props.stageCode,
        selectedValue: [ele.profileTransactionID]
      }
      dispatch(saveSMSdata(data, advid, templatename, tempid, examdate, examcenterid, venueid, candidatename, applicationno, mobileno, postid));
      let arr = getApplicationListingArrForInterviewPtLetter && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList;
      const updatedArr = arr.map(item => ({
        ...item,
        isMobileNoCheckedFlg: false,
        isEmailCheckedFlg: false
      }));
      setApplicationListingArrForInterviewPtLetter(updatedArr);
      setIsAllCheckedForSendNotificationToAllViaEmail(false);
      setIsAllCheckedForSendNotificationToAllViaMobile(false);
    }
  };

  const sendNotificationToAllForInterviewPtLetter = () => {
    let templatename = 'ptAndInterview';
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let advid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id ? parseAdvertisementDetails.advertisement.id : '';
    let tempid = interviewPtLetterTypeForNotification ? interviewPtLetterTypeForNotification : '';
    let postid = interviewPtLetterNotificationPostId ? interviewPtLetterNotificationPostId : '';
    let examdate = interviewDateForNotification ? dayjs(interviewDateForNotification).format(commonLabels.DATE_FORMAT_LABEL) : '';
    let examcenterid = examCenterIdForInterviewPtLetter ? examCenterIdForInterviewPtLetter : '';
    let venueid = venueIdForInterviewPtLetter ? venueIdForInterviewPtLetter : '';
    let candidatename = candidateNameForInterviewPtLetter ? candidateNameForInterviewPtLetter : '';
    let applicationno = applicationNoForInterviewPtLetter ? applicationNoForInterviewPtLetter : '';
    let mobileno = mobileNoForInterviewPtLetter ? mobileNoForInterviewPtLetter : '';
    setSendNotificationToAllModalForInterviewPtLetter(false);
    setSendNotificationToAllByinterviewPtLetterType(false);
    let notificationType = ['SMS'];
    if (sendNotificationToAllViaMobile && sendNotificationToAllViaEmail) {
      notificationType = ["SMS", "EMAIL"];
    } else if (sendNotificationToAllViaMobile && (!sendNotificationToAllViaEmail)) {
      notificationType = ["SMS"];
    } else if ((!sendNotificationToAllViaMobile) && sendNotificationToAllViaEmail) {
      notificationType = ["EMAIL"];
    };

    const data = {
      type: notificationType,
      adverId: advid,
      stageCode: props.stageCode,
      selectedValue: []
    }
    if (sendNotificationToAllByinterviewPtLetterType) {
      dispatch(saveSMSdata(data, advid, templatename, tempid, '', '', '', '', '', '', postid));
    } else {
      dispatch(saveSMSdata(data, advid, templatename, tempid, examdate, examcenterid, venueid, candidatename, applicationno, mobileno, postid));
    }
  };

  const isAllCheckedForSendNotificationToAllViaMobileClick = (curflag, type, appId) => {
    let flag = curflag;
    if (type === "mobile") {
      setIsAllCheckedForSendNotificationToAllViaMobile(curflag)
      const updatedArr = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length > 0 && applicationListingArrForInterviewPtLetter.map(item => ({
        ...item,
        isMobileNoCheckedFlg: flag,
      }));
      setApplicationListingArrForInterviewPtLetter(updatedArr);
    } else if (type === "email") {
      setIsAllCheckedForSendNotificationToAllViaEmail(curflag)
      const updatedArr = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length > 0 && applicationListingArrForInterviewPtLetter.map(item => ({
        ...item,
        isEmailCheckedFlg: flag,
      }));
      setApplicationListingArrForInterviewPtLetter(updatedArr);
    } else if (type === "singleMobileNoCheckedFlg") {
      const updatedArr = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length > 0 && applicationListingArrForInterviewPtLetter.map(item => {
        if (item.applicationId === appId) {
          return {
            ...item,
            isMobileNoCheckedFlg: curflag,
          };
        }
        return item;
      });
      setApplicationListingArrForInterviewPtLetter(updatedArr);
      const allFlagsEqual = updatedArr && updatedArr.every(item => item.isMobileNoCheckedFlg === curflag);
      if (allFlagsEqual) {
        setIsAllCheckedForSendNotificationToAllViaMobile(curflag);
      } else {
        setIsAllCheckedForSendNotificationToAllViaMobile(false);
      }
    } else if (type === "singleEmailCheckedFlg") {
      const updatedArr = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length > 0 && applicationListingArrForInterviewPtLetter.map(item => {
        if (item.applicationId === appId) {
          return {
            ...item,
            isEmailCheckedFlg: curflag,
          };
        }
        return item;
      });
      setApplicationListingArrForInterviewPtLetter(updatedArr);
      const allFlagsEqual = updatedArr && updatedArr.every(item => item.isEmailCheckedFlg === curflag);
      if (allFlagsEqual) {
        setIsAllCheckedForSendNotificationToAllViaEmail(curflag);
      } else {
        setIsAllCheckedForSendNotificationToAllViaEmail(false)
      }
    }
  }

  const interviewPtLetterSendNotification = () => {
    let templatename = 'ptAndInterview';
    let advtData = props && props.advertisementDetails;
    let parseAdvertisementDetails = JSON.parse(advtData);
    let advid = parseAdvertisementDetails && parseAdvertisementDetails.advertisement && parseAdvertisementDetails.advertisement.id ? parseAdvertisementDetails.advertisement.id : '';
    let tempid = interviewPtLetterTypeForNotification ? interviewPtLetterTypeForNotification : '';
    let postid = interviewPtLetterNotificationPostId ? interviewPtLetterNotificationPostId : '';
    let examdate = interviewDateForNotification ? dayjs(interviewDateForNotification).format(commonLabels.DATE_FORMAT_LABEL) : '';
    let examcenterid = examCenterIdForInterviewPtLetter ? examCenterIdForInterviewPtLetter : '';
    let venueid = venueIdForInterviewPtLetter ? venueIdForInterviewPtLetter : '';
    let candidatename = candidateNameForInterviewPtLetter ? candidateNameForInterviewPtLetter : '';
    let applicationno = applicationNoForInterviewPtLetter ? applicationNoForInterviewPtLetter : '';
    let mobileno = mobileNoForInterviewPtLetter ? mobileNoForInterviewPtLetter : '';
    setSendNotificationToAllModalForInterviewPtLetter(false);
    setSendNotificationToAllByinterviewPtLetterType(false);
    const mobileNoCheckedCount = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.filter(item => item.isMobileNoCheckedFlg === true).length;
    const emailCheckedCount = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.filter(item => item.isEmailCheckedFlg === true).length;

    let idsToExtract = [];
    let greaterCountFlg = ['SMS'];
    if (isAllCheckedForSendNotificationToAllViaMobile && isAllCheckedForSendNotificationToAllViaEmail) {
      greaterCountFlg = ["SMS", "EMAIL"];
      idsToExtract = [];
    } else
      if (mobileNoCheckedCount > emailCheckedCount) {
        greaterCountFlg = ["SMS"];
        idsToExtract = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter
          .filter(item => item.isMobileNoCheckedFlg === true)
          .map(item => item.profileTransactionID);
      } else {
        greaterCountFlg = ["EMAIL"];
        idsToExtract = applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter
          .filter(item => item.isEmailCheckedFlg === true)
          .map(item => item.profileTransactionID);
      }

    const data = {
      type: greaterCountFlg,
      adverId: advid,
      stageCode: props.stageCode,
      selectedValue: idsToExtract
    }
    dispatch(saveSMSdata(data, advid, templatename, tempid, examdate, examcenterid, venueid, candidatename, applicationno, mobileno, postid));

    let arr = getApplicationListingArrForInterviewPtLetter && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto && getApplicationListingArrForInterviewPtLetter.eligibleCandidateListReportDto.eligibleCandidateList;
    const updatedArr = arr.map(item => ({
      ...item,
      isMobileNoCheckedFlg: false,
      isEmailCheckedFlg: false
    }));
    setApplicationListingArrForInterviewPtLetter(updatedArr);
    setIsAllCheckedForSendNotificationToAllViaEmail(false);
    setIsAllCheckedForSendNotificationToAllViaMobile(false);
  };

  return (
    <>
      {props.stageCode === "FEE_RECEIPT" && (
        <div
          className="feeReceiptSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
          data-bs-parent="#configTabContent"
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {feerecheaderField &&
              feerecheaderField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                    data-bs-toggle="tab"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONTENT}</h5>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "CENTRE_CHANGE" && (
        <div
          className="centreChangeSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
          data-bs-parent="#configTabContent"
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    <tr>
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {/* {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )} */}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td>{item.postCriteriaId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {/* {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.onlinePaymentEndDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}</td>
                                    ) : (
                                      ""
                                    )} */}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONTENT}</h5>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "PREFERENCE_CHANGE" && (
        <div
          className="preferenceChangeSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active "
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {/* {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )} */}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td>{item.postCriteriaId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {/* {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.onlinePaymentEndDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}</td>
                                    ) : (
                                      ""
                                    )} */}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.onlinePaymentEndDate}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>
                {applicationStagesLabels.UPLOAD_AND_DOWNLOAD_PREFERENCE_LIST}
              </h5>
              <div className="d-flex justify-content-center">
                <main
                  role="main"
                  className="col-sm-9 col-md-11 col-lg-12 "
                  id="main_block"
                >
                  <div className="pt-2 pb-2">
                    <div className="float-right pe-1">
                      <button type="button" className="btn btn-sm btn-primary">
                        {applicationStagesLabels.UPLOAD_LIST}
                      </button>{" "}
                      &nbsp;
                      <button type="button" className="btn btn-sm btn-primary">
                        {" "}
                        {applicationStagesLabels.DOWNLOAD_LIST}{" "}
                      </button>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "RE_UPLOAD_DOCUMENTS" && (
        <div
          className="reUploadDocumentsSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {/* {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )} */}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="word-break text-center">
                                      {index + 1}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td>{item.postName}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {/* {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                        <td>{item.onlinePaymentEndDate
                                          ? dayjs(
                                            getFormattedDate(
                                              new Date(item.onlinePaymentEndDate)
                                            )
                                          ).format(
                                            applicationStagesLabels.DatePlaceHolder
                                          )
                                          : ""}</td>
                                    ) : (
                                      ""
                                    )} */}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.PostName}{" "}
                      </label>
                      <div className="input-group bg-color">
                        <select
                          className="form-select bg-color"
                          name="postCriteriaName"
                          value={postCriteriaId}
                          onChange={(event) => onChangePostCriteria(event)}
                        >
                          <option key="" value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {advertisementDetails &&
                            advertisementDetails.examPostList &&
                            advertisementDetails.examPostList.length > 0 &&
                            advertisementDetails.examPostList.map((item, i) => {
                              return (
                                <option key={i} value={item.postCriteria.id}>
                                  {item.postCriteria.name}-
                                  {item.postCriteria.nameDvng}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <ul className="nav nav-tabs" id="configTab" role="tablist">
                <li className="nav-item cursor-pointer" key="0">
                  <a
                    className={
                      stepSubName === "upload_tab"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="uploadTab"
                    onClick={() => {
                      setSubName("upload_tab");
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>Upload List</span>
                  </a>
                </li>
                <li className="nav-item cursor-pointer" key="1">
                  <a
                    className={
                      stepSubName === "download_tab"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="downloadTab"
                    onClick={() => {
                      setSubName("download_tab");
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{applicationStagesLabels.DOWNLOAD_LIST}</span>
                  </a>
                </li>
              </ul>

              <div
                className="tab-content border border-light"
                id="configTabContent"
              >
                <div
                  className={
                    stepSubName === "upload_tab"
                      ? "tab-pane show active tabContentHeaderCss"
                      : "tab-pane fade tabContentHeaderCss"
                  }
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <h5>Upload List</h5>

                  <div className="border border-light w-100 p-1">
                    <div className="justify-content-center">
                      <div className="float-right  pe-1 mb-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={handledUploadDocumentList}
                        >
                          {applicationStagesLabels.UPLOAD_LIST}
                        </button>{" "}
                        &nbsp;
                      </div>
                      <ImportDataModal
                        showImportDocList={showImportDocList}
                        type="candidate_list"
                        advid={props.adverId}
                        setImportDocumentList={setImportDocumentList}
                      />

                      <div className="">

                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col" className='theadBgColor'>{applicationStagesLabels.SR_NO}</th>
                              <th scope="col" className='theadBgColor'>
                                {applicationStagesLabels.APPLICATION_ID}
                              </th>
                              <th scope="col" className='theadBgColor'>
                                {applicationStagesLabels.DOCUMENTS_NAME}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="f12">
                            <tr key="0">
                              <td className="w-10 word-break text-center">1</td>
                              <td className="w-15 word-break text-center">30</td>
                              <td className="word-break ">
                                {
                                  applicationStagesLabels.PROOF_OF_KNOWLEDGE_OF_MARATHI_LANGUAGE
                                }
                              </td>
                            </tr>
                            <tr key="1">
                              <td className="w-10 word-break text-center">2</td>
                              <td className="w-15 word-break text-center">31</td>
                              <td className="word-break ">
                                {applicationStagesLabels.PROOF_OF_AGE}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    stepSubName === "download_tab"
                      ? "tab-pane show active tabContentHeaderCss"
                      : "tab-pane fade tabContentHeaderCss"
                  }
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <h5>{applicationStagesLabels.DOWNLOAD_LIST}</h5>
                  <div className="border border-light w-100 p-1">
                    <div className="justify-content-center">
                      <div className="float-right pe-1 mb-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={downloadDocumentTemplate}
                        >
                          {applicationStagesLabels.DOWNLOAD_LIST}
                        </button>
                      </div>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col" className='theadBgColor'>{applicationStagesLabels.SR_NO}</th>
                            <th scope="col" className='theadBgColor'>
                              {applicationStagesLabels.APPLICATION_ID}
                            </th>
                            <th scope="col" className='theadBgColor'>
                              {applicationStagesLabels.DOCUMENTS_NAME}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="f12">
                          <tr key="0">
                            <td className="w-10 word-break text-center">1</td>
                            <td className="w-15 word-break text-center">30</td>
                            <td className="word-break ">
                              {
                                applicationStagesLabels.PROOF_OF_KNOWLEDGE_OF_MARATHI_LANGUAGE
                              }
                            </td>
                          </tr>
                          <tr key="1">
                            <td className="w-10 word-break text-center">2</td>
                            <td className="w-15 word-break text-center">31</td>
                            <td className="word-break ">
                              {applicationStagesLabels.PROOF_OF_AGE}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "ADMIT_CARDS" && (
        <div
          className="admitCardSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {admitCardheaderField &&
              admitCardheaderField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      handleAdmitCardTabClick(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList ">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className="text-center theadBgColor">
                                        {applicationStagesLabels.NO}
                                      </th>
                                      <th scope="col" className="w-25 theadBgColor">
                                        {TimetableLabels.EXAM_TEMPLATE}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {/* {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )} */}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break  text-center">
                                      {index + 1}
                                    </td>
                                    <td className="w-25 word-break">
                                      {item.templateName
                                        ? item.templateName
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {/* <td>{item.onlinePaymentEndDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.onlinePaymentEndDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}</td> */}
                                    {/* {item.postCriteriaId != "" &&
                                    item.postCriteriaId != null &&
                                    item.postCriteriaId != undefined ? (
                                      <td>{item.postCriteriaId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                    item.examSubjectId != null &&
                                    item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )} */}
                                    {/* {item.onlinePaymentEndDate != "" &&
                                    item.onlinePaymentEndDate != null &&
                                    item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.type != "" &&
                                    item.type != null &&
                                    item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )} */}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-3 mt-2">
                      <label className="fw-bold">
                        {TimetableLabels.EXAM_TEMPLATE}
                        <span className="redColor">*</span>
                      </label>
                      <div className="input-group bg-color">
                        <select
                          className="form-select bg-color"
                          name="examTemplate"
                          value={examTemplate}
                          defaultValue={examTemplate}
                          onInput={(e) => {
                            handleExamTemplateChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getExamTemplateListForImportAdmitCardCsv &&
                            getExamTemplateListForImportAdmitCardCsv.length > 0 &&
                            getExamTemplateListForImportAdmitCardCsv
                              .sort((a, b) => {
                                return Number(a.sortOrder) - Number(b.sortOrder);
                              })
                              .map((ele, ind) => {
                                return (
                                  <option key={ind++} value={ele.id}>
                                    {ele.label}
                                  </option>
                                );
                              })}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img
                                    src="/icons/calender.png"
                                    className="date-picker-icon"
                                  ></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img
                                    src="/icons/calender.png"
                                    className="date-picker-icon"
                                  ></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-3 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img
                                    src="/icons/calender.png"
                                    className="date-picker-icon"
                                  ></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img
                                    src="/icons/calender.png"
                                    className="date-picker-icon"
                                  ></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-3 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONTENT}</h5>
              <TimeTableCsvData
                type="Csv_upload"
                upload_button_label="Import File"
                advtId={props.adverId}
                stageId={props.stageId}
              />

              <div className="border border-light w-100 p-1 mt-4">
                <div className="justify-content-center">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        {timeTableCsvListHeader &&
                          timeTableCsvListHeader.map((itm, ind) => {
                            return (
                              <>
                                {itm == "" ? (
                                  <th
                                    key={ind}
                                    className="text-center w90 theadBgColor"
                                  >
                                    {itm}
                                  </th>
                                ) : (
                                  <th key={ind} className="text-center theadBgColor">
                                    {itm}
                                  </th>
                                )}
                              </>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody>
                      {getTimeTableDetails &&
                        getTimeTableDetails.examInstructionsDtoList &&
                        getTimeTableDetails.examInstructionsDtoList.length > 0 ? (
                        getTimeTableDetails.examInstructionsDtoList.map(
                          (ele, i) => {
                            if (ele) {
                              const currentDate = new Date().setHours(
                                0,
                                0,
                                0,
                                0
                              );
                              const stageEndDate = new Date(
                                ele.stageEndDate
                              ).setHours(0, 0, 0, 0);
                              const isPastDate = stageEndDate < currentDate;
                              const className =
                                (ele.stageEndDate ? isPastDate : false) ||
                                (ele.isStageActive === false
                                  ? "past-date-row"
                                  : true);
                              return (
                                <tr className={className}>
                                  <td className="w-10 word-break text-center">
                                    {TimeTableCsvListTableCounter++}
                                  </td>
                                  <td className="word-break">
                                    {ele && ele.advertisementName
                                      ? ele.advertisementName
                                      : ""}
                                  </td>
                                  <td className="word-break">
                                    {ele && ele.templateLabel
                                      ? ele.templateLabel
                                      : ""}
                                    <br /> (
                                    {ele.templateId ? ele.templateId : ""})
                                  </td>
                                  <td className="word-break">
                                    {ele && ele.examDisplayName
                                      ? ele.examDisplayName
                                      : ""}
                                  </td>
                                  <td className="word-break text-center">
                                    <i
                                      role="button"
                                      data-toggle="tooltip"
                                      title={commonLabels.BUTTON_EDIT}
                                      className="text-primary fa fa-edit"
                                      onClick={(e) => {
                                        handleAdmitCardStageContentEditClick(
                                          ele.id,
                                          ele.examId,
                                          ele.templateId
                                        );
                                      }}
                                    ></i>
                                    &nbsp;&nbsp;
                                    <i
                                      role="button"
                                      data-toggle="tooltip"
                                      className="fa fa-trash ms-2"
                                      title={commonLabels.BUTTON_DELETE}
                                      onClick={(e) => {
                                        handleAdmitCardStageContentDeleteClick(
                                          ele
                                        );
                                      }}
                                    ></i>
                                  </td>
                                </tr>
                              );
                            }
                          }
                        )
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            {docLabels.NO_DATA}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "3" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div
                className="tab-content border border-light"
                id="configTabContent"
              >
                <div className="row d-flex align-items-center">
                  <div className="col-md-4 mt-2">
                    <div className="form-group">
                      <label className="fw-bold ">
                        {" "}
                        {candidateManagementLabels.SEARCH_VALUE}&nbsp;
                        <span className="redColor">*</span>
                      </label>
                      <div className="input-group bg-color">
                        <input
                          name="name"
                          className="form-control"
                          type="text"
                          value={admitCardSearchData}
                          onChange={(e) => setAdmitCardSearchData(e.target.value)}
                          onKeyPress={handleKeyPress}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <div className="row mt-2 col-sm-12">
                      <div className="col-md-6 col-sm-12">
                        <button
                          type="button"
                          disabled={!admitCardSearchData}
                          className=" btn btn-primary custom_button  w-100 f12 mt-2  "
                          onClick={searchAction}
                        >
                          {candidateManagementLabels.SEARCH}
                        </button>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <button
                          type="button"
                          onClick={resetAction}
                          className="btn btn-outline-secondary w-100 f12 mt-2"
                        >
                          {candidateManagementLabels.RESET}
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="card">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        {candidateManagementLabels.admitCardSearchListTableheader.map(
                          (ele, index) => (
                            <th scope="col" className='theadBgColor' key={index}>
                              {ele}
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody className="f12">
                      {getSearchAdmitCardListDetails &&
                        getSearchAdmitCardListDetails.candidateResponseDtos &&
                        getSearchAdmitCardListDetails.candidateResponseDtos
                          .length > 0 ? (
                        getSearchAdmitCardListDetails.candidateResponseDtos.map(
                          (ele, i) => {
                            if (ele) {
                              return (
                                <tr>
                                  <td className="word-break">
                                    {admitCardTableCounter++}
                                  </td>
                                  <td className="word-break">
                                    {ele && ele.applicationNo
                                      ? ele.applicationNo
                                      : ""}
                                  </td>
                                  <td className="word-break">
                                    {ele &&
                                      ele.personalInfoList &&
                                      ele.personalInfoList.englishFullName
                                      ? ele.personalInfoList.englishFullName
                                      : ""}
                                  </td>
                                  <td className="word-break">
                                    {ele &&
                                      ele.personalInfoList &&
                                      ele.personalInfoList.mobileNumber
                                      ? ele.personalInfoList.mobileNumber
                                      : ""}
                                  </td>
                                  <td className="word-break">
                                    {ele &&
                                      ele.personalInfoList &&
                                      ele.personalInfoList.emailId
                                      ? ele.personalInfoList.emailId
                                      : ""}
                                  </td>
                                  <td className="w15 word-break">
                                    <i
                                      role="button"
                                      data-toggle="tooltip"
                                      title={
                                        ele.admitCardsActive
                                          ? commonLabels.BUTTON_INACTIVE
                                          : commonLabels.BUTTON_ACTIVE
                                      }
                                      className={
                                        ele.admitCardsActive === true
                                          ? "text-success fa fa-toggle-on"
                                          : "text-danger fa fa-toggle-off"
                                      }
                                      onClick={(e) => {
                                        activeAdmitCardSearchListElement(
                                          ele,
                                          ele.admitCardsActive
                                        );
                                      }}
                                    ></i>
                                    &nbsp;&nbsp;
                                    <button
                                      className="btn btn-outline-primary  custom_button  btn-sm"
                                      onClick={() => {
                                        handleAdmitCardDownload(ele);
                                      }}
                                    >
                                      {candidateManagementLabels.VIEW}
                                    </button>
                                    <div
                                      className="d-none"
                                      ref={admitCardpdfRef}
                                    >
                                      <AdmitCard />
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          }
                        )
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            {docLabels.NO_DATA}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {getSearchAdmitCardListDetails &&
                    getSearchAdmitCardListDetails.candidateResponseDtos &&
                    getSearchAdmitCardListDetails.candidateResponseDtos.length >
                    0 && (
                      <TablePagination
                        paginationFor="admit_card_search_list"
                        rowPerPage={admitCardStageSearchRowPerPage}
                        totalCount={
                          getSearchAdmitCardListDetails &&
                          getSearchAdmitCardListDetails.count
                        }
                        advid={props.adverId}
                        searchCode2={admitCardSearchData}
                      />
                    )}
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "4" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div
                className="tab-content border border-light"
                id="configTabContent"
              >
                <div className="row">
                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">
                      {TimetableLabels.SELECT_EXAM_TEMPLATE}
                      <span className="errorText">*</span>
                    </label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        name="selectExamTemplate"
                        value={selectExamTemplate}
                        defaultValue={selectExamTemplate}
                        onInput={(e) => {
                          handleSelectedExamTemplateChange(e);
                        }}
                        ref={register({ required: true })}
                      >
                        <option key={0} value="">
                          {commonLabels.COMBO_SELECT}
                        </option>
                        {getExamTemplateListForImportAdmitCardCsv &&
                          getExamTemplateListForImportAdmitCardCsv.length > 0 &&
                          getExamTemplateListForImportAdmitCardCsv
                            .sort((a, b) => {
                              return Number(a.sortOrder) - Number(b.sortOrder);
                            })
                            .map((ele, ind) => {
                              return (
                                <option key={ind++} value={ele.id}>
                                  {ele.label}
                                </option>
                              );
                            })}
                      </select>
                    </div>
                    {_.get("selectExamTemplate.type", errors) ===
                      "required" && (
                        <p className="errorText float-start mt-n4">
                          {commonLabels.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )}
                  </div>

                  <div className="col-md-4 mt-2">
                    <label className="fw-bold">
                      {TimetableLabels.EXAM_CENTER}&nbsp;
                      <span className="redColor">*</span>
                    </label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        name="examCenter"
                        value={examCenter}
                        defaultValue={examCenter}
                        ref={register({ required: true })}
                        onInput={(e) => {
                          handleExamCenterChange(e);
                        }}
                      >
                        <option key={0} value="">
                          {commonLabels.COMBO_SELECT}
                        </option>
                        {getExamCenterList &&
                          getExamCenterList.length > 0 &&
                          getExamCenterList.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    {_.get("examCenter.type", errors) === "required" && (
                      <p className="errorText float-start mt-n4">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div>

                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">
                      {TimetableLabels.SELECT_VENUE}
                      <span className="errorText">*</span>
                    </label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        name="selectedVenue"
                        value={selectedVenue}
                        defaultValue={selectedVenue}
                        onInput={(e) => {
                          setSelectedVenue(e.target.value);
                        }}
                        ref={register({ required: true })}
                      >
                        <option key={0} value="">
                          {commonLabels.COMBO_SELECT}
                        </option>
                        {getVenueDetailsList &&
                          getVenueDetailsList.map((ele, ind) => {
                            return (
                              <option key={ind++} value={ele.venueId}>
                                {ele.venueName}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {_.get("selectedVenue.type", errors) === "required" && (
                      <p className="errorText float-start mt-n4">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div>

                  <div className="col-md-8 col-lg-4">
                    <div className="row mt27">
                      <div className="col-md-6 col-sm-12">
                        <button
                          type="button"
                          className=" btn btn-primary custom_button  btn-sm w-100  "
                          disabled={!examCenter}
                          onClick={(e) => {
                            deleteCenterWiseTemplateList();
                          }}
                        >
                          {candidateManagementLabels.QUALIFICATION_INFO.DELETE}
                        </button>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <button
                          type="button"
                          onClick={resetCenterAction}
                          className="btn btn-outline-secondary btn-sm w-100"
                        >
                          {candidateManagementLabels.RESET}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={stepName === "5" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"}
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div
                className="tab-content border border-light"
                id="configTabContent"
              >
                <div className="row">
                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">{TimetableLabels.SELECT_EXAM_TEMPLATE}<span className="errorText">*</span></label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        name="templateIdForNotification"
                        value={templateIdForNotification}
                        defaultValue={templateIdForNotification}
                        onInput={(e) => {
                          handleTemplateIdForNotification(e);
                        }}
                        ref={register({ required: true })}
                      >
                        <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                        {getExamTemplateListForImportAdmitCardCsv &&
                          getExamTemplateListForImportAdmitCardCsv.length > 0 &&
                          getExamTemplateListForImportAdmitCardCsv
                            .sort((a, b) => {
                              return Number(a.sortOrder) - Number(b.sortOrder);
                            })
                            .map((ele, ind) => {
                              return (
                                <option key={ind++} value={ele.id}>
                                  {ele.label}
                                </option>
                              );
                            })}
                      </select>
                    </div>
                    {_.get("templateIdForNotification.type", errors) === "required" && (
                      <p className="errorText float-start mt-n4">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div>
                  <div className='col-md-4 mt-2'>
                    <label className="fw-bold">{venueLabels.SELECT_EXAM_DATE}</label>
                    <Controller
                      name="examDateForNotification"
                      key={examDateForNotification && examDateForNotification ? "examDateForNotification" : "examDateForNotification1"}
                      defaultValue={examDateForNotification && examDateForNotification ? dayjs(examDateForNotification).toDate() : ""}
                      control={control}
                      render={({ onChange, value }) => (
                        <div className="date-picker-container">
                          <DatePicker
                            selected={examDateForNotification ? getFormattedDate(value) : ''}
                            showMonthDropdown
                            showYearDropdown
                            placeholderText={commonLabels.COMMON.DATE_FORMAT}
                            dateFormat={commonLabels.COMMON.SMALL_SIZE_DATE_FORMAT}
                            onChange={(e) => {
                              setExamDateForNotification(toUTCDate(e));
                              onChange(toUTCDate(e));
                            }}
                            showIcon
                            minDate={new Date()}
                            className="form-control bg-color ps-2"
                            icon={
                              <img
                                src="/icons/calender.png"
                                className="date-picker-icon"
                              ></img>
                            }
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="fw-bold">{TimetableLabels.EXAM_CENTER}
                    </label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        name="examCenterIdForNotification"
                        value={examCenterIdForNotification}
                        ref={register({ required: false })}
                        onInput={(e) => {
                          handleExamCenterIdForNotification(e);
                        }}
                      >
                        <option key={0} value="">
                          {commonLabels.COMBO_SELECT}
                        </option>
                        {getExamCenterList &&
                          getExamCenterList.length > 0 &&
                          getExamCenterList.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">{TimetableLabels.SELECT_VENUE}</label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        id="venueIdForNotification"
                        name="venueIdForNotification"
                        value={venueIdForNotification}
                        onInput={(e) => {
                          setVenueIdForNotification(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {commonLabels.COMBO_SELECT}
                        </option>
                        {getApprovedVenueDetailsList &&
                          getApprovedVenueDetailsList.map((ele, ind) => {
                            return (
                              <option key={ind++} value={ele.id}>
                                {ele.venuename}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">{TimetableLabels.CANDIDATE_NAME}</label>
                    <div className="input-group bg-color">
                      <input
                        name="candidateNameForNotification"
                        className="form-control"
                        type="text"
                        value={candidateNameForNotification}
                        onChange={(e) => handleCandidateNameChangeForNotification(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">{TimetableLabels.APPLICATION_NO}</label>
                    <div className="input-group bg-color">
                      <input
                        name="applicationNoForNotification"
                        className="form-control"
                        type="text"
                        value={applicationNoForNotification}
                        onChange={(e) => handleApplicationNoChangeForNotification(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">{TimetableLabels.MOBILE_NO}</label>
                    <div className="input-group bg-color">
                      <input
                        name="mobileNoForNotification"
                        className="form-control"
                        type="text"
                        value={mobileNoForNotification}
                        onChange={(e) => handleMobileNoChangeForNotification(e)}
                        maxLength="10"
                      />
                    </div>
                  </div>
                  <div className='col-auto'>
                    <button className='form-control  btn btn-primary custom_button  notificationSearchBtnCss  ' onClick={handleSearchApplicationListClick} disabled={(!templateIdForNotification)}><i className="fa fa-search"></i></button>
                  </div>
                  <div className='col-auto'>
                    <button
                      className=" btn btn-primary custom_button  cursor-pointer mt27  "
                      onClick={() => { handleSendNotificationToAllByTemplateId('', 'sendAll') }}
                      disabled={(!templateIdForNotification)}
                    >
                      {applicationStagesLabels.SEND_ALL}
                    </button>
                  </div>
                </div>
                <hr />
                <div className="card scrollableTable">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        {applicationStagesLabels.ApplicationListHeader.map((itm, ind) => {
                          return (<>
                            {(itm == "" && ind !== 3) ? <th key={ind} className='text-center w-90 theadBgColor'>{itm}</th> : (ind === 0) ? <th key={ind} className='text-center theadBgColor'>{itm}</th> : (ind === 1 || ind === 2) ? <th key={ind} className='text-left theadBgColor' >{itm}</th> : ind === 3 ? <th key={ind} className='text-center theadBgColor'>{
                              // (getapplicationList && getapplicationList.length > 0) && <input type="checkbox" className="me-3"/>
                              <button
                                className="btn btn-sm btn-primary cursor-pointer me-n3"
                                onClick={() => { onApplicationSelect('', 'sendAll') }}
                                disabled={(getapplicationList && getapplicationList.length > 0) ? false : true}
                              >
                                {applicationStagesLabels.SEND_ALL}
                              </button>
                            }<span className="me-4">{itm}</span></th> : <th key={ind} className='text-center' >{itm}</th>}
                          </>
                          );
                        }
                        )}
                      </tr>
                    </thead>
                    <tbody className="f12">
                      {getapplicationList && getapplicationList.length > 0 ? (
                        getapplicationList.map(
                          (ele, i) => {
                            if (ele) {
                              return (
                                <tr>
                                  <td className="word-break text-center">
                                    {++i}
                                  </td>
                                  <td className="word-break text-left">
                                    {ele && ele.applicationNo
                                      ? ele.applicationNo
                                      : ""}
                                  </td>
                                  <td className="word-break text-left">
                                    {ele &&
                                      ele.candidateName
                                      ? ele.candidateName
                                      : ""}
                                  </td>
                                  <td className="text-center">
                                    <div className='position-relative'>
                                      {/* <input
                                        type="checkbox"
                                        className="me-4"
                                        // checked={ele.isChecked}
                                        // onChange={(event) => handleChange(ele.id, event.target.checked, false, false)}
                                    /> */}
                                      <button
                                        className="btn btn-sm btn-primary cursor-pointer"
                                        onClick={() => { onApplicationSelect(ele, '') }}
                                      >
                                        {applicationStagesLabels.SEND}
                                      </button>
                                    </div>
                                  </td>

                                </tr>
                              );
                            }
                          }
                        )
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            {docLabels.NO_DATA}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {getSearchAdmitCardListDetails &&
                    getSearchAdmitCardListDetails.candidateResponseDtos &&
                    getSearchAdmitCardListDetails.candidateResponseDtos.length >
                    0 && (
                      <TablePagination
                        paginationFor="admit_card_search_list"
                        rowPerPage={admitCardStageSearchRowPerPage}
                        totalCount={
                          getSearchAdmitCardListDetails &&
                          getSearchAdmitCardListDetails.count
                        }
                        advid={props.adverId}
                        searchCode2={admitCardSearchData}
                      />
                    )}
                </div>
              </div>
            </div>
            <div
              className={stepName === "6" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"}
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div
                className="tab-content border border-light"
                id="configTabContent"
              >
                <div className="row">
                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">{TimetableLabels.SELECT_EXAM_TEMPLATE}
                    </label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        name="templateIdForReport"
                        value={templateIdForReport}
                        defaultValue={templateIdForReport}
                        onInput={(e) => {
                          handleTemplateIdForReport(e);
                        }}
                      // ref={register({ required: true })}
                      >
                        <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                        {getExamTemplateListForImportAdmitCardCsv &&
                          getExamTemplateListForImportAdmitCardCsv.length > 0 &&
                          getExamTemplateListForImportAdmitCardCsv
                            .sort((a, b) => {
                              return Number(a.sortOrder) - Number(b.sortOrder);
                            })
                            .map((ele, ind) => {
                              return (
                                <option key={ind++} value={ele.id}>
                                  {ele.label}
                                </option>
                              );
                            })}
                      </select>
                    </div>
                  </div>
                  <div className='col-md-4 mt-2'>
                    <label className="fw-bold">{venueLabels.SELECT_EXAM_DATE}<span className="errorText">*</span></label>
                    <Controller
                      name="examDateForReport"
                      key={examDateForReport && examDateForReport ? "examDateForReport" : "examDateForReport1"}
                      defaultValue={examDateForReport && examDateForReport ? dayjs(examDateForReport).toDate() : ""}
                      control={control}
                      render={({ onChange, value }) => (
                        <div className="date-picker-container">
                          <DatePicker
                            selected={examDateForReport ? getFormattedDate(value) : ''}
                            showMonthDropdown
                            showYearDropdown
                            placeholderText={commonLabels.COMMON.DATE_FORMAT}
                            dateFormat={commonLabels.COMMON.SMALL_SIZE_DATE_FORMAT}
                            onChange={(e) => {
                              setExamDateForReport(toUTCDate(e));
                              onChange(toUTCDate(e));
                            }}
                            // minDate={new Date()}
                            className="form-control bg-color ps-2"
                            showIcon
                            icon={
                              <img
                                src="/icons/calender.png"
                                className="date-picker-icon"
                              ></img>
                            }
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="fw-bold">{TimetableLabels.EXAM_CENTER}<span className="errorText">*</span></label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        name="examCenterIdForReport"
                        value={examCenterIdForReport}
                        onInput={(e) => {
                          handleExamCenterIdForReport(e);
                        }}
                      >
                        <option key={0} value="">
                          {commonLabels.COMBO_SELECT}
                        </option>
                        {getExamCenterList &&
                          getExamCenterList.length > 0 &&
                          getExamCenterList.map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="text-left fw-bold">{TimetableLabels.SELECT_VENUE}</label>
                    <div className="input-group bg-color">
                      <select
                        className="form-select bg-color"
                        id="venueIdForReport"
                        name="venueIdForReport"
                        value={venueIdForReport}
                        onInput={(e) => {
                          setVenueIdForReport(e.target.value);
                        }}
                      >
                        <option key={0} value="">
                          {commonLabels.COMBO_SELECT}
                        </option>
                        {getApprovedVenueDetailsList &&
                          getApprovedVenueDetailsList.map((ele, ind) => {
                            return (
                              <option key={ind++} value={ele.id}>
                                {ele.venuename}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                  <div className='col-md-4 mt-2'>
                    <label className="text-left fw-bold">{TimetableLabels.UPLOAD} {TimetableLabels.FILE}<span className="errorText">*</span></label>
                    <input
                      type="file"
                      accept='.csv'
                      className="bg-color"
                      onChange={(event) => onChangeImage(event)} onClick={handleStaffFileInputClick} ref={(e) => { register({ required: true })(e); fileInputRef.current = e; }}
                    />
                  </div>
                  <div className='col-md-12'>
                    <button
                      className="btn btn-sm btn-primary cursor-pointer ms-3 mt27"
                      onClick={handleUploadExamStaffClick}
                      disabled={(!file) || (!examCenterIdForReport) || (!examDateForReport)}
                    >
                      {applicationStagesLabels.Upload}
                    </button>
                    <button
                      className="btn btn-sm btn-primary cursor-pointer ms-3 mt27"
                      onClick={handleDonwloadExamStaffFile}
                      disabled={(!examCenterIdForReport) || (!examDateForReport)}
                    >
                      {applicationStagesLabels.DOWNLOAD_OBJECTION_REPORT}
                    </button>
                    <button
                      className="btn btn-sm btn-primary cursor-pointer ms-3 mt27"
                      onClick={handleSampleExamStaffFileDownload}
                    >
                      {applicationStagesLabels.DOWNLOAD_SAMPLE_FILE}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "ANSWER_KEY_QUESTION_OBJECTION" && (
        <div
          className="answerKeyQuestionObjectionSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <ul className="nav nav-tabs" id="configTab" role="tablist">
                <li className="nav-item cursor-pointer" key="0">
                  <a
                    className={
                      objectionStep === "objection_configuration"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="uploadTab"
                    onClick={() => {
                      setObjectionStep("objection_configuration");
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>
                      {applicationStagesLabels.ObjectionConfiguration}
                    </span>
                  </a>
                </li>
                <li className={showObjectionAnswerKeyDataTab ? "nav-item cursor-pointer" : "disable-li"} key="1">
                  <a
                    className={
                      objectionStep === "objection_answer_key_data"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="downloadTab"
                    onClick={handleObjectionAnswerKeyDataStage}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{applicationStagesLabels.ObjectionAnwerKeyData}</span>
                  </a>
                </li>
                <li className={showObjectionAnswerKeyDataTab ? "nav-item cursor-pointer" : "disable-li"} key="2">
                  <a
                    className={
                      objectionStep === "objection_files"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="downloadTab"
                    onClick={handleObjectionFileStage}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{applicationStagesLabels.ObjectionFiles}</span>
                  </a>
                </li>
              </ul>
              <div
                className="tab-content border border-light"
                id="configTabContent"
              >
                <div
                  className={
                    objectionStep === "objection_configuration"
                      ? "tab-pane show active tabContentHeaderCss"
                      : "tab-pane fade tabContentHeaderCss"
                  }
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="border border-light w-100 p-1">
                    <div className="stageConfigAddForm">
                      <div className="row">
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.PostName}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="postCriteriaName"
                              value={postCriteriaId}
                              onChange={(event) => onChangePostCriteria(event)}
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {advertisementDetails &&
                                advertisementDetails.examPostList &&
                                advertisementDetails.examPostList.length > 0 &&
                                advertisementDetails.examPostList.map(
                                  (item, i) => {
                                    return (
                                      <option
                                        key={i}
                                        value={item.postCriteria.id}
                                      >
                                        {item.postCriteria.name}-
                                        {item.postCriteria.nameDvng}
                                      </option>
                                    );
                                  }
                                )}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.ExamName}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="examName"
                              value={selectedExam}
                              defaultValue={selectedExam}
                              onChange={handleExamChange}
                            >
                              <option key={0} value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getActiveExamListData &&
                                getActiveExamListData.length > 0 &&
                                getActiveExamListData.map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.SubjectName}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="subjectName"
                              value={subjectId}
                              onChange={(event) =>
                                setSubjectId(event.target.value)
                              }
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {allSubjectsList &&
                                allSubjectsList.examSubjects &&
                                allSubjectsList.examSubjects.length > 0 &&
                                allSubjectsList.examSubjects.map((item, i) => {
                                  return (
                                    <option key={i} value={item.id}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.StartDate}{" "}
                            <span className="redColor">*</span>
                          </label>
                          {selectedPostStartDate ? (
                            <Controller
                              name="postStartDate"
                              key="postStartDate"
                              defaultValue={selectedPostStartDate}
                              control={control}
                              render={({ onChange }) => (
                                <div className="date-picker-container">
                                  <DatePicker
                                    selected={selectedPostStartDate}
                                    onChange={(e) => {
                                      onchangePostStartDate(toUTCDate(e));
                                      onChange(toUTCDate(e));
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    placeholderText={
                                      applicationStagesLabels.DatePlaceHolder
                                    }
                                    dateFormat={
                                      applicationStagesLabels.dateFormat
                                    }
                                    className="form-control bg-color ps-2"
                                    showIcon
                                    icon={
                                      <img src="/icons/calender.png" className="date-picker-icon"></img>
                                    }
                                  />
                                </div>
                              )}
                            />
                          ) : (
                            <Controller
                              name="postStartDate"
                              key="postStartDate"
                              defaultValue=""
                              control={control}
                              render={({ onChange, value }) => (
                                <div className="date-picker-container">
                                  <DatePicker
                                    selected=""
                                    onChange={(e) => {
                                      onchangePostStartDate(toUTCDate(e));
                                      onChange(toUTCDate(e));
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    placeholderText={
                                      applicationStagesLabels.DatePlaceHolder
                                    }
                                    dateFormat={
                                      applicationStagesLabels.dateFormat
                                    }
                                    className="form-control bg-color ps-2"
                                    showIcon
                                    icon={
                                      <img src="/icons/calender.png" className="date-picker-icon"></img>
                                    }
                                  />
                                </div>
                              )}
                            />
                          )}
                        </div>
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.EndDate}{" "}
                            <span className="redColor">*</span>
                          </label>
                          {selectedPostEndDate ? (
                            <Controller
                              name="postEndDate"
                              key="postEndDate"
                              defaultValue={selectedPostEndDate}
                              control={control}
                              render={({ onChange }) => (
                                <div className="date-picker-container">
                                  <DatePicker
                                    selected={selectedPostEndDate}
                                    minDate={selectedPostStartDate}
                                    onChange={(e) => {
                                      onchangePostEndDate(toUTCDate(e));
                                      onChange(toUTCDate(e));
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    placeholderText={
                                      applicationStagesLabels.DatePlaceHolder
                                    }
                                    dateFormat={
                                      applicationStagesLabels.dateFormat
                                    }
                                    className="form-control bg-color ps-2"
                                    showIcon
                                    icon={
                                      <img src="/icons/calender.png" className="date-picker-icon"></img>
                                    }
                                  />
                                </div>
                              )}
                            />
                          ) : (
                            <Controller
                              name="postEndDate"
                              key="postEndDate"
                              defaultValue=""
                              control={control}
                              render={({ onChange, value }) => (
                                <div className="date-picker-container">
                                  <DatePicker
                                    selected=""
                                    minDate={selectedPostStartDate}
                                    onChange={(e) => {
                                      onchangePostEndDate(toUTCDate(e));
                                      onChange(toUTCDate(e));
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    placeholderText={
                                      applicationStagesLabels.DatePlaceHolder
                                    }
                                    dateFormat={
                                      applicationStagesLabels.dateFormat
                                    }
                                    className="form-control bg-color ps-2"
                                    showIcon
                                    icon={
                                      <img src="/icons/calender.png" className="date-picker-icon"></img>
                                    }
                                  />
                                </div>
                              )}
                            />
                          )}
                        </div>
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.OnlinePaymentEndDate}{" "}
                            <span className="redColor">*</span>
                          </label>
                          {selectedPaymentEndDate ? (
                            <Controller
                              name="paymentEndDate"
                              key="paymentEndDate"
                              defaultValue={selectedPaymentEndDate}
                              control={control}
                              render={({ onChange }) => (
                                <div className="date-picker-container">
                                  <DatePicker
                                    selected={selectedPaymentEndDate}
                                    minDate={selectedPostStartDate}
                                    onChange={(e) => {
                                      onchangePaymentEndDate(toUTCDate(e));
                                      onChange(toUTCDate(e));
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    placeholderText={
                                      applicationStagesLabels.DatePlaceHolder
                                    }
                                    dateFormat={
                                      applicationStagesLabels.dateFormat
                                    }
                                    className="form-control bg-color ps-2"
                                    showIcon
                                    icon={
                                      <img src="/icons/calender.png" className="date-picker-icon"></img>
                                    }
                                  />
                                </div>
                              )}
                            />
                          ) : (
                            <Controller
                              name="paymentEndDate"
                              key="paymentEndDate"
                              defaultValue=""
                              control={control}
                              render={({ onChange, value }) => (
                                <div className="date-picker-container">
                                  <DatePicker
                                    selected=""
                                    minDate={selectedPostStartDate}
                                    onChange={(e) => {
                                      onchangePaymentEndDate(toUTCDate(e));
                                      onChange(toUTCDate(e));
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    placeholderText={
                                      applicationStagesLabels.DatePlaceHolder
                                    }
                                    dateFormat={
                                      applicationStagesLabels.dateFormat
                                    }
                                    className="form-control bg-color ps-2"
                                    showIcon
                                    icon={
                                      <img src="/icons/calender.png" className="date-picker-icon"></img>
                                    }
                                  />
                                </div>
                              )}
                            />
                          )}
                        </div>
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.QuestionPaperSet}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="quePaperSet"
                              value={quePaperSet}
                              onChange={(event) =>
                                setQuePaperSet(event.target.value)
                              }
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getExamPaperSet && getExamPaperSet.lookupOptionDtoList &&
                                getExamPaperSet.lookupOptionDtoList.length > 0 &&
                                getExamPaperSet.lookupOptionDtoList
                                  .sort((a, b) => {
                                    return Number(a.sortOrder) - Number(b.sortOrder);
                                  })
                                  .map((ele, ind) => {
                                    return (
                                      <option key={ind++} value={ele.id}>
                                        {ele.label}
                                      </option>
                                    );
                                  })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.NoOfQuestions}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <input
                              type="number"
                              min="1"
                              className="form-control"
                              name="noOfQuestions"
                              value={noOfQuestions}
                              onChange={(event) => {
                                const value = Math.min(
                                  event.target.value,
                                  getExamPaperQuestionsLimit && getExamPaperQuestionsLimit.lookupOptionDtoList &&
                                  getExamPaperQuestionsLimit.lookupOptionDtoList[0].label
                                );
                                setNoOfQuestions(value);
                                setSelectedCheckboxes(
                                  Array.from(
                                    { length: value },
                                    (_, index) => index + 1
                                  )
                                );
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 mt-4">
                          <label className="fw-bold">
                            {applicationStagesLabels.IsActive}{" "}
                          </label>
                          <input
                            className="float-start text-left mt-1 me-1"
                            type="checkbox"
                            name="isActive"
                            checked={isActive ? true : false}
                            onChange={(e) => setIsActive(e.target.checked)}
                            ref={register({})}
                          // defaultChecked={isActive?true:false}
                          />
                        </div>
                        {noOfQuestions > 0 && (
                          <div className="col-md-12 mt-2">
                            <div className="d-flex align-items-center">
                              <a
                                className="btn btn-sm btn-primary cursor-pointer"
                                onClick={() => setSelectedCheckboxes([])}
                              >
                                {applicationStagesLabels.RemoveAll}
                              </a>
                              <a
                                className="btn btn-sm btn-primary cursor-pointer ms-1"
                                onClick={selectAllCheckboxes}
                              >
                                {applicationStagesLabels.SelectAll}
                              </a>
                              <div className="ms-2">
                                <p className="mb-0 text-danger">
                                  {" "}
                                  {applicationStagesLabels.Note}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                        <div
                          className="col-md-12 mt-2 questionsCss"
                        >
                          <div className="d-flex flex-wrap">
                            {Array.from(
                              { length: parseInt(noOfQuestions) },
                              (_, index) => (
                                <div
                                  key={index}
                                  className="mb-3 d-flex align-items-center w20"
                                >
                                  <input
                                    type="checkbox"
                                    className="me-1"
                                    checked={selectedCheckboxes.includes(
                                      index + 1
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(index + 1)
                                    }
                                  />
                                  <label className="ms-1">
                                    {applicationStagesLabels.QuestionNo}{" "}
                                    {index + 1}
                                  </label>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 mt-2 mb-3">
                          <a
                            className="btn btn-sm btn-primary cursor-pointer"
                            onClick={() =>
                              handleAddMoreDetails(
                                props.stageId,
                                props.currentStageData
                              )
                            }
                          >
                            {isEditObjectionStageConfigId !== ""
                              ? TimetableLabels.UPDATE_DETAILS
                              : TimetableLabels.ADD_MORE_DETAILS}
                          </a>
                        </div>
                        {renderSaveButton && (
                          <div className="col-md-6 mt-2 mb-3 text-end">
                            <a
                              className="btn btn-sm btn-primary cursor-pointer"
                              onClick={() => {
                                handleSaveObjectionData(
                                  props.stageId,
                                  props.currentStageData
                                );
                                setIsSaveButtonRendered(true);
                              }}
                            >
                              {applicationStagesLabels.Save}
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                    {allStageConfigList &&
                      allStageConfigList.advertisementStageDtoList &&
                      allStageConfigList.advertisementStageDtoList.length > 0 &&
                      allStageConfigList.advertisementStageDtoList
                        .filter((item) => item.stage.id === props.stageId)
                        .map((item, index) => {
                          if (
                            index === 0 &&
                            item.masterAdvertisementStageObjectionDto &&
                            item.masterAdvertisementStageObjectionDto
                              .advertisementStageObjectionsDtoList &&
                            item.masterAdvertisementStageObjectionDto
                              .advertisementStageObjectionsDtoList.length > 0
                          ) {
                            return (
                              <div className="stageConfigList " key={0}>
                                <table className="table table-bordered ">
                                  <thead>
                                    <tr>
                                      {objectionListHeader &&
                                        objectionListHeader.map((itm, ind) => {
                                          return (
                                            <th
                                              key={ind}
                                              className="text-center theadBgColor"
                                            >
                                              {itm}
                                            </th>
                                          );
                                        })}
                                    </tr>
                                  </thead>
                                  <tbody className="f12">
                                    {item.masterAdvertisementStageObjectionDto.advertisementStageObjectionsDtoList.map(
                                      (item, index) => (
                                        <tr key={index}>
                                          <td className="word-break text-center">
                                            {index + 1}
                                          </td>
                                          {item.advertisementStage
                                            .postCriteriaId != "" &&
                                            item.advertisementStage
                                              .postCriteriaId != null &&
                                            item.advertisementStage
                                              .postCriteriaId != undefined && (
                                              <td className="word-break ">
                                                {item.examPostName}
                                                <br />
                                              </td>
                                            )}
                                          {item.advertisementStage
                                            .postCriteriaId != "" &&
                                            item.advertisementStage
                                              .postCriteriaId != null &&
                                            item.advertisementStage
                                              .postCriteriaId != undefined && (
                                              <td className="word-break ">
                                                {item.examName}
                                                <br />
                                              </td>
                                            )}
                                          {item.advertisementStage
                                            .examSubjectId != "" &&
                                            item.advertisementStage
                                              .examSubjectId != null &&
                                            item.advertisementStage
                                              .examSubjectId != undefined && (
                                              <td className="word-break ">
                                                {item.examSubjectName}
                                                <br />
                                              </td>
                                            )}
                                          <td className="word-break text-center">
                                            {item.examPaperSetName}
                                            <br />
                                          </td>
                                          <td className="w-10 word-break ">
                                            {item.advertisementStage.startDate
                                              ? dayjs(
                                                getFormattedDate(
                                                  new Date(
                                                    item.advertisementStage.startDate
                                                  )
                                                )
                                              ).format(
                                                applicationStagesLabels.DatePlaceHolder
                                              )
                                              : ""}
                                          </td>
                                          <td className="w-10 word-break ">
                                            {item.advertisementStage.endDate
                                              ? dayjs(
                                                getFormattedDate(
                                                  new Date(
                                                    item.advertisementStage.endDate
                                                  )
                                                )
                                              ).format(
                                                applicationStagesLabels.DatePlaceHolder
                                              )
                                              : ""}
                                          </td>
                                          <td className="word-break ">
                                            {item.advertisementStage
                                              .onlinePaymentEndDate
                                              ? dayjs(
                                                getFormattedDate(
                                                  new Date(
                                                    item.advertisementStage.onlinePaymentEndDate
                                                  )
                                                )
                                              ).format(
                                                applicationStagesLabels.DatePlaceHolder
                                              )
                                              : ""}
                                          </td>
                                          <td className="word-break ">
                                            {item.objectionQuestions}
                                            <br />
                                          </td>
                                          <td className="word-break ">
                                            {item.objectionExcludeQuestions}
                                            <br />
                                          </td>
                                          <td className="w-10 word-break ">
                                            <i
                                              role="button"
                                              data-toggle="tooltip"
                                              title={commonLabels.BUTTON_EDIT}
                                              className="text-primary fa fa-edit"
                                              onClick={() => {
                                                onEditObjectionStageConfig(
                                                  item,
                                                  index
                                                );
                                              }}
                                            ></i>
                                            &nbsp;&nbsp;
                                            <i
                                              role="button"
                                              data-toggle="tooltip"
                                              title={
                                                item.isActive
                                                  ? commonLabels.BUTTON_INACTIVE
                                                  : commonLabels.BUTTON_ACTIVE
                                              }
                                              className={
                                                item.isActive === true
                                                  ? "text-success fa fa-toggle-on ms-2"
                                                  : "text-danger fa fa-toggle-off ms-2"
                                              }
                                              onClick={(e) => {
                                                activeObjectionStageConfig(
                                                  item,
                                                  item.isActive,
                                                  index
                                                );
                                              }}
                                            ></i>
                                            &nbsp;&nbsp;
                                            <i
                                              role="button"
                                              data-toggle="tooltip"
                                              title={commonLabels.BUTTON_DELETE}
                                              className="text-danger fa fa-trash ms-2"
                                              onClick={(e) => {
                                                manageObjectionStageConfigData(
                                                  item,
                                                  index
                                                );
                                              }}
                                            ></i>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                  </div>
                </div>
                <div
                  className={
                    objectionStep === "objection_answer_key_data"
                      ? "tab-pane show active tabContentHeaderCss"
                      : "tab-pane fade tabContentHeaderCss"
                  }
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="border border-light w-100 p-1">
                    <div className="stageConfigAddForm">
                      <div className="row ">
                        <div className="col-md-12 mt-2 col-lg-4">
                          <label className="fw-bold">
                            {applicationStagesLabels.ExamName}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="examName"
                              value={objectionExamId}
                              defaultValue={objectionExamId}
                              onChange={handleObjectionExamChange}
                              ref={register({ required: true })}
                            >
                              <option key={0} value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getActiveExamListData &&
                                getActiveExamListData.length > 0 &&
                                getActiveExamListData.map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {_.get("examName.type", errors) === "required" && (
                            <p className="errorText float-start ms-1 mt-n4">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div>
                        <div className="col-md-12 mt-2 col-lg-4">
                          <label className="fw-bold">
                            {applicationStagesLabels.ExamSubject}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="examSubject"
                              value={objectionExamSubjectId}
                              onChange={(event) =>
                                setObjectionExamSubjectId(event.target.value)
                              }
                              ref={register({ required: true })}
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getExamSubjectsForObjection &&
                                getExamSubjectsForObjection.length > 0 &&
                                getExamSubjectsForObjection.map((item, i) => {
                                  return (
                                    <option key={i} value={item.id}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                          {_.get("examSubject.type", errors) === "required" && (
                            <p className="errorText float-start ms-1 mt-n4">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div>
                        <div className="col-md-12 col-lg-4">
                          <label className="fw-bold">
                            {applicationStagesLabels.UploadMasterKey}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <input
                            name="file"
                            type="file"
                            accept=".csv"
                            onChange={(event) => onObjectionFileChange(event)}
                            onClick={handleInputClick}
                            ref={(e) => { register({ required: true })(e); objectionAnswerKeyfileInputRef.current = e; }}
                            className="bg-color"
                          />
                          {_.get("file.type", errors) === "required" && (
                            <p className="errorText float-start ms-1">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div>
                        <div className="col-md-4">
                          <button
                            type="button"
                            className="  btn btn-primary custom_button  btn-sm cursor-pointer ms-2 pt-1 pb-1  "
                            onClick={handleSubmit((e) => {
                              uploadFile(e);
                            })}
                          >
                            {applicationStagesLabels.Upload}
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr />
                    {getObjectionAnsweKeyDataList &&
                      getObjectionAnsweKeyDataList.length > 0 ? (
                      <div className="">
                        <table className="table table-bordered table-sm mt-5">
                          <thead>
                            <tr>
                              {applicationStagesLabels.ObjectionAnswerKeyDataHeaders.map(
                                (ele, index) => (
                                  <th
                                    scope="col"
                                    key={index}
                                    className={`${ele === "No." || ele === "Action"
                                      ? "text-center theadBgColor"
                                      : "theadBgColor"
                                      }`}
                                  >
                                    {ele}
                                  </th>
                                )
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {getObjectionAnsweKeyDataList &&
                              getObjectionAnsweKeyDataList.map((ele, i) => {
                                if (ele) {
                                  return (
                                    <tr>
                                      <td className="word-break text-center">
                                        {i + 1}
                                      </td>
                                      <td className="word-break">
                                        {" "}
                                        {ele.examName ? ele.examName : "-"}{" "}
                                      </td>
                                      <td className="word-break">
                                        {" "}
                                        {ele.examSubjectName
                                          ? ele.examSubjectName
                                          : "-"}{" "}
                                      </td>
                                      <td className="word-break">
                                        <button
                                          type="button"
                                          className="  btn btn-primary custom_button  btn-sm cursor-pointer  "
                                          onClick={() => {
                                            handleViewAnswerKeyBtnClick(ele);
                                          }}
                                        >
                                          {
                                            applicationStagesLabels.VIEW_ANSWER_KEY
                                          }
                                        </button>
                                      </td>
                                      <td className="word-break text-center">
                                        <i
                                          role="button"
                                          data-toggle="tooltip"
                                          className="fa fa-trash"
                                          title={commonLabels.BUTTON_DELETE}
                                          onClick={(e) => {
                                            handleDeleteClick(ele);
                                          }}
                                        ></i>
                                        <i
                                          role="button"
                                          data-toggle="tooltip"
                                          className="fa fa-download ms-2"
                                          title="Download"
                                          onClick={() => {
                                            handleDownloadClick(ele);
                                          }}
                                        ></i>
                                      </td>
                                    </tr>
                                  );
                                }
                              })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      ""
                    )}
                    {showObjectionAnswerKeyModal && (
                      <ObjectionAnswerKeyDataModal
                        showObjectionAnswerKeyModal={
                          showObjectionAnswerKeyModal
                        } AnswerKe
                        setShowObjectionAnswerKeyModal={
                          setShowObjectionAnswerKeyModal
                        }
                        objectionAnswerKeyModalData={
                          objectionAnswerKeyModalData
                        }
                        setObjectionAnswerKeyModalData={
                          setObjectionAnswerKeyModalData
                        }
                      />
                    )}
                  </div>
                </div>
                <div
                  className={
                    objectionStep === "objection_files"
                      ? "tab-pane show active tabContentHeaderCss"
                      : "tab-pane fade tabContentHeaderCss"
                  }
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="border border-light w-100 p-1">
                    <div className="stageConfigAddForm">
                      <div className="row">
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.SelectSubject}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="objectionFilesSubjectId"
                              value={objectionFilesSubjectId}
                              defaultValue={objectionFilesSubjectId}
                              onChange={(event) => {
                                handleObjectionFileExamChange(
                                  event,
                                  props.stageId
                                );
                              }}
                              disabled={isEditObjectionFileStage ? true : false}
                            >
                              <option key={0} value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getExamSubjectsListForObjectionFile &&
                                getExamSubjectsListForObjectionFile.length > 0 &&
                                getExamSubjectsListForObjectionFile.map(
                                  (element, index) => (
                                    <option key={index} value={element.id}>
                                      {element.name}
                                    </option>
                                  )
                                )}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.SelectQuestion}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="selectObjectionFilesQuestions"
                              value={selectObjectionFilesQuestions}
                              onChange={(event) =>
                                setSelectObjectionFilesQuestions(
                                  event.target.value
                                )
                              }
                              disabled={isEditObjectionFileStage ? true : false}
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getObjectionQuestionsList &&
                                getObjectionQuestionsList.length > 0 &&
                                getObjectionQuestionsList.map((item, i) => {
                                  return (
                                    <option key={i} value={item}>
                                      {item}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.UploadFile}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <input
                            name="objectionFileUploader"
                            type="file"
                            accept="image/*,.jpg,.jpeg,.png,.gif,.bmp"
                            onChange={onFileChange}
                            onClick={handleFileInputClick}
                            className="bg-color"
                          />
                        </div>

                        {objectionFilesUploadedPhoto &&
                          objectionFilesUploadedPhoto.objectionQuestionFile && (
                            <div className="col-md-4 f11">
                              <button
                                type="submit"
                                className="  btn btn-primary custom_button  btn-sm cursor-pointer me-2 pt-1 pb-1 mt-2  "
                                onClick={handleViewUploadedImage}
                              >
                                {applicationStagesLabels.ViewUploadedImage}
                              </button>
                            </div>
                          )}

                        <div className="col-md-4">
                          <button
                            type="button"
                            className="  btn btn-primary custom_button  btn-sm cursor-pointer ms-2 pt-1 pb-1 mt-2  "
                            onClick={() => {
                              addObjectionFileData();
                            }}
                            disabled={
                              props.adverId != null &&
                                props.adverId != "" &&
                                props.adverId != undefined &&
                                objectionFilesSubjectId != null &&
                                objectionFilesSubjectId != "" &&
                                objectionFilesSubjectId != undefined &&
                                selectObjectionFilesQuestions != null &&
                                selectObjectionFilesQuestions != "" &&
                                selectObjectionFilesQuestions != undefined &&
                                objectionFileUploader != null &&
                                objectionFileUploader != "" &&
                                objectionFileUploader != undefined
                                ? false
                                : true
                            }
                          >
                            {commonLabels.BUTTON_SAVE}
                          </button>
                        </div>

                        {tempState && <CommonLoader tempState={tempState} />}

                        <div>
                          <Modal
                            size="lg"
                            show={showObjectionFileImgModal}
                            onHide={cancelObjectionFileImgModal}
                            aria-labelledby="example-modal-sizes-title-lg"
                            backdrop="static"
                          >
                            <Modal.Header className="d-flex justify-content-between align-items-center logout_heading">
                              <Modal.Title> </Modal.Title>
                              <button
                                type="button"
                                className="ms-auto logout_close"
                                aria-label="Close"
                                onClick={cancelObjectionFileImgModal}
                              >X</button>
                            </Modal.Header>

                            <Modal.Body>
                              <img
                                src={
                                  objectionFilesUploadedPhoto &&
                                    objectionFilesUploadedPhoto.objectionQuestionFile
                                    ? `data:image/png;base64, ${objectionFilesUploadedPhoto.objectionQuestionFile}`
                                    : ""
                                }
                                className="w-100 h-100"
                                alt=""
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="image"
                              />
                            </Modal.Body>

                            <Modal.Footer>
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={cancelObjectionFileImgModal}
                              >
                                {commonLabels.BUTTON_CANCEL}
                              </button>
                            </Modal.Footer>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  {getAllObjectionFilesList &&
                    getAllObjectionFilesList.objectionFileList &&
                    getAllObjectionFilesList.objectionFileList.length > 0 &&
                    <>
                      <div>
                        <table className="table table-bordered table-sm" >
                          <thead className="thead-light text-center">
                            <tr>
                              {applicationStagesLabels.ObjectionFileHeaders.map(
                                (ele, index) => (
                                  <th scope="col" className='theadBgColor text-center' key={index}>
                                    {ele}
                                  </th>
                                )
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {getAllObjectionFilesList &&
                              getAllObjectionFilesList.objectionFileList &&
                              getAllObjectionFilesList.objectionFileList.map(
                                (ele, i) => {
                                  if (ele) {
                                    return (
                                      <tr>
                                        <td className="word-break text-center">
                                          {ObjectionFilesTableCounter++}
                                        </td>
                                        <td className="word-break text-center">
                                          {" "}
                                          {ele.examSubjectName
                                            ? ele.examSubjectName
                                            : "-"}{" "}
                                        </td>
                                        <td className="word-break text-center">
                                          {" "}
                                          {ele.questionNo
                                            ? ele.questionNo
                                            : "-"}{" "}
                                        </td>
                                        <td className="text-center">
                                          <i
                                            role="button"
                                            data-toggle="tooltip"
                                            title={commonLabels.BUTTON_EDIT}
                                            className="text-primary fa fa-edit"
                                            onClick={(e) => {
                                              handleObjectionFileEditClick(
                                                ele,
                                                props.stageId
                                              );
                                            }}
                                          ></i>
                                          &nbsp;&nbsp;
                                          <i
                                            role="button"
                                            data-toggle="tooltip"
                                            title={
                                              ele.isActive
                                                ? commonLabels.BUTTON_INACTIVE
                                                : commonLabels.BUTTON_ACTIVE
                                            }
                                            className={
                                              ele.isActive === true
                                                ? "text-success fa fa-toggle-on"
                                                : "text-danger fa fa-toggle-off"
                                            }
                                            onClick={(e) => {
                                              activeObjectionFileStageConfig(
                                                ele,
                                                ele.isActive
                                              );
                                            }}
                                          ></i>
                                          &nbsp;&nbsp;
                                          <i
                                            role="button"
                                            data-toggle="tooltip"
                                            className="fa fa-trash"
                                            title={commonLabels.BUTTON_DELETE}
                                            onClick={(e) => {
                                              deleteObjectionFileStageConfig(ele);
                                            }}
                                          ></i>
                                        </td>
                                      </tr>
                                    );
                                  }
                                }
                              )}
                          </tbody>
                        </table>
                      </div>
                      <TablePagination
                        paginationFor="all_objection_file_list"
                        rowPerPage={rowPerPage}
                        totalCount={getAllObjectionFilesList.count}
                        advid={props.adverId}
                      />
                    </>
                  }
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <ul className="nav nav-tabs" id="configTab" role="tablist">
                <li className="nav-item cursor-pointer" key="0">
                  <a
                    className={
                      objectionContentTab === "objection_report"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="uploadTab"
                    onClick={() => {
                      setObjectionContentTab("objection_report");
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{applicationStagesLabels.OBJECTION_REPORT}</span>
                  </a>
                </li>
                <li className="nav-item cursor-pointer" key="1">
                  <a
                    className={
                      objectionContentTab === "objection_count_report"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="uploadTab"
                    onClick={() => {
                      setObjectionContentTab("objection_count_report");
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>
                      {applicationStagesLabels.OBJECTION_COUNT_REPORT}
                    </span>
                  </a>
                </li>
                <li className="nav-item cursor-pointer" key="2">
                  <a
                    className={
                      objectionContentTab === "objection_attachment_report"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="uploadTab"
                    onClick={() => {
                      setObjectionContentTab("objection_attachment_report");
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>
                      {applicationStagesLabels.OBJECTION_ATTACHMENT_REPORT}
                    </span>
                  </a>
                </li>
              </ul>
              <div
                className="tab-content border border-light"
                id="configTabContent"
              >
                <div
                  className={
                    objectionContentTab === "objection_report"
                      ? "tab-pane show active tabContentHeaderCss"
                      : "tab-pane fade tabContentHeaderCss"
                  }
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="border border-light w-100 p-1">
                    <div className="stageConfigAddForm">
                      <div className="row">
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.ExamName}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="objectionReportExamId"
                              value={objectionReportExamId}
                              defaultValue={objectionReportExamId}
                              onChange={handleObjectionReportExamChange}
                            >
                              <option key={0} value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getAllObjectionReportExamsList &&
                                getAllObjectionReportExamsList.length > 0 &&
                                getAllObjectionReportExamsList.map(
                                  (element, index) => (
                                    <option key={index} value={element.id}>
                                      {element.name}
                                    </option>
                                  )
                                )}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.ExamSubject}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="objectionReportExamSubId"
                              value={objectionReportExamSubId}
                              onChange={(e) => {
                                handleObjectionReportExamSubjectChange(
                                  e,
                                  props.stageId
                                );
                              }}
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getAllObjectionReportExamSubjectsList &&
                                getAllObjectionReportExamSubjectsList.length >
                                0 &&
                                getAllObjectionReportExamSubjectsList.map(
                                  (item, i) => {
                                    return (
                                      <option key={i} value={item.id}>
                                        {item.name}
                                      </option>
                                    );
                                  }
                                )}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.SelectQuestion}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="objectionReportExamSubQueNo"
                              value={objectionReportExamSubQueNo}
                              onChange={handleObjectionReportExamSubQueNoChange}
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getAllObjectionReportExamSubjectQuestionsList &&
                                getAllObjectionReportExamSubjectQuestionsList.length >
                                0 &&
                                getAllObjectionReportExamSubjectQuestionsList.map(
                                  (item, i) => {
                                    return (
                                      <option key={i} value={item}>
                                        {item}
                                      </option>
                                    );
                                  }
                                )}
                            </select>
                          </div>
                        </div>

                        {objectionReportExamId &&
                          objectionReportExamSubId &&
                          objectionReportExamSubQueNo && (
                            <div className="col-md-12 mt-2 float-right">
                              <button
                                type="button"
                                className="btn btn-sm btn-primary me-2"
                                onClick={handleViewReportButtonClick}
                              >
                                {" "}
                                {applicationStagesLabels.VIEW_REPORT}{" "}
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-primary me-2"
                                onClick={handleDownloadReportButtonClick}
                              >
                                {" "}
                                {
                                  applicationStagesLabels.DOWNLOAD_OBJECTION_REPORT
                                }{" "}
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={handleResetButtonClick}
                              >
                                {applicationStagesLabels.RESET}
                              </button>
                              <div className="d-none" ref={pdfRef}>
                                <ObjectionReport />
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    <hr />
                    {getObjectionReportDetails &&
                      getObjectionReportDetails.objectionRequestReportDto &&
                      getObjectionReportDetails.objectionRequestReportDto
                        .objectionRequestsList &&
                      getObjectionReportDetails.objectionRequestReportDto
                        .objectionRequestsList.length > 0 && (
                        <div>
                          <h4>{applicationStagesLabels.QUESTION}</h4>
                          <img
                            src={
                              getObjectionReportDetails &&
                                getObjectionReportDetails.objectionRequestReportDto &&
                                getObjectionReportDetails
                                  .objectionRequestReportDto.objectionQuestionFile
                                ? `data:image/png;base64, ${getObjectionReportDetails.objectionRequestReportDto.objectionQuestionFile}`
                                : ""
                            }
                            className="w-100 h-100 mt-1"
                            alt=""
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="image"
                          />
                          <h4 className="mt-2">
                            {applicationStagesLabels.CANDIDATE_OBJECTION}
                          </h4>
                          {/* <hr/> */}
                          {getObjectionReportDetails &&
                            getObjectionReportDetails.objectionRequestReportDto &&
                            getObjectionReportDetails.objectionRequestReportDto
                              .objectionRequestsList &&
                            getObjectionReportDetails.objectionRequestReportDto
                              .objectionRequestsList.length > 0 ? (
                            <table className="table table-bordered table-sm mt-5">
                              <thead>
                                <tr>
                                  {applicationStagesLabels.ObjectionReportHeaders.map(
                                    (ele, index) => (
                                      <th scope="col" className='theadBgColor' key={index}>
                                        {ele}
                                      </th>
                                    )
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                {getObjectionReportDetails &&
                                  getObjectionReportDetails.objectionRequestReportDto &&
                                  getObjectionReportDetails
                                    .objectionRequestReportDto
                                    .objectionRequestsList &&
                                  getObjectionReportDetails
                                    .objectionRequestReportDto
                                    .objectionRequestsList.length > 0 &&
                                  getObjectionReportDetails.objectionRequestReportDto.objectionRequestsList.map(
                                    (ele, i) => {
                                      if (ele) {
                                        return (
                                          <tr>
                                            <td className="word-break ">
                                              {i + 1}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.applicationNo
                                                ? ele.applicationNo
                                                : "-"}{" "}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.examSubjectName
                                                ? ele.examSubjectName
                                                : "-"}{" "}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.masterQuestionSrno
                                                ? ele.masterQuestionSrno
                                                : "-"}{" "}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.masterKeyAnswer
                                                ? ele.masterKeyAnswer
                                                : "-"}{" "}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.candidateAnswer
                                                ? ele.candidateAnswer
                                                : "-"}{" "}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.objectionRemark
                                                ? ele.objectionRemark
                                                : "-"}{" "}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.referenceBook
                                                ? ele.referenceBook
                                                : "-"}{" "}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.authorName
                                                ? ele.authorName
                                                : "-"}{" "}
                                            </td>
                                            <td className="word-break">
                                              {" "}
                                              {ele.referenceDocument
                                                ? ele.referenceDocument
                                                : "-"}{" "}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    }
                                  )}
                              </tbody>
                            </table>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                  </div>
                </div>
                <div
                  className={
                    objectionContentTab === "objection_count_report"
                      ? "tab-pane show active tabContentHeaderCss"
                      : "tab-pane fade tabContentHeaderCss"
                  }
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div
                    className="tab-content border border-light"
                    id="configTabContent"
                  >
                    <div className="border border-light w-100 p-1">
                      <div className="stageConfigAddForm">
                        <div className="row">
                          <div className="col-md-4 mt-2">
                            <label className="fw-bold">
                              {applicationStagesLabels.OBJECTION_TYPE}{" "}
                              <span className="redColor">*</span>
                            </label>
                            <div className="input-group bg-color">
                              <select
                                className="form-select bg-color"
                                name="objectionReportCountFlg"
                                value={objectionReportCountFlg}
                                defaultValue={objectionReportCountFlg}
                                onChange={(e) => {
                                  handleObjectionCountReportFlgChange(
                                    e.target.value
                                  );
                                }}
                              >
                                <option key={0} value="">
                                  {commonLabels.COMBO_SELECT}
                                </option>
                                {objectionCountReportList &&
                                  objectionCountReportList.map((item, index) => (
                                    <option value={item.val} key={index + 1}>
                                      {item.title}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4 mt-2">
                            <label className="fw-bold">
                              {applicationStagesLabels.ExamName}{" "}
                              <span className="redColor">*</span>
                            </label>
                            <div className="input-group bg-color">
                              <select
                                className="form-select bg-color"
                                name="objectionCountReportExamId"
                                value={objectionCountReportExamId}
                                defaultValue={objectionCountReportExamId}
                                onChange={handleObjectionCountReportExamChange}
                              >
                                <option key={0} value="">
                                  {commonLabels.COMBO_SELECT}
                                </option>
                                {getAllObjectionReportExamsList &&
                                  getAllObjectionReportExamsList.length > 0 &&
                                  getAllObjectionReportExamsList.map(
                                    (element, index) => (
                                      <option key={index} value={element.id}>
                                        {element.name}
                                      </option>
                                    )
                                  )}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4 mt-2">
                            <label className="fw-bold">
                              {applicationStagesLabels.ExamSubject}{" "}
                              <span className="redColor">*</span>
                            </label>
                            <div className="input-group bg-color">
                              <select
                                className="form-select bg-color"
                                name="objectionCountReportExamSubId"
                                value={objectionCountReportExamSubId}
                                defaultValue={objectionCountReportExamSubId}
                                onChange={(e) =>
                                  setObjectionCountReportExamSubId(e.target.value)
                                }
                              >
                                <option key="" value="">
                                  {commonLabels.COMBO_SELECT}
                                </option>
                                {getAllObjectionReportExamSubjectsList &&
                                  getAllObjectionReportExamSubjectsList.length >
                                  0 &&
                                  getAllObjectionReportExamSubjectsList.map(
                                    (item, i) => {
                                      return (
                                        <option key={i} value={item.id}>
                                          {item.name}
                                        </option>
                                      );
                                    }
                                  )}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-12 mt-2 float-right">
                            <button
                              type="button"
                              className="btn btn-sm btn-primary me-2"
                              onClick={
                                handleViewObjectionCountReportButtonClick
                              }
                              disabled={
                                !objectionCountReportExamId ||
                                !objectionCountReportExamSubId ||
                                !objectionReportCountFlg
                              }
                            >
                              {" "}
                              {applicationStagesLabels.VIEW_REPORT}{" "}
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary me-2"
                              onClick={
                                handleDownloadObjectionCountReportButtonClick
                              }
                              disabled={
                                !objectionCountReportExamId ||
                                !objectionCountReportExamSubId ||
                                !objectionReportCountFlg
                              }
                            >
                              {" "}
                              {
                                applicationStagesLabels.DOWNLOAD_OBJECTION_REPORT
                              }{" "}
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              onClick={handleResetObjectionCountButtonClick}
                              disabled={
                                !objectionCountReportExamId ||
                                !objectionCountReportExamSubId ||
                                !objectionReportCountFlg
                              }
                            >
                              {applicationStagesLabels.RESET}
                            </button>
                          </div>
                        </div>
                      </div>
                      <hr />
                      {getObjectionReportCountDetails &&
                        getObjectionReportCountDetails.objectionQuestionCountList &&
                        getObjectionReportCountDetails
                          .objectionQuestionCountList.length > 0 && (
                          <div>
                            {getObjectionReportCountDetails &&
                              getObjectionReportCountDetails.objectionQuestionCountList &&
                              getObjectionReportCountDetails
                                .objectionQuestionCountList.length > 0 ? (
                              <table className="table table-bordered table-sm mt-5">
                                <thead>
                                  {objectionReportCountFlg === "0" ? (
                                    <tr>
                                      <th
                                        scope="col"
                                        key="1"
                                        className="text-center theadBgColor"
                                      >
                                        {" "}
                                        {applicationStagesLabels.QuestionNo}.
                                      </th>
                                      <th
                                        scope="col"
                                        key="2"
                                        className="text-center theadBgColor"
                                      >
                                        {" "}
                                        {applicationStagesLabels.COUNT}{" "}
                                      </th>
                                      <th
                                        scope="col"
                                        key="3"
                                        className="text-center theadBgColor"
                                      >
                                        {" "}
                                        {applicationStagesLabels.PAYMENT}{" "}
                                      </th>
                                    </tr>
                                  ) : (
                                    <tr>
                                      <th
                                        scope="col"
                                        key="1"
                                        className="text-center theadBgColor"
                                      >
                                        {" "}
                                        {applicationStagesLabels.QuestionNo}.
                                      </th>
                                      <th
                                        scope="col"
                                        key="2"
                                        className="text-center theadBgColor"
                                      >
                                        {" "}
                                        {applicationStagesLabels.COUNT}{" "}
                                      </th>
                                    </tr>
                                  )}
                                </thead>
                                <tbody>
                                  {getObjectionReportCountDetails &&
                                    getObjectionReportCountDetails.objectionQuestionCountList &&
                                    getObjectionReportCountDetails
                                      .objectionQuestionCountList.length > 0 &&
                                    getObjectionReportCountDetails.objectionQuestionCountList.map(
                                      (ele, i) => {
                                        if (ele && ele.payment) {
                                          return (
                                            <tr>
                                              <td className="text-center">
                                                {ele.questionNo
                                                  ? ele.questionNo
                                                  : "-"}
                                              </td>
                                              <td className="text-center">
                                                {" "}
                                                {ele.count
                                                  ? ele.count
                                                  : "-"}{" "}
                                              </td>
                                              <td className="text-center">
                                                {" "}
                                                {ele.payment
                                                  ? ele.payment
                                                  : "-"}{" "}
                                              </td>
                                            </tr>
                                          );
                                        } else {
                                          return (
                                            <tr>
                                              <td className="text-center">
                                                {ele.questionNo
                                                  ? ele.questionNo
                                                  : "-"}
                                              </td>
                                              <td className="text-center">
                                                {" "}
                                                {ele.count
                                                  ? ele.count
                                                  : "-"}{" "}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      }
                                    )}
                                  <tr>
                                    <td className="text-center">
                                      <span className="fw-bold">
                                        {applicationStagesLabels.TOTAL}
                                      </span>{" "}
                                      {NoOfQues}
                                    </td>
                                    <td className="text-center">
                                      <span className="fw-bold">
                                        {applicationStagesLabels.TOTAL}
                                      </span>{" "}
                                      {getObjectionReportCountDetails.objectionQuestionCountList.reduce(
                                        (total, ele) =>
                                          total + (ele.count || 0),
                                        0
                                      )}
                                    </td>
                                    {objectionReportCountFlg === "0" && (
                                      <td className="text-center">
                                        <span className="fw-bold">
                                          {applicationStagesLabels.TOTAL}
                                        </span>{" "}
                                        {getObjectionReportCountDetails.objectionQuestionCountList.reduce(
                                          (total, ele) =>
                                            total + (ele.payment || 0),
                                          0
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div
                  className={
                    objectionContentTab === "objection_attachment_report"
                      ? "tab-pane show active tabContentHeaderCss"
                      : "tab-pane fade tabContentHeaderCss"
                  }
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="border border-light w-100 p-1">
                    <div className="stageConfigAddForm">
                      <div className="row">
                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.ExamName}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="objectionAttachmentReportExamId"
                              value={objectionAttachmentReportExamId}
                              onChange={handleObjectionAttachmentReportExamChange}
                            >
                              <option key={0} value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getAllObjectionReportExamsList &&
                                getAllObjectionReportExamsList.length > 0 &&
                                getAllObjectionReportExamsList.map(
                                  (element, index) => (
                                    <option key={index} value={element.id}>
                                      {element.name}
                                    </option>
                                  )
                                )}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.ExamSubject}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="objectionAttachmentReportExamSubId"
                              value={objectionAttachmentReportExamSubId}
                              onChange={(e) => {
                                handleObjectionAttachmentReportExamSubjectChange(
                                  e,
                                  props.stageId
                                );
                              }}
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getAllObjectionReportExamSubjectsList &&
                                getAllObjectionReportExamSubjectsList.length >
                                0 &&
                                getAllObjectionReportExamSubjectsList.map(
                                  (item, i) => {
                                    return (
                                      <option key={i} value={item.id}>
                                        {item.name}
                                      </option>
                                    );
                                  }
                                )}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.SelectQuestion}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="objectionAttachmentReportExamSubQueNo"
                              value={objectionAttachmentReportExamSubQueNo}
                              onChange={(e) => {
                                handleObjectionAttachmentReportExamSubQueNoChange(
                                  e,
                                  props.stageId
                                );
                              }}
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getAllObjectionReportExamSubjectQuestionsList &&
                                getAllObjectionReportExamSubjectQuestionsList.length >
                                0 &&
                                getAllObjectionReportExamSubjectQuestionsList.map(
                                  (item, i) => {
                                    return (
                                      <option key={i} value={item}>
                                        {item}
                                      </option>
                                    );
                                  }
                                )}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 mt-2">
                          <label className="fw-bold">
                            {applicationStagesLabels.SELECT_APP}{" "}
                            <span className="redColor">*</span>
                          </label>
                          <div className="input-group bg-color">
                            <select
                              className="form-select bg-color"
                              name="objectionAttachmentReportAppNo"
                              value={objectionAttachmentReportAppNo}
                              onChange={
                                handleObjectionAttachmentReportApplicationNoChange
                              }
                            >
                              <option key="" value="">
                                {commonLabels.COMBO_SELECT}
                              </option>
                              {getObjectionAttachmentReportApplicationsData &&
                                getObjectionAttachmentReportApplicationsData.length >
                                0 &&
                                getObjectionAttachmentReportApplicationsData.map(
                                  (item, i) => {
                                    return (
                                      <option key={i} value={item}>
                                        {item}
                                      </option>
                                    );
                                  }
                                )}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-12 mt-2 float-right">
                          <button
                            type="button"
                            className="btn btn-sm btn-primary me-2"
                            onClick={
                              handleDownloadAllApplicationsObjectionAttachmentReport
                            }
                            disabled={
                              !objectionAttachmentReportExamId ||
                              !objectionAttachmentReportExamSubId ||
                              !objectionAttachmentReportExamSubQueNo ||
                              objectionAttachmentReportAppNo
                            }
                          >
                            {" "}
                            {
                              applicationStagesLabels.DOWNLOAD_ALL_APPLICATION_OBJECTION_REPORT
                            }{" "}
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary me-2"
                            onClick={handleDownloadObjectionAttachmentReport}
                            disabled={
                              !objectionAttachmentReportExamId ||
                              !objectionAttachmentReportExamSubId ||
                              !objectionAttachmentReportExamSubQueNo ||
                              !objectionAttachmentReportAppNo
                            }
                          >
                            {" "}
                            {
                              applicationStagesLabels.DOWNLOAD_OBJECTION_REPORT
                            }{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "OMR_DISPLAY" && (
        <div
          className="omrDisplaySection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>
              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='theadBgColor text-center'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {/* {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )} */}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {/* <td className="word-break "></td> */}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONTENT}</h5>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "RESULT_MARK_SHEET" && (
        <div
          className="resultMarkSheetSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList ">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='text-center theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {/* {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )} */}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td className="word-break ">
                                        {item.postName}
                                        <br />
                                      </td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td className="word-break ">
                                        {item.examSubjectName}
                                        <br />
                                      </td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="w-10 word-break ">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.PostName}{" "}
                      </label>
                      <div className="input-group bg-color">
                        <select
                          className="form-select bg-color"
                          name="postCriteriaName"
                          value={postCriteriaId}
                          onChange={(event) => onChangePostCriteria(event)}
                        >
                          <option key="" value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {advertisementDetails &&
                            advertisementDetails.examPostList &&
                            advertisementDetails.examPostList.length > 0 &&
                            advertisementDetails.examPostList.map((item, i) => {
                              return (
                                <option key={i} value={item.postCriteria.id}>
                                  {item.postCriteria.name}-
                                  {item.postCriteria.nameDvng}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.SubjectName}{" "}
                      </label>
                      <div className="input-group bg-color">
                        <select
                          className="form-select bg-color"
                          name="subjectName"
                          value={subjectId}
                          onChange={(event) => setSubjectId(event.target.value)}
                        >
                          <option key="" value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allSubjectsList &&
                            allSubjectsList.examSubjects &&
                            allSubjectsList.examSubjects.length > 0 &&
                            allSubjectsList.examSubjects.map((item, i) => {
                              return (
                                <option key={i} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.UPLOAD_AND_DOWNLOAD_MARKSHEET}</h5>
              <div className="d-flex justify-content-center">
                <main
                  role="main"
                  className="col-sm-9 col-md-11 col-lg-12 "
                  id="main_block"
                >
                  <div className="pt-2 pb-2">
                    <div className="float-right pe-1">
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={handledUploadList}
                      >
                        {applicationStagesLabels.UPLOAD_LIST}
                      </button>{" "}
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={downloadTemplate}
                      >
                        {applicationStagesLabels.DOWNLOAD_TEMPLATE}
                      </button>
                    </div>
                  </div>
                </main>
                <ImportDataModal
                  showImportDocList={showImportDocList}
                  setImportDocumentList={setImportDocumentList}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "RETOTALING" && (
        <div
          className="retotalingSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="retotalingTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>

          <div
            className="tab-content border border-light"
            id="retotalingTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              id="configrationTabContent"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList ">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    <tr>
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {
                                          applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                        }
                                      </th>
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Type}
                                      </th>
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    {item.postName != "" &&
                                      item.postName != null &&
                                      item.postName != undefined ? (
                                      <td className="word-break ">
                                        {item.postName}{" "}
                                      </td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectName != "" &&
                                      item.examSubjectName != null &&
                                      item.examSubjectName != undefined ? (
                                      <td className="word-break ">
                                        {item.examSubjectName}
                                      </td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.onlinePaymentEndDate ? (
                                      <td className="word-break ">
                                        {item.onlinePaymentEndDate
                                          ? dayjs(
                                            getFormattedDate(
                                              new Date(
                                                item.onlinePaymentEndDate
                                              )
                                            )
                                          ).format(
                                            applicationStagesLabels.DatePlaceHolder
                                          )
                                          : ""}
                                      </td>
                                    ) : (
                                      ""
                                    )}
                                    {item.type ? (
                                      <td className="word-break ">
                                        {item.type ? "Type " + item.type : ""}
                                      </td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.PostName}{" "}
                      </label>
                      <div className="input-group bg-color">
                        <select
                          className="form-select bg-color"
                          name="postCriteriaName"
                          value={postCriteriaId}
                          onChange={(event) => onChangePostCriteria(event)}
                        >
                          <option key="" value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {advertisementDetails &&
                            advertisementDetails.examPostList &&
                            advertisementDetails.examPostList.length > 0 &&
                            advertisementDetails.examPostList.map((item, i) => {
                              return (
                                <option key={i} value={item.postCriteria.id}>
                                  {item.postCriteria.name}-
                                  {item.postCriteria.nameDvng}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.SubjectName}{" "}
                      </label>
                      <div className="input-group bg-color">
                        <select
                          className="form-select bg-color"
                          name="subjectName"
                          value={subjectId}
                          onChange={(event) => setSubjectId(event.target.value)}
                        >
                          <option key="" value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allSubjectsList &&
                            allSubjectsList.examSubjects &&
                            allSubjectsList.examSubjects.length > 0 &&
                            allSubjectsList.examSubjects.map((item, i) => {
                              return (
                                <option key={i} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.OnlinePaymentEndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPaymentEndDate ? (
                        <Controller
                          name="paymentEndDate"
                          key="paymentEndDate"
                          defaultValue={selectedPaymentEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPaymentEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePaymentEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="paymentEndDate"
                          key="paymentEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePaymentEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.Type}{" "}
                        <span className="redColor">*</span>
                      </label>
                      <div className="input-group bg-color">
                        <select
                          className="form-select bg-color"
                          name="type"
                          value={selectedType}
                          onChange={(e) => {
                            onchangeType(e);
                          }}
                        >
                          {types &&
                            types.map((item, index) => (
                              <option value={item.val} key={index + 1}>
                                {item.title}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active whiteBg" : "tab-pane fade whiteBg"
              }
              id="receivedRequestsTab"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="border border-light w-100 p-1">
                <h5>{applicationStagesLabels.DOWNLOAD_REQUEST}</h5>
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 &&
                  allStageConfigList.advertisementStageDtoList
                    .filter((item) => item.stage.id == props.stageId)
                    .map((item, index) => {
                      if (item.postCriteriaId) {
                        return (
                          <div className="">
                            <table className="table table-bordered">
                              <thead>
                                <tr key={0}>
                                  {applicationStagesLabels.ReceivedRequestHeader.map(
                                    (ele, index) => (
                                      <th scope="col" key={index} className='theadBgColor'>
                                        {ele}
                                      </th>
                                    )
                                  )}
                                </tr>
                              </thead>
                              <tbody className="f12">
                                {advertisementDetails &&
                                  advertisementDetails.examPostList &&
                                  advertisementDetails.examPostList.length > 0 &&
                                  advertisementDetails.examPostList.map(
                                    (item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td className="word-break">
                                            {item.postCriteria.name}
                                          </td>
                                          <td className="word-break ">
                                            {item.postCriteria.nameDvng}{" "}
                                          </td>
                                          <td className="word-break ">
                                            <DataImport
                                              type="retotaling_download"
                                              advtId={props.adverId}
                                              postId={item.postCriteria.id}
                                              download_button_label="Download Retotaling Request"
                                            />
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                              </tbody>
                            </table>
                          </div>
                        );
                      } else {
                        return (
                          <DataImport
                            type="retotaling_download"
                            advtId={props.adverId}
                            postId=""
                            download_button_label="Download Retotaling Request"
                          />
                        );
                      }
                    })}
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "RETOTALING_RESULT" && (
        <div
          className="retotalingResultSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <div className="border border-light w-100 p-1">
            <h5 className="ms-2">{applicationStagesLabels.UPLOAD_RESULT}</h5>
            <DataImport
              type="retotaling_upload"
              advtId={props.adverId}
              upload_button_label="Upload Retotaling Result"
            />
          </div>
        </div>
      )}
      {props.stageCode === "INTERVIEW_LETTER_PT_LETTER" && (
        <div
          className="interviewLetterPTLetterSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {interviewPtLetterHeaderField &&
              interviewPtLetterHeaderField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      handleInterviewAndPtLetterTabClick(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    <tr>
                                      <th scope="col" className="text-center theadBgColor">
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="w13 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="row">
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.PostName}<span className="errorText">*</span></label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      id="interviewPtLetterPostId"
                      name="interviewPtLetterPostId"
                      value={interviewPtLetterPostId}
                      onInput={(e) => {
                        setInterviewPtLetterPostId(e.target.value);
                      }}
                    >
                      <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                      {postNamesData && postNamesData.length > 0 && postNamesData.map((element, index) =>
                        <option key={index} value={element.id}>{element.name}</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.Type}<span className="errorText">*</span></label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      id="interviewPtLettertype"
                      name="interviewPtLettertype"
                      value={interviewPtLettertype}
                      onInput={(e) => {
                        setInterviewPtLettertype(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.COMBO_SELECT}
                      </option>
                      {getScheduleTypeList && getScheduleTypeList.lookupOptionDtoList &&
                        getScheduleTypeList.lookupOptionDtoList.map((ele, ind) => {
                          return (
                            <option key={ind++} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
                <div className='col-md-4 mt-2'>
                  <label className="text-left fw-bold">{TimetableLabels.UPLOAD} {TimetableLabels.FILE}<span className="errorText">*</span></label>
                  <input
                    type="file"
                    accept='.csv'
                    name="interviewCsvfile"
                    className="bg-color"
                    onChange={(event) => onInterviewLetterCsvFileChange(event)} onClick={handleInterviewLetterCsvFileInputClick} ref={(e) => { register({ required: true })(e); interviewCsvfileInputRef.current = e; }}
                  />
                </div>
                <div className='col-md-6'>
                  <button
                    className="btn btn-sm btn-primary cursor-pointer ms-3 mt27"
                    onClick={handleInterviewLetterCsvUploadClick}
                    disabled={(!interviewCsvfile) || (!interviewPtLettertype) || (!interviewPtLetterPostId)}
                  >
                    {applicationStagesLabels.Upload}
                  </button>
                  <button
                    className="btn btn-sm btn-primary cursor-pointer ms-3 mt27"
                    onClick={handleDonwloadInterviewLetterCsvFile}
                    disabled={(!interviewPtLettertype) || (!interviewPtLetterPostId)}
                  >
                    {applicationStagesLabels.DOWNLOAD_OBJECTION_REPORT}
                  </button>
                  <button
                    className="btn btn-sm btn-primary cursor-pointer ms-3 mt27"
                    onClick={handleInterviewLetterCsvFileDownload}
                  >
                    {applicationStagesLabels.DOWNLOAD_SAMPLE_FILE}
                  </button>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "3" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="row">
                <div className='col-md-12 mt-2'>
                  <button
                    className="btn btn-sm btn-primary float-end"
                    type="submit"
                    onClick={handleAddInstructionsBtnClick}
                  >
                    {applicationStagesLabels.ADD_INSTRUCTIONS}
                  </button>
                </div>
              </div>

              {/* <div className="interviewInstructionsCss"> */}
              <div className="">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      {applicationStagesLabels.interviewInstructionsListHeader && applicationStagesLabels.interviewInstructionsListHeader.map((ele, index) =>
                        <th scope="col" key={index} className={(index === 0 || index === 2 || index === 3) ? 'text-center theadBgColor' : 'text-left theadBgColor'}>{ele}</th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="f12">
                    {getInterviewInstructionsList && getInterviewInstructionsList.examInstructionsDtoList && getInterviewInstructionsList.examInstructionsDtoList.length > 0 ? (
                      getInterviewInstructionsList.examInstructionsDtoList.map((ele, index) => (
                        ele ? (
                          <tr key={index}>
                            <td className="word-break text-center">{index + 1}</td>
                            <td className="word-break text-left">{ele.postName}</td>
                            <td className="word-break text-center">{ele.templateLabel}</td>
                            <td className="word-break text-center">
                              <i
                                role="button"
                                data-toggle="tooltip"
                                title={commonLabels.BUTTON_EDIT}
                                className="text-primary fa fa-edit"
                                onClick={(e) => {
                                  handleEditInstructionsBtnClick(
                                    ele
                                  );
                                }}
                              ></i>
                              &nbsp;&nbsp;
                              <i
                                role="button"
                                data-toggle="tooltip"
                                className="fa fa-trash ms-2"
                                title={commonLabels.BUTTON_DELETE}
                                onClick={(e) => {
                                  handleDeleteInstructionsBtnClick(
                                    ele
                                  );
                                }}
                              ></i>
                            </td>
                          </tr>
                        )
                          : null
                      ))
                    )
                      :
                      (
                        <tr>
                          <td colSpan="4" className="text-center">{applicationStagesLabels.NO_DATA_TO_DISPLAY}</td>
                        </tr>
                      )
                    }
                  </tbody>
                </table>
              </div>

              <div className="row" ref={targetRef}>

                <div className="col-md-6 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.PostName}<span className="errorText">*</span></label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      id="interviewPtLetterInstructionsPostId"
                      name="interviewPtLetterInstructionsPostId"
                      value={interviewPtLetterInstructionsPostId}
                      onInput={(e) => {
                        setInterviewPtLetterInstructionsPostId(e.target.value);
                      }}
                    >
                      <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                      {postNamesData && postNamesData.length > 0 && postNamesData.map((element, index) =>
                        <option key={index} value={element.id}>{element.name}</option>
                      )}
                    </select>
                  </div>
                </div>

                <div className="col-md-6 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.Type}<span className="errorText">*</span></label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      id="letterType"
                      name="letterType"
                      value={letterType}
                      onInput={(e) => {
                        setLetterType(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.COMBO_SELECT}
                      </option>
                      {getScheduleTypeList && getScheduleTypeList.lookupOptionDtoList &&
                        getScheduleTypeList.lookupOptionDtoList.map((ele, ind) => {
                          return (
                            <option key={ind++} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>

                <div className="col-md-6 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.SERIAL_NO}<span className="errorText">*</span></label>
                  {/* <input
                    className="form-select"
                    type="text"
                    id="serialNo"
                    name="serialNo"
                    value={serialNo}
                    onInput={(e) => {
                      setSerialNo(e.target.value);
                    }}
                  /> */}
                  <Controller
                    name="serialNo"
                    control={control}
                    key="serialNo"
                    defaultValue={serialNo}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          setSerialNo(e);
                        }}
                        value={serialNo}
                      />
                    )}
                  />
                </div>

                <div className="col-md-6 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.PUB_DATE}<span className="errorText">*</span></label>
                  {/* <input
                    className="form-select"
                    type="text"
                    id="publicationDate"
                    name="publicationDate"
                    value={publicationDate}
                    onInput={(e) => {
                      setpublicationDate(e.target.value);
                    }}
                  /> */}
                  <Controller
                    name="publicationDate"
                    control={control}
                    key="publicationDate"
                    defaultValue={publicationDate}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          setpublicationDate(e);
                        }}
                        value={publicationDate}
                      />
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label className="text-left fw-bold">
                    {TimetableLabels.SIGNATURE}
                  </label>
                  <Controller
                    name="signature"
                    control={control}
                    key="signature"
                    defaultValue={signature}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          if (e.length <= 200) {
                            setSignature(e);
                            setSignatureLengthErr(false);
                          } else {
                            setSignatureLengthErr(true);
                          }
                        }}
                        value={signature}
                      />
                    )}
                  />
                  {signatureLengthErr && (
                    <p className="errorText">
                      {TimetableLabels.MAX_VALUE_FOR_200_CHAR}
                    </p>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="text-left fw-bold">
                    {TimetableLabels.AUTHORITY}
                  </label>
                  <Controller
                    name="authority"
                    control={control}
                    key="authority"
                    defaultValue={authority}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          if (e.length <= 200) {
                            setAuthority(e);
                            setAuthorityLengthErr(false);
                          } else {
                            setAuthorityLengthErr(true);
                          }
                        }}
                        value={authority}
                      />
                    )}
                  />
                  {authorityLengthErr && (
                    <p className="errorText">
                      {TimetableLabels.MAX_VALUE_FOR_200_CHAR}
                    </p>
                  )}
                </div>

                <div className="col-md-12 ">
                  <label className="mt-2 mb-2 fw-bold ms-2">
                    {TimetableLabels.IMPORTANT_INSTRUCTION}
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={impInstruction}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setImpInstruction(data);
                    }}
                  />
                  {/* <CDNCKEditor
                    data={impInstruction}
                    onChange={(newData) => setImpInstruction(newData)}
                  /> */}
                </div>

                <div className="col-md-12 ">
                  <label className="mt-2 mb-2 fw-bold ms-2">
                    {TimetableLabels.INSTRUCTIONS_FOR_CANDIDATE}
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={candidateInstruction}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setCandidateInstruction(data);
                    }}
                  />
                  {/* <CDNCKEditor
                    data={candidateInstruction}
                    onChange={(newData) => setCandidateInstruction(newData)}
                  /> */}
                </div>

                <div className='col-md-6 mt-4'>
                  <button
                    className=" btn btn-primary custom_button   "
                    type="submit"
                    disabled={
                      !candidateInstruction ||
                      !impInstruction ||
                      authorityLengthErr ||
                      signatureLengthErr ||
                      !interviewPtLetterInstructionsPostId ||
                      !letterType ||
                      !serialNo ||
                      !publicationDate
                    }
                    onClick={handleInstructionsSubmit}
                  >
                    {venueLabels.SAVE}
                  </button>
                </div>

              </div>

            </div>
            <div
              className={
                stepName === "4" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="row">
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.PostName}<span className="errorText">*</span></label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      id="interviewPtLetterReportPostId"
                      name="interviewPtLetterReportPostId"
                      value={interviewPtLetterReportPostId}
                      onInput={(e) => {
                        setInterviewPtLetterReportPostId(e.target.value);
                      }}
                    >
                      <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                      {postNamesData && postNamesData.length > 0 && postNamesData.map((element, index) =>
                        <option key={index} value={element.id}>{element.name}</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.Type}<span className="errorText">*</span></label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      id="reportType"
                      name="reportType"
                      value={reportType}
                      onInput={(e) => {
                        setReportType(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.COMBO_SELECT}
                      </option>
                      {getScheduleTypeList && getScheduleTypeList.lookupOptionDtoList &&
                        getScheduleTypeList.lookupOptionDtoList.map((ele, ind) => {
                          return (
                            <option key={ind++} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.INTERVIEW_REPORT_NAME}<span className="errorText">*</span></label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      id="interviewPtLetterReportName"
                      name="interviewPtLetterReportName"
                      value={interviewPtLetterReportName}
                      onInput={(e) => {
                        setInterviewPtLetterReportName(e.target.value);
                      }}
                    >
                      <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                      {getInterviewReportList && getInterviewReportList.lookupOptionDtoList && getInterviewReportList.lookupOptionDtoList.length > 0 && getInterviewReportList.lookupOptionDtoList.map((element, index) =>
                        <option key={index} value={element.label}>{element.label}</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-md-4 mt-1">
                  <button
                    className="btn btn-sm btn-primary cursor-pointer mt-1"
                    onClick={() =>
                      handleDownloadInterviewReportClick()
                    }
                    disabled={(!interviewPtLetterReportName) || (!interviewPtLetterReportPostId) || (!reportType)}
                  >
                    {applicationStagesLabels.DOWNLOAD_OBJECTION_REPORT}
                  </button>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "5" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="row">
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.PostName}<span className="errorText">*</span></label>
                  <select
                    className="form-select"
                    id="interviewPtLetterNotificationPostId"
                    name="interviewPtLetterNotificationPostId"
                    value={interviewPtLetterNotificationPostId}
                    onInput={(e) => {
                      setInterviewPtLetterNotificationPostId(e.target.value);
                    }}
                  >
                    <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                    {postNamesData && postNamesData.length > 0 && postNamesData.map((element, index) =>
                      <option key={index} value={element.id}>{element.name}</option>
                    )}
                  </select>
                  {_.get("interviewPtLetterNotificationPostId.type", errors) === "required" && (
                    <p className="errorText float-start mt-n4">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{applicationStagesLabels.Type}<span className="errorText">*</span></label>
                  <select
                    className="form-select"
                    name="interviewPtLetterTypeForNotification"
                    value={interviewPtLetterTypeForNotification}
                    defaultValue={interviewPtLetterTypeForNotification}
                    onInput={(e) => {
                      handleInterviewPtLetterTypeNotification(e);
                    }}
                    ref={register({ required: true })}
                  >
                    <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                    {getScheduleTypeList && getScheduleTypeList.lookupOptionDtoList &&
                      getScheduleTypeList.lookupOptionDtoList.map((ele, ind) => {
                        return (
                          <option key={ind++} value={ele.id}>
                            {ele.label}
                          </option>
                        );
                      })}
                  </select>
                  {_.get("interviewPtLetterTypeForNotification.type", errors) === "required" && (
                    <p className="errorText float-start mt-n4">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className='col-md-4 mt-2'>
                  <label className="fw-bold">{applicationStagesLabels.INTERVIEW_DATE}</label>
                  <Controller
                    name="interviewDateForNotification"
                    key={interviewDateForNotification && interviewDateForNotification ? "interviewDateForNotification" : "interviewDateForNotification1"}
                    defaultValue={interviewDateForNotification && interviewDateForNotification ? dayjs(interviewDateForNotification).toDate() : ""}
                    control={control}
                    render={({ onChange, value }) => (
                      <DatePicker
                        selected={interviewDateForNotification ? getFormattedDate(value) : ''}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText={commonLabels.COMMON.DATE_FORMAT}
                        dateFormat={commonLabels.COMMON.SMALL_SIZE_DATE_FORMAT}
                        onChange={(e) => {
                          setInterviewDateForNotification(toUTCDate(e));
                          onChange(toUTCDate(e));
                        }}
                        minDate={new Date()}
                        className="form-control"
                      />
                    )}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label className="fw-bold">{TimetableLabels.EXAM_CENTER}
                  </label>
                  <select
                    className="form-select"
                    name="examCenterIdForInterviewPtLetter"
                    value={examCenterIdForInterviewPtLetter}
                    ref={register({ required: false })}
                    onInput={(e) => {
                      handleExamCenterIdForInterviewPtLetterTypeNotification(e);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.examCenterList &&
                      getInterviewPtLetterDropdownValues.examCenterList.length > 0 &&
                      getInterviewPtLetterDropdownValues.examCenterList.map((element, index) => (
                        <option key={index} value={element.id}>
                          {element.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{TimetableLabels.SELECT_VENUE}</label>
                  <select
                    className="form-select"
                    id="venueIdForInterviewPtLetter"
                    name="venueIdForInterviewPtLetter"
                    value={venueIdForInterviewPtLetter}
                    onInput={(e) => {
                      setVenueIdForInterviewPtLetter(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.venueList &&
                      getInterviewPtLetterDropdownValues.venueList.length > 0 &&
                      getInterviewPtLetterDropdownValues.venueList.map((element, index) => (
                        <option key={index} value={element.label}>
                          {element.label}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{TimetableLabels.CANDIDATE_NAME}</label>
                  <input
                    name="candidateNameForInterviewPtLetter"
                    className="form-control"
                    type="text"
                    value={candidateNameForInterviewPtLetter}
                    onChange={(e) => handleCandidateNameChangeForNotificationInterviewPtLetter(e)}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{TimetableLabels.APPLICATION_NO}</label>
                  <input
                    name="applicationNoForInterviewPtLetter"
                    className="form-control"
                    type="text"
                    value={applicationNoForInterviewPtLetter}
                    onChange={(e) => handleApplicationNoChangeForNotificationInterviewPtLetter(e)}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label className="text-left fw-bold">{TimetableLabels.MOBILE_NO}</label>
                  <input
                    name="mobileNoForInterviewPtLetter"
                    className="form-control"
                    type="text"
                    value={mobileNoForInterviewPtLetter}
                    onChange={(e) => handleMobileNoChangeForNotificationInterviewPtLetter(e)}
                    maxLength="10"
                  />
                </div>
                <div className='col-auto'>
                  <button className='form-control btn-primary notificationSearchBtnCss searchBtn' onClick={handleSearchApplicationListForInterviewPtLetterClick} disabled={(!(interviewPtLetterTypeForNotification && interviewPtLetterNotificationPostId))}><i className="fa fa-search"></i></button>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6 mt-2">
                  <span className="RadioText text-left fw-bold" >{applicationStagesLabels.SEND_NOTIFICATION}</span>
                  <div className="radio ms-1">
                    <label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="sendNotificationToAllViaMobile"
                        checked={sendNotificationToAllViaMobile ? true : false}
                        onChange={(e) => setSendNotificationToAllViaMobile(e.target.checked)}
                        ref={register({})}
                      />
                      &nbsp;{applicationStagesLabels.MOBILE}
                    </label>
                  </div>

                  <div className="radio ms-2">
                    <label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="sendNotificationToAllViaEmail"
                        checked={sendNotificationToAllViaEmail ? true : false}
                        onChange={(e) => setSendNotificationToAllViaEmail(e.target.checked)}
                        ref={register({})}
                      />
                      &nbsp;{applicationStagesLabels.EMAIL}
                    </label>
                  </div>
                </div>
                <div className='col-md-6 mt-1'>
                  <button
                    className="btn btn-sm btn-primary cursor-pointer"
                    onClick={() => { handleSendNotificationToAllForInterviewPtLetter('', 'sendAll') }}
                    disabled={(!((interviewPtLetterTypeForNotification && interviewPtLetterNotificationPostId) && (sendNotificationToAllViaMobile || sendNotificationToAllViaEmail)))}
                  >
                    {applicationStagesLabels.SEND_ALL}
                  </button>
                </div>
              </div>
              <hr />
              <div className="card scrollableTable">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      {applicationStagesLabels.InterviewLetterApplicationListHeader.map((itm, ind) => {
                        return (<>
                          {(itm == "" && ind !== 5) ? <th key={ind} className='text-center w-90 theadBgColor'>{itm}</th> : (ind === 0) ? <th key={ind} className='text-center theadBgColor'>{itm}</th> : (ind === 1 || ind === 2) ? <th key={ind} className='text-left theadBgColor' >{itm}</th> :
                            (ind === 3) ?
                              <th key={ind} className='text-center theadBgColor' >
                                {itm}
                                <input
                                  className="radio text-center mt-1 me-1 ms-2"
                                  type="checkbox"
                                  name="isAllCheckedForSendNotificationToAllViaMobile"
                                  checked={isAllCheckedForSendNotificationToAllViaMobile ? true : false}
                                  onChange={(event) => isAllCheckedForSendNotificationToAllViaMobileClick(event.target.checked, "mobile")}
                                  disabled={(applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length === 0) ? true : false}
                                  ref={register({})}
                                />
                              </th>
                              :
                              (ind === 4) ?
                                <th key={ind} className='text-center theadBgColor' >
                                  {itm}
                                  <input
                                    className="radio text-center mt-1 me-1 ms-2"
                                    type="checkbox"
                                    name="isAllCheckedForSendNotificationToAllViaEmail"
                                    checked={isAllCheckedForSendNotificationToAllViaEmail ? true : false}
                                    onChange={(event) => isAllCheckedForSendNotificationToAllViaMobileClick(event.target.checked, "email")}
                                    disabled={(applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length === 0) ? true : false}
                                    ref={register({})}
                                  />
                                </th>
                                : ind === 5 ? <th key={ind} className='text-center theadBgColor'>{
                                  <button
                                    className="btn btn-sm btn-primary cursor-pointer me-n3"
                                    onClick={interviewPtLetterSendNotification}
                                    disabled={((applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length === 0) || (!(isAllCheckedForSendNotificationToAllViaMobile || isAllCheckedForSendNotificationToAllViaEmail || disableFlg))) ? true : false}
                                  >
                                    {applicationStagesLabels.SEND_ALL}
                                  </button>
                                }<span className="me-4">{itm}</span></th> : <th key={ind} className='text-center theadBgColor' >{itm}</th>}
                        </>
                        );
                      }
                      )}
                    </tr>
                  </thead>
                  <tbody className="f12">
                    {applicationListingArrForInterviewPtLetter && applicationListingArrForInterviewPtLetter.length > 0 ? (
                      applicationListingArrForInterviewPtLetter.map(
                        (ele, i) => {
                          if (ele) {
                            return (
                              <tr>
                                <td className="word-break text-center">
                                  {++i}
                                </td>
                                <td className="word-break text-left">
                                  {ele && ele.profileTransactionID
                                    ? ele.profileTransactionID
                                    : ""}
                                </td>
                                <td className="word-break text-left">
                                  {ele &&
                                    ele.candidateName
                                    ? ele.candidateName
                                    : ""}
                                </td>
                                <td className="word-break text-center">
                                  <input
                                    className="radio text-center mt-1 me-1"
                                    type="checkbox"
                                    name="isMobileNoCheckedFlg"
                                    checked={ele.isMobileNoCheckedFlg ? true : false}
                                    onChange={(event) => isAllCheckedForSendNotificationToAllViaMobileClick(event.target.checked, "singleMobileNoCheckedFlg", ele.applicationId)}
                                  />
                                </td>
                                <td className="word-break text-center">
                                  <input
                                    className="radio text-center mt-1 me-1"
                                    type="checkbox"
                                    name="isEmailCheckedFlg"
                                    checked={ele.isEmailCheckedFlg ? true : false}
                                    onChange={(event) => isAllCheckedForSendNotificationToAllViaMobileClick(event.target.checked, "singleEmailCheckedFlg", ele.applicationId)}
                                  />
                                </td>
                                <td className="text-center">
                                  <div className='position-relative'>
                                    <button
                                      className="btn btn-sm btn-primary cursor-pointer"
                                      onClick={() => { sendNotificationForInterviewPtLetter(ele, '') }}
                                      disabled={!(ele.isMobileNoCheckedFlg || ele.isEmailCheckedFlg)}
                                    >
                                      {applicationStagesLabels.SEND}
                                    </button>
                                  </div>
                                </td>

                              </tr>
                            );
                          }
                        }
                      )
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          {docLabels.NO_DATA}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {/* {getSearchAdmitCardListDetails &&
                    getSearchAdmitCardListDetails.candidateResponseDtos &&
                    getSearchAdmitCardListDetails.candidateResponseDtos.length >
                    0 && (
                      <TablePagination
                        paginationFor="admit_card_search_list"
                        rowPerPage={admitCardStageSearchRowPerPage}
                        totalCount={
                          getSearchAdmitCardListDetails &&
                          getSearchAdmitCardListDetails.count
                        }
                        advid={props.adverId}
                        searchCode2={admitCardSearchData}
                      />
                    )} */}
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "FINAL_RESULT" && (
        <div
          className="finalResultSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='text-center theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>

                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <th scope="col" className='theadBgColor'>{item.postCriteriaId}</th>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <th>{item.examSubjectId}</th>
                                    ) : (
                                      ""
                                    )}
                                    {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONTENT}</h5>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "RECOMMENDATION_LETTER" && (
        <div
          className="recommendationLetterSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='text-center theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>

                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td>{item.postCriteriaId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONTENT}</h5>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "NOT_RECOMMENDATION_LETTER" && (
        <div
          className="notRecommendationLetterSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='text-center theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break  text-center">
                                      {index + 1}
                                    </td>

                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td>{item.postCriteriaId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONTENT}</h5>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "RECHECK_ELIGIBILITY" && (
        <div
          className="recheckEligibilitySection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='text-center theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td>{item.postCriteriaId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                onChange={(e) => {
                                  onchangePostStartDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected={selectedPostEndDate}
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <div className="date-picker-container">
                              <DatePicker
                                selected=""
                                minDate={selectedPostStartDate}
                                onChange={(e) => {
                                  onchangePostEndDate(toUTCDate(e));
                                  onChange(toUTCDate(e));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                placeholderText={
                                  applicationStagesLabels.DatePlaceHolder
                                }
                                dateFormat={applicationStagesLabels.dateFormat}
                                className="form-control bg-color ps-2"
                                showIcon
                                icon={
                                  <img src="/icons/calender.png" className="date-picker-icon"></img>
                                }
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONTENT}</h5>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "PREF_OPT_OUT" && (
        <div
          className="preferenceChangeSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td>{item.postCriteriaId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <DatePicker
                              selected={selectedPostStartDate}
                              onChange={(e) => {
                                onchangePostStartDate(toUTCDate(e));
                                onChange(toUTCDate(e));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              placeholderText={
                                applicationStagesLabels.DatePlaceHolder
                              }
                              dateFormat={applicationStagesLabels.dateFormat}
                              className="form-control"
                            />
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <DatePicker
                              selected=""
                              onChange={(e) => {
                                onchangePostStartDate(toUTCDate(e));
                                onChange(toUTCDate(e));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              placeholderText={
                                applicationStagesLabels.DatePlaceHolder
                              }
                              dateFormat={applicationStagesLabels.dateFormat}
                              className="form-control"
                            />
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <DatePicker
                              selected={selectedPostEndDate}
                              minDate={selectedPostStartDate}
                              onChange={(e) => {
                                onchangePostEndDate(toUTCDate(e));
                                onChange(toUTCDate(e));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              placeholderText={
                                applicationStagesLabels.DatePlaceHolder
                              }
                              dateFormat={applicationStagesLabels.dateFormat}
                              className="form-control"
                            />
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <DatePicker
                              selected=""
                              minDate={selectedPostStartDate}
                              onChange={(e) => {
                                onchangePostEndDate(toUTCDate(e));
                                onChange(toUTCDate(e));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              placeholderText={
                                applicationStagesLabels.DatePlaceHolder
                              }
                              dateFormat={applicationStagesLabels.dateFormat}
                              className="form-control"
                            />
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>
                {applicationStagesLabels.UPLOAD_AND_DOWNLOAD_PREFERENCE_LIST}
              </h5>
              <div className="d-flex justify-content-center">
                <main
                  role="main"
                  className="col-sm-9 col-md-11 col-lg-12 "
                  id="main_block"
                >
                  <div className="pt-2 pb-2">
                    <div className="float-right pe-1">
                      <button type="button" className="btn btn-sm btn-primary">
                        {applicationStagesLabels.UPLOAD_LIST}
                      </button>{" "}
                      &nbsp;
                      <button type="button" className="btn btn-sm btn-primary">
                        {" "}
                        {applicationStagesLabels.DOWNLOAD_LIST}{" "}
                      </button>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode === "OPTING_OUT" && (
        <div
          className="preferenceChangeSection panel-collapse collapse"
          id={"stage_" + props.isPast + props.stageId}
        >
          <ul className="nav nav-tabs" id="configTab" role="tablist">
            {headerField &&
              headerField.map((ele, index) => (
                <li className="nav-item cursor-pointer" key={ele.id}>
                  <a
                    className={
                      stepName === ele.id
                        ? "nav-link active"
                        : "nav-link bg-profile-tabs"
                    }
                    value="home"
                    id={ele.code}
                    onClick={() => {
                      setName(ele.id);
                    }}
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                  >
                    <span>{ele.name}</span>
                  </a>
                </li>
              ))}
          </ul>
          <div
            className="tab-content border border-light"
            id="configTabContent"
          >
            <div
              className={
                stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>{applicationStagesLabels.CONFIGURATION}</h5>

              <div className="border border-light w-100 p-1">
                {allStageConfigList &&
                  allStageConfigList.advertisementStageDtoList &&
                  allStageConfigList.advertisementStageDtoList.length > 0 && (
                    <div className="stageConfigList">
                      <table className="table table-bordered">
                        {allStageConfigList &&
                          allStageConfigList.advertisementStageDtoList &&
                          allStageConfigList.advertisementStageDtoList.length >
                          0 &&
                          allStageConfigList.advertisementStageDtoList
                            .filter((item) => item.stage.id == props.stageId)
                            .map((item, index) => {
                              if (index == 0) {
                                return (
                                  <thead key={0}>
                                    {" "}
                                    <tr>
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.NO}
                                      </th>
                                      {item.postCriteriaId != "" &&
                                        item.postCriteriaId != null &&
                                        item.postCriteriaId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.PostName}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.examSubjectId != "" &&
                                        item.examSubjectId != null &&
                                        item.examSubjectId != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.EXAM_SUBJECT_NAME
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.startDate != "" &&
                                        item.startDate != null &&
                                        item.startDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.StartDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.endDate != "" &&
                                        item.endDate != null &&
                                        item.endDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.EndDate}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.onlinePaymentEndDate != "" &&
                                        item.onlinePaymentEndDate != null &&
                                        item.onlinePaymentEndDate != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {
                                            applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                          }
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      {item.type != "" &&
                                        item.type != null &&
                                        item.type != undefined ? (
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Type}
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th scope="col" className='theadBgColor'>
                                        {applicationStagesLabels.Action}
                                      </th>
                                    </tr>{" "}
                                  </thead>
                                );
                              }
                            })}

                        <tbody className="f12">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-10 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.startDate
                                        ? dayjs(
                                          getFormattedDate(
                                            new Date(item.startDate)
                                          )
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    <td className="word-break ">
                                      {item.endDate
                                        ? dayjs(
                                          getFormattedDate(new Date(item.endDate))
                                        ).format(
                                          applicationStagesLabels.DatePlaceHolder
                                        )
                                        : ""}
                                    </td>
                                    {item.postCriteriaId != "" &&
                                      item.postCriteriaId != null &&
                                      item.postCriteriaId != undefined ? (
                                      <td>{item.postCriteriaId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.examSubjectId != "" &&
                                      item.examSubjectId != null &&
                                      item.examSubjectId != undefined ? (
                                      <td>{item.examSubjectId}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.onlinePaymentEndDate != "" &&
                                      item.onlinePaymentEndDate != null &&
                                      item.onlinePaymentEndDate != undefined ? (
                                      <td>{item.onlinePaymentEndDate}</td>
                                    ) : (
                                      ""
                                    )}
                                    {item.type != "" &&
                                      item.type != null &&
                                      item.type != undefined ? (
                                      <td>{item.type}</td>
                                    ) : (
                                      ""
                                    )}
                                    <td className="w-10 word-break">
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_EDIT}
                                        className="text-primary fa fa-edit"
                                        onClick={() => {
                                          onEditStageConfig(item);
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={
                                          item.isActive
                                            ? commonLabels.BUTTON_INACTIVE
                                            : commonLabels.BUTTON_ACTIVE
                                        }
                                        className={
                                          item.isActive === true
                                            ? "text-success fa fa-toggle-on"
                                            : "text-danger fa fa-toggle-off"
                                        }
                                        onClick={(e) => {
                                          activeStageConfig(
                                            item,
                                            item.isActive
                                          );
                                        }}
                                      ></i>
                                      &nbsp;&nbsp;
                                      <i
                                        role="button"
                                        data-toggle="tooltip"
                                        title={commonLabels.BUTTON_DELETE}
                                        className="text-danger fa fa-trash"
                                        onClick={(e) => {
                                          manageStageConfigData(item);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="stageConfigAddForm">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.StartDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostStartDate ? (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue={selectedPostStartDate}
                          control={control}
                          render={({ onChange }) => (
                            <DatePicker
                              selected={selectedPostStartDate}
                              onChange={(e) => {
                                onchangePostStartDate(toUTCDate(e));
                                onChange(toUTCDate(e));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              placeholderText={
                                applicationStagesLabels.DatePlaceHolder
                              }
                              dateFormat={applicationStagesLabels.dateFormat}
                              className="form-control"
                            />
                          )}
                        />
                      ) : (
                        <Controller
                          name="postStartDate"
                          key="postStartDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <DatePicker
                              selected=""
                              onChange={(e) => {
                                onchangePostStartDate(toUTCDate(e));
                                onChange(toUTCDate(e));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              placeholderText={
                                applicationStagesLabels.DatePlaceHolder
                              }
                              dateFormat={applicationStagesLabels.dateFormat}
                              className="form-control"
                            />
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-2">
                      <label className="fw-bold">
                        {applicationStagesLabels.EndDate}{" "}
                        <span className="redColor">*</span>
                      </label>
                      {selectedPostEndDate ? (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue={selectedPostEndDate}
                          control={control}
                          render={({ onChange }) => (
                            <DatePicker
                              selected={selectedPostEndDate}
                              minDate={selectedPostStartDate}
                              onChange={(e) => {
                                onchangePostEndDate(toUTCDate(e));
                                onChange(toUTCDate(e));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              placeholderText={
                                applicationStagesLabels.DatePlaceHolder
                              }
                              dateFormat={applicationStagesLabels.dateFormat}
                              className="form-control"
                            />
                          )}
                        />
                      ) : (
                        <Controller
                          name="postEndDate"
                          key="postEndDate"
                          defaultValue=""
                          control={control}
                          render={({ onChange, value }) => (
                            <DatePicker
                              selected=""
                              minDate={selectedPostStartDate}
                              onChange={(e) => {
                                onchangePostEndDate(toUTCDate(e));
                                onChange(toUTCDate(e));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              placeholderText={
                                applicationStagesLabels.DatePlaceHolder
                              }
                              dateFormat={applicationStagesLabels.dateFormat}
                              className="form-control"
                            />
                          )}
                        />
                      )}
                    </div>
                    <div className="col-md-4 mt-4">
                      <label className="fw-bold">
                        {applicationStagesLabels.IsActive}{" "}
                      </label>
                      <input
                        className="float-start text-left mt-1 me-1"
                        type="checkbox"
                        name="isActive"
                        checked={isActive ? true : false}
                        onChange={(e) => setIsActive(e.target.checked)}
                        ref={register({})}
                      // defaultChecked={isActive?true:false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-3 mb-3">
                      <a
                        className="btn btn-sm btn-primary cursor-pointer"
                        onClick={() =>
                          saveStageConfigData(
                            props.stageId,
                            props.currentStageData
                          )
                        }
                      >
                        {applicationStagesLabels.Save}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
              }
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <h5>
                {applicationStagesLabels.UPLOAD_AND_DOWNLOAD_PREFERENCE_LIST}
              </h5>
              <div className="d-flex justify-content-center">
                <main
                  role="main"
                  className="col-sm-9 col-md-11 col-lg-12 "
                  id="main_block"
                >
                  <div className="pt-2 pb-2">
                    <div className="float-right pe-1">
                      <button type="button" className="btn btn-sm btn-primary">
                        {applicationStagesLabels.UPLOAD_LIST}
                      </button>{" "}
                      &nbsp;
                      <button type="button" className="btn btn-sm btn-primary">
                        {" "}
                        {applicationStagesLabels.DOWNLOAD_LIST}{" "}
                      </button>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      )}
      {props.stageCode != "FEE_RECEIPT" &&
        props.stageCode != "CENTRE_CHANGE" &&
        props.stageCode != "PREFERENCE_CHANGE" &&
        props.stageCode != "RE_UPLOAD_DOCUMENTS" &&
        props.stageCode != "ADMIT_CARDS" &&
        props.stageCode != "ANSWER_KEY_QUESTION_OBJECTION" &&
        props.stageCode != "OMR_DISPLAY" &&
        props.stageCode != "RESULT_MARK_SHEET" &&
        props.stageCode != "RETOTALING" &&
        props.stageCode != "RETOTALING_FEE" &&
        props.stageCode != "RETOTALING_RESULT" &&
        props.stageCode != "INTERVIEW_LETTER_PT_LETTER" &&
        props.stageCode != "FINAL_RESULT" &&
        props.stageCode != "RECOMMENDATION_LETTER" &&
        props.stageCode != "NOT_RECOMMENDATION_LETTER" &&
        props.stageCode != "RECHECK_ELIGIBILITY" && (
          <div
            className="otherSection panel-collapse collapse"
            id={"stage_" + props.isPast + props.stageId}
          >
            <ul className="nav nav-tabs" id="configTab" role="tablist">
              {headerField &&
                headerField.map((ele, index) => (
                  <li className="nav-item cursor-pointer" key={ele.id}>
                    <a
                      className={
                        stepName === ele.id
                          ? "nav-link active"
                          : "nav-link bg-profile-tabs"
                      }
                      value="home"
                      id={ele.code}
                      onClick={() => {
                        setName(ele.id);
                      }}
                      data-toggle="tab"
                      role="tab"
                      aria-controls="home"
                      aria-selected="false"
                    >
                      <span>{ele.name}</span>
                    </a>
                  </li>
                ))}
            </ul>
            <div
              className="tab-content border border-light"
              id="configTabContent"
            >
              <div
                className={
                  stepName === "1" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
                }
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <h5>{applicationStagesLabels.CONFIGURATION}</h5>

                <div className="border border-light w-100 p-1">
                  {allStageConfigList &&
                    allStageConfigList.advertisementStageDtoList &&
                    allStageConfigList.advertisementStageDtoList.length > 0 && (
                      <div className="stageConfigList">
                        <table className="table table-bordered">
                          {allStageConfigList &&
                            allStageConfigList.advertisementStageDtoList &&
                            allStageConfigList.advertisementStageDtoList
                              .length > 0 &&
                            allStageConfigList.advertisementStageDtoList
                              .filter((item) => item.stage.id == props.stageId)
                              .map((item, index) => {
                                if (index == 0) {
                                  return (
                                    <thead key={0}>
                                      {" "}
                                      <tr>
                                        <th scope="col" className='ext-center theadBgColor'>
                                          {applicationStagesLabels.NO}
                                        </th>
                                        {item.postCriteriaId != "" &&
                                          item.postCriteriaId != null &&
                                          item.postCriteriaId != undefined ? (
                                          <th scope="col" className='theadBgColor'>
                                            {applicationStagesLabels.PostName}
                                          </th>
                                        ) : (
                                          ""
                                        )}
                                        {item.examSubjectId != "" &&
                                          item.examSubjectId != null &&
                                          item.examSubjectId != undefined ? (
                                          <th scope="col" className='theadBgColor'>
                                            {
                                              applicationStagesLabels.EXAM_SUBJECT_NAME
                                            }
                                          </th>
                                        ) : (
                                          ""
                                        )}
                                        {item.startDate != "" &&
                                          item.startDate != null &&
                                          item.startDate != undefined ? (
                                          <th scope="col" className='theadBgColor'>
                                            {applicationStagesLabels.StartDate}
                                          </th>
                                        ) : (
                                          ""
                                        )}
                                        {item.endDate != "" &&
                                          item.endDate != null &&
                                          item.endDate != undefined ? (
                                          <th scope="col" className='theadBgColor'>
                                            {applicationStagesLabels.EndDate}
                                          </th>
                                        ) : (
                                          ""
                                        )}
                                        {item.onlinePaymentEndDate != "" &&
                                          item.onlinePaymentEndDate != null &&
                                          item.onlinePaymentEndDate !=
                                          undefined ? (
                                          <th scope="col" className='theadBgColor'>
                                            {
                                              applicationStagesLabels.ONLINE_PAYMENT_END_DATE
                                            }
                                          </th>
                                        ) : (
                                          ""
                                        )}
                                        {item.type != "" &&
                                          item.type != null &&
                                          item.type != undefined ? (
                                          <th scope="col" className='theadBgColor'>
                                            {applicationStagesLabels.Type}
                                          </th>
                                        ) : (
                                          ""
                                        )}
                                        <th scope="col" className='theadBgColor'>
                                          {applicationStagesLabels.Action}
                                        </th>
                                      </tr>{" "}
                                    </thead>
                                  );
                                }
                              })}

                          <tbody className="f12">
                            {allStageConfigList &&
                              allStageConfigList.advertisementStageDtoList &&
                              allStageConfigList.advertisementStageDtoList
                                .length > 0 &&
                              allStageConfigList.advertisementStageDtoList
                                .filter(
                                  (item) => item.stage.id == props.stageId
                                )
                                .map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className="w-10 word-break text-center">
                                        {index + 1}
                                      </td>

                                      <td className="word-break ">
                                        {item.startDate
                                          ? dayjs(
                                            getFormattedDate(
                                              new Date(item.startDate)
                                            )
                                          ).format(
                                            applicationStagesLabels.DatePlaceHolder
                                          )
                                          : ""}
                                      </td>
                                      <td className="word-break ">
                                        {item.endDate
                                          ? dayjs(
                                            getFormattedDate(
                                              new Date(item.endDate)
                                            )
                                          ).format(
                                            applicationStagesLabels.DatePlaceHolder
                                          )
                                          : ""}
                                      </td>
                                      <td className="w-10 word-break">
                                        <i
                                          role="button"
                                          data-toggle="tooltip"
                                          title={commonLabels.BUTTON_EDIT}
                                          className="text-primary fa fa-edit"
                                          onClick={() => {
                                            onEditStageConfig(item);
                                          }}
                                        ></i>
                                        &nbsp;&nbsp;
                                        <i
                                          role="button"
                                          data-toggle="tooltip"
                                          title={
                                            item.isActive
                                              ? commonLabels.BUTTON_INACTIVE
                                              : commonLabels.BUTTON_ACTIVE
                                          }
                                          className={
                                            item.isActive === true
                                              ? "text-success fa fa-toggle-on"
                                              : "text-danger fa fa-toggle-off"
                                          }
                                          onClick={(e) => {
                                            activeStageConfig(
                                              item,
                                              item.isActive
                                            );
                                          }}
                                        ></i>
                                        &nbsp;&nbsp;
                                        <i
                                          role="button"
                                          data-toggle="tooltip"
                                          title={commonLabels.BUTTON_DELETE}
                                          className="text-danger fa fa-trash"
                                          onClick={(e) => {
                                            manageStageConfigData(item);
                                          }}
                                        ></i>
                                      </td>
                                    </tr>
                                  );
                                })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  <div className="stageConfigAddForm">
                    <div className="row">
                      <div className="col-md-4 mt-2">
                        <label className="fw-bold">
                          {applicationStagesLabels.StartDate}{" "}
                          <span className="redColor">*</span>
                        </label>
                        {selectedPostStartDate ? (
                          <Controller
                            name="postStartDate"
                            key="postStartDate"
                            defaultValue={selectedPostStartDate}
                            control={control}
                            render={({ onChange }) => (
                              <div className="date-picker-container">
                                <DatePicker
                                  selected={selectedPostStartDate}
                                  onChange={(e) => {
                                    onchangePostStartDate(toUTCDate(e));
                                    onChange(toUTCDate(e));
                                  }}
                                  showMonthDropdown
                                  showYearDropdown
                                  placeholderText={
                                    applicationStagesLabels.DatePlaceHolder
                                  }
                                  dateFormat={applicationStagesLabels.dateFormat}
                                  className="form-control bg-color ps-2"
                                  showIcon
                                  icon={
                                    <img src="/icons/calender.png" className="date-picker-icon"></img>
                                  }
                                />
                              </div>
                            )}
                          />
                        ) : (
                          <Controller
                            name="postStartDate"
                            key="postStartDate"
                            defaultValue=""
                            control={control}
                            render={({ onChange, value }) => (
                              <div className="date-picker-container">
                                <DatePicker
                                  selected=""
                                  onChange={(e) => {
                                    onchangePostStartDate(toUTCDate(e));
                                    onChange(toUTCDate(e));
                                  }}
                                  showMonthDropdown
                                  showYearDropdown
                                  placeholderText={
                                    applicationStagesLabels.DatePlaceHolder
                                  }
                                  dateFormat={applicationStagesLabels.dateFormat}
                                  className="form-control bg-color ps-2"
                                  showIcon
                                  icon={
                                    <img src="/icons/calender.png" className="date-picker-icon"></img>
                                  }
                                />
                              </div>
                            )}
                          />
                        )}
                      </div>
                      <div className="col-md-4 mt-2">
                        <label className="fw-bold">
                          {applicationStagesLabels.EndDate}{" "}
                          <span className="redColor">*</span>
                        </label>
                        {selectedPostEndDate ? (
                          <Controller
                            name="postEndDate"
                            key="postEndDate"
                            defaultValue={selectedPostEndDate}
                            control={control}
                            render={({ onChange }) => (
                              <div className="date-picker-container">
                                <DatePicker
                                  selected={selectedPostEndDate}
                                  minDate={selectedPostStartDate}
                                  onChange={(e) => {
                                    onchangePostEndDate(toUTCDate(e));
                                    onChange(toUTCDate(e));
                                  }}
                                  showMonthDropdown
                                  showYearDropdown
                                  placeholderText={
                                    applicationStagesLabels.DatePlaceHolder
                                  }
                                  dateFormat={applicationStagesLabels.dateFormat}
                                  className="form-control bg-color ps-2"
                                  showIcon
                                  icon={
                                    <img src="/icons/calender.png" className="date-picker-icon"></img>
                                  }
                                />
                              </div>
                            )}
                          />
                        ) : (
                          <Controller
                            name="postEndDate"
                            key="postEndDate"
                            defaultValue=""
                            control={control}
                            render={({ onChange, value }) => (
                              <div className="date-picker-container">
                                <DatePicker
                                  selected=""
                                  minDate={selectedPostStartDate}
                                  onChange={(e) => {
                                    onchangePostEndDate(toUTCDate(e));
                                    onChange(toUTCDate(e));
                                  }}
                                  showMonthDropdown
                                  showYearDropdown
                                  placeholderText={
                                    applicationStagesLabels.DatePlaceHolder
                                  }
                                  dateFormat={applicationStagesLabels.dateFormat}
                                  className="form-control bg-color ps-2"
                                  showIcon
                                  icon={
                                    <img src="/icons/calender.png" className="date-picker-icon"></img>
                                  }
                                />
                              </div>
                            )}
                          />
                        )}
                      </div>
                      <div className="col-md-4 mt-4">
                        <label className="fw-bold">
                          {applicationStagesLabels.IsActive}{" "}
                        </label>
                        <input
                          className="float-start text-left mt-1 me-1"
                          type="checkbox"
                          name="isActive"
                          checked={isActive ? true : false}
                          onChange={(e) => setIsActive(e.target.checked)}
                          ref={register({})}
                        // defaultChecked={isActive?true:false}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4 mt-3 mb-3">
                        <a
                          className="btn btn-sm btn-primary cursor-pointer"
                          onClick={() =>
                            saveStageConfigData(
                              props.stageId,
                              props.currentStageData
                            )
                          }
                        >
                          {applicationStagesLabels.Save}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  stepName === "2" ? "tab-pane show active tabContentHeaderCss" : "tab-pane fade tabContentHeaderCss"
                }
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <h5>{applicationStagesLabels.CONTENT}</h5>
              </div>
            </div>
          </div>
        )}
      {showCenterWiseDeleteAdmitCardModal && (
        <ConfirmationDialog
          showModal={showCenterWiseDeleteAdmitCardModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowCenterWiseDeleteAdmitCardModal}
          deleteRecord={deleteCenterWiseAdmitCardData}
          deletedId={examCenter}
          IsConfirmation={"true"}
        />
      )}
      {sendNotificationToAllModal &&
        <SendNotificationModal
          showModal={sendNotificationToAllModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_SEND_NOTIFICATION_MESSAGE}
          setShowModal={setSendNotificationToAllModal}
          setSendNotificationToAllByTemplateId={setSendNotificationToAllByTemplateId}
          sendNotification={sendNotificationToAll}
          IsConfirmation={"true"}
        />
      }
      {sendNotificationToAllModalForInterviewPtLetter &&
        <SendNotificationModal
          showModal={sendNotificationToAllModalForInterviewPtLetter}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_SEND_NOTIFICATION_MESSAGE}
          setShowModal={setSendNotificationToAllModalForInterviewPtLetter}
          setSendNotificationToAllByTemplateId={setSendNotificationToAllByinterviewPtLetterType}
          sendNotification={sendNotificationToAllForInterviewPtLetter}
          IsConfirmation={"true"}
        />
      }
      {/* {viewAdmitCardModal && (
        <ViewAdmitCard
          viewAdmitCardModal={viewAdmitCardModal}
          setViewAdmitCardModal={setViewAdmitCardModal}
          admitCardViewData={admitCardViewData}
          handleDownloadAdmitCardClick={handleDownloadAdmitCardClick}
          viewAdmitCardpdfRef={viewAdmitCardpdfRef}
        />
      )} */}
      {showAdmitCardStageContentUpdateModal && (
        <UpdateTimeTableDetails
          advId={props.adverId}
          timeTableData={getUpdateTimeTableDataByTempId}
          timeTableDetails={getTimeTableDetails}
          showUpdateModal={showAdmitCardStageContentUpdateModal}
          setShowUpdateModal={setShowAdmitCardStageContentUpdateModal}
          templateId={templateIdForAdmitCard}
        />
      )}
      {showAdmitCardStageContentDeleteModal && (
        <ConfirmationDialog
          showModal={showAdmitCardStageContentDeleteModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowAdmitCardStageContentDeleteModal}
          deleteRecord={deleteTimeTableData}
          deletedId={deleteTimeTableDetail}
          IsConfirmation={"true"}
        />
      )}

      {openDonwloadInterviewLetterCsvModal && (
        <DownloadInterviewLetterModal
          advId={props.adverId ? props.adverId : ''}
          openDonwloadInterviewLetterCsvModal={openDonwloadInterviewLetterCsvModal}
          setOpenDonwloadInterviewLetterCsvModal={setOpenDonwloadInterviewLetterCsvModal}
          scheduleType={interviewPtLettertype ? interviewPtLettertype : ''}
          setInterviewPtLettertype={setInterviewPtLettertype}
          postid={interviewPtLetterPostId ? interviewPtLetterPostId : ''}
          setInterviewPtLetterPostId={setInterviewPtLetterPostId}
        />
      )}

      {
        openAttendanceMusterReportModal && (
          <AttendanceMusterReportModal
            openAttendanceMusterReportModal={openAttendanceMusterReportModal}
            setOpenAttendanceMusterReportModal={setOpenAttendanceMusterReportModal}
            advtId={props.adverId ? props.adverId : ''}
            interviewPtLetterReportPostId={interviewPtLetterReportPostId ? interviewPtLetterReportPostId : ''}
            setInterviewPtLetterReportPostId={setInterviewPtLetterReportPostId}
            interviewPtLetterReportName={interviewPtLetterReportName ? interviewPtLetterReportName : ''}
            setInterviewPtLetterReportName={setInterviewPtLetterReportName}
            reportType={reportType ? reportType : ''}
            setReportType={setReportType}
          />
        )
      }
    </>
  );
};

export default StageContent;
